import type { LucideIcon } from 'lucide-react';
import { TerminalIcon } from 'lucide-react';
import type React from 'react';
import type { JSX, SVGProps } from 'react';

export function create({ icon: Icon }: { icon?: LucideIcon }) {
  return (
    <div className="icons rounded-md border border-border p-1 shadow-sm">
      {Icon ? <Icon /> : <TerminalIcon />}
    </div>
  );
}

type IconProps = {
  size?: number | string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
};

export function MagicIcon({
  size = 24,
  color = 'currentColor',
  className,
  style,
}: IconProps): JSX.Element {
  return (
    <svg
      role="img"
      width={size}
      height={size}
      viewBox="0 0 14 18"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      className={className}
      style={style}
    >
      <path d="M7.73931 7.02622C7.86306 6.65497 8.38731 6.65497 8.51106 7.02622L9.23669 9.20535C9.39641 9.68438 9.66551 10.1196 10.0227 10.4766C10.3798 10.8335 10.8152 11.1024 11.2943 11.2619L13.4723 11.9875C13.8436 12.1112 13.8436 12.6355 13.4723 12.7592L11.2932 13.4849C10.8142 13.6446 10.3789 13.9137 10.022 14.2708C9.66501 14.628 9.39615 15.0634 9.23669 15.5425L8.51106 17.7205C8.48438 17.8018 8.43271 17.8726 8.36342 17.9228C8.29412 17.973 8.21075 18 8.12519 18C8.03963 18 7.95625 17.973 7.88696 17.9228C7.81766 17.8726 7.76599 17.8018 7.73931 17.7205L7.01368 15.5414C6.85407 15.0625 6.58515 14.6273 6.2282 14.2704C5.87125 13.9134 5.43608 13.6445 4.95717 13.4849L2.77804 12.7592C2.69674 12.7326 2.62595 12.6809 2.57576 12.6116C2.52558 12.5423 2.49855 12.4589 2.49855 12.3734C2.49855 12.2878 2.52558 12.2044 2.57576 12.1351C2.62595 12.0658 2.69674 12.0142 2.77804 11.9875L4.95717 11.2619C5.43608 11.1023 5.87125 10.8333 6.2282 10.4764C6.58515 10.1194 6.85407 9.68426 7.01368 9.20535L7.73931 7.02622ZM3.39342 1.28982C3.40955 1.2411 3.44062 1.19871 3.48223 1.16866C3.52383 1.13861 3.57385 1.12243 3.62517 1.12243C3.67649 1.12243 3.7265 1.13861 3.76811 1.16866C3.80971 1.19871 3.84079 1.2411 3.85692 1.28982L4.29229 2.59708C4.48692 3.17983 4.94367 3.63658 5.52643 3.83121L6.83368 4.26658C6.8824 4.28272 6.9248 4.31379 6.95484 4.35539C6.98489 4.397 7.00107 4.44701 7.00107 4.49833C7.00107 4.54965 6.98489 4.59967 6.95484 4.64127C6.9248 4.68288 6.8824 4.71395 6.83368 4.73008L5.52643 5.16546C5.23885 5.26091 4.97752 5.42218 4.76327 5.63643C4.54901 5.85069 4.38774 6.11201 4.29229 6.39959L3.85692 7.70685C3.84079 7.75557 3.80971 7.79796 3.76811 7.82801C3.7265 7.85806 3.67649 7.87423 3.62517 7.87423C3.57385 7.87423 3.52383 7.85806 3.48223 7.82801C3.44062 7.79796 3.40955 7.75557 3.39342 7.70685L2.95804 6.39959C2.8626 6.11201 2.70132 5.85069 2.48707 5.63643C2.27281 5.42218 2.01149 5.26091 1.72391 5.16546L0.416654 4.73008C0.367935 4.71395 0.325539 4.68288 0.29549 4.64127C0.265441 4.59967 0.249268 4.54965 0.249268 4.49833C0.249268 4.44701 0.265441 4.397 0.29549 4.35539C0.325539 4.31379 0.367935 4.28272 0.416654 4.26658L1.72391 3.83121C2.01149 3.73576 2.27281 3.57449 2.48707 3.36024C2.70132 3.14598 2.8626 2.88466 2.95804 2.59708L3.39342 1.28982ZM11.3461 0.109691C11.3572 0.0776579 11.378 0.0498811 11.4056 0.0302224C11.4332 0.0105637 11.4663 0 11.5002 0C11.5341 0 11.5672 0.0105637 11.5948 0.0302224C11.6224 0.0498811 11.6432 0.0776579 11.6543 0.109691L11.9446 0.980445C12.074 1.3697 12.3788 1.67457 12.7681 1.80395L13.6388 2.0942C13.6709 2.1053 13.6986 2.12612 13.7183 2.15374C13.738 2.18136 13.7485 2.21442 13.7485 2.24832C13.7485 2.28223 13.738 2.31529 13.7183 2.34291C13.6986 2.37053 13.6709 2.39134 13.6388 2.40245L12.7681 2.6927C12.5764 2.75683 12.4023 2.86459 12.2594 3.0075C12.1165 3.1504 12.0087 3.32455 11.9446 3.51621L11.6543 4.38696C11.6432 4.41899 11.6224 4.44677 11.5948 4.46643C11.5672 4.48609 11.5341 4.49665 11.5002 4.49665C11.4663 4.49665 11.4332 4.48609 11.4056 4.46643C11.378 4.44677 11.3572 4.41899 11.3461 4.38696L11.0558 3.51621C10.9917 3.32455 10.8839 3.1504 10.741 3.0075C10.5981 2.86459 10.424 2.75683 10.2323 2.6927L9.36269 2.40245C9.33066 2.39134 9.30288 2.37053 9.28322 2.34291C9.26356 2.31529 9.253 2.28223 9.253 2.24832C9.253 2.21442 9.26356 2.18136 9.28322 2.15374C9.30288 2.12612 9.33066 2.1053 9.36269 2.0942L10.2334 1.80395C10.6227 1.67457 10.9276 1.3697 11.0569 0.980445L11.3461 0.109691Z" />
    </svg>
  );
}

export function ClaudeIcon({
  size = 24,
  color = 'currentColor',
  className,
  style,
}: IconProps): JSX.Element {
  return (
    <svg
      role="img"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      className={className}
      style={style}
    >
      <path d="m4.7144 15.9555 4.7174-2.6471.079-.2307-.079-.1275h-.2307l-.7893-.0486-2.6956-.0729-2.3375-.0971-2.2646-.1214-.5707-.1215-.5343-.7042.0546-.3522.4797-.3218.686.0608 1.5179.1032 2.2767.1578 1.6514.0972 2.4468.255h.3886l.0546-.1579-.1336-.0971-.1032-.0972L6.973 9.8356l-2.55-1.6879-1.3356-.9714-.7225-.4918-.3643-.4614-.1578-1.0078.6557-.7225.8803.0607.2246.0607.8925.686 1.9064 1.4754 2.4893 1.8336.3643.3035.1457-.1032.0182-.0728-.164-.2733-1.3539-2.4467-1.445-2.4893-.6435-1.032-.17-.6194c-.0607-.255-.1032-.4674-.1032-.7285L6.287.1335 6.6997 0l.9957.1336.419.3642.6192 1.4147 1.0018 2.2282 1.5543 3.0296.4553.8985.2429.8318.091.255h.1579v-.1457l.1275-1.706.2368-2.0947.2307-2.6957.0789-.7589.3764-.9107.7468-.4918.5828.2793.4797.686-.0668.4433-.2853 1.8517-.5586 2.9021-.3643 1.9429h.2125l.2429-.2429.9835-1.3053 1.6514-2.0643.7286-.8196.85-.9046.5464-.4311h1.0321l.759 1.1293-.34 1.1657-1.0625 1.3478-.8804 1.1414-1.2628 1.7-.7893 1.36.0729.1093.1882-.0183 2.8535-.607 1.5421-.2794 1.8396-.3157.8318.3886.091.3946-.3278.8075-1.967.4857-2.3072.4614-3.4364.8136-.0425.0304.0486.0607 1.5482.1457.6618.0364h1.621l3.0175.2247.7892.522.4736.6376-.079.4857-1.2142.6193-1.6393-.3886-3.825-.9107-1.3113-.3279h-.1822v.1093l1.0929 1.0686 2.0035 1.8092 2.5075 2.3314.1275.5768-.3218.4554-.34-.0486-2.2039-1.6575-.85-.7468-1.9246-1.621h-.1275v.17l.4432.6496 2.3436 3.5214.1214 1.0807-.17.3521-.6071.2125-.6679-.1214-1.3721-1.9246L14.38 17.959l-1.1414-1.9428-.1397.079-.674 7.2552-.3156.3703-.7286.2793-.6071-.4614-.3218-.7468.3218-1.4753.3886-1.9246.3157-1.53.2853-1.9004.17-.6314-.0121-.0425-.1397.0182-1.4328 1.9672-2.1796 2.9446-1.7243 1.8456-.4128.164-.7164-.3704.0667-.6618.4008-.5889 2.386-3.0357 1.4389-1.882.929-1.0868-.0062-.1579h-.0546l-6.3385 4.1164-1.1293.1457-.4857-.4554.0608-.7467.2307-.2429 1.9064-1.3114Z" />
    </svg>
  );
}

export function OpenAIIcon({
  size = 24,
  color = 'currentColor',
  className,
  style,
}: IconProps): JSX.Element {
  return (
    <svg
      role="img"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      className={className}
      style={style}
    >
      <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" />
    </svg>
  );
}

export function StacksIcon({
  size = 24,
  color = 'currentColor',
  className,
  style,
}: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <svg
        width="11"
        height="12"
        viewBox="0 0 11 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4731 4.34457C10.4676 4.34254 10.4617 4.34142 10.4556 4.34142H7.66498C7.56531 4.34142 7.47632 4.28892 7.42981 4.2017C7.38333 4.11455 7.38871 4.01181 7.44355 3.92737C7.44361 3.92727 7.44368 3.92717 7.44375 3.92706L9.26679 1.2179L9.26691 1.21772C9.30487 1.16078 9.308 1.09041 9.27647 1.03052C9.24449 0.969753 9.18331 0.934558 9.11682 0.934558H8.40359C8.34467 0.934558 8.28646 0.962411 8.2532 1.01499L6.11856 4.18809L6.11845 4.18827C6.05401 4.28493 5.94741 4.34142 5.82998 4.34142H5.56454C5.44711 4.34142 5.34051 4.28493 5.27607 4.18827L5.27598 4.18812L3.14595 1.01731C3.1127 0.964726 3.05448 0.936866 2.99554 0.936866H2.28232C2.21517 0.936866 2.15203 0.974946 2.12036 1.03513L2.1646 1.05842L2.12036 1.03513C2.08824 1.09616 2.09509 1.1662 2.12955 1.21946L2.12954 1.21946L2.13004 1.22021L3.9535 3.93L3.9535 3.93001L3.95384 3.9305C4.00968 4.01138 4.01401 4.11361 3.96702 4.2017L3.96681 4.20211C3.92013 4.29158 3.83346 4.34373 3.73185 4.34373H0.943578C0.841532 4.34373 0.762012 4.4267 0.762012 4.5253V5.11619C0.762012 5.21823 0.844983 5.29775 0.943578 5.29775H10.4556C10.5576 5.29775 10.6371 5.21478 10.6371 5.11619V4.5253C10.6371 4.42935 10.5638 4.35332 10.4731 4.34457Z"
          style={{
            fill: 'currentColor',
            stroke: 'currentColor',
            fillOpacity: 1,
            strokeOpacity: 1,
            strokeWidth: '0.1',
            strokeLinejoin: 'round',
          }}
        />
        <path
          d="M2.13004 10.8872L2.12992 10.8873C2.09196 10.9443 2.08883 11.0147 2.12036 11.0745C2.15234 11.1353 2.21352 11.1705 2.28001 11.1705H2.99324C3.05216 11.1705 3.11038 11.1427 3.14363 11.0901L5.27827 7.91697L5.27838 7.9168C5.34282 7.82014 5.44942 7.76364 5.56685 7.76364H5.83229C5.94972 7.76364 6.05632 7.82014 6.12076 7.9168L6.12086 7.91695L8.25361 11.0907L8.25391 11.0911C8.28845 11.1414 8.34297 11.1705 8.40359 11.1705H9.11682C9.18396 11.1705 9.24711 11.1324 9.27878 11.0722C9.3109 11.0112 9.30405 10.9412 9.26959 10.8879L9.2696 10.8879L9.2691 10.8872L7.44564 8.17737L7.4453 8.17687C7.38946 8.096 7.38513 7.99377 7.43212 7.90567L7.43233 7.90527C7.47901 7.8158 7.56568 7.76364 7.66729 7.76364H10.4556C10.5576 7.76364 10.6371 7.68067 10.6371 7.58208V6.99118C10.6371 6.88914 10.5542 6.80962 10.4556 6.80962C10.4503 6.80962 10.4453 6.81043 10.4405 6.81193H0.943578C0.841532 6.81193 0.762012 6.8949 0.762012 6.99349V7.58439C0.762012 7.68643 0.844983 7.76595 0.943578 7.76595H3.73185C3.83152 7.76595 3.92051 7.81846 3.96702 7.90567C4.01364 7.99308 4.00792 8.0957 3.95342 8.17749C3.95341 8.17751 3.95339 8.17753 3.95338 8.17755L2.13004 10.8872Z"
          style={{
            fill: 'currentColor',
            stroke: 'currentColor',
            fillOpacity: 1,
            strokeOpacity: 1,
            strokeWidth: '0.1',
            strokeLinejoin: 'round',
          }}
        />
      </svg>
    </svg>
  );
}

export function Bitcoin(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
    >
      <path
        d="M1.19348 3.46362L8.58334 3.46362C9.10426 3.46362 9.60385 3.67056 9.97219 4.0389C10.3405 4.40725 10.5475 4.90684 10.5475 5.42776V5.53032C10.5475 6.05124 10.3405 6.55083 9.97219 6.91917C9.60385 7.28752 9.10426 7.49446 8.58334 7.49446L1.19348 7.49446L1.19348 3.46362Z"
        stroke="currentColor"
        style={{ stroke: 'currentColor', strokeOpacity: 1 }}
        strokeMiterlimit="10"
      />
      <path
        d="M1.19287 7.49463L9.02376 7.49463C9.28843 7.49463 9.55051 7.54676 9.79503 7.64804C10.0396 7.74933 10.2617 7.89778 10.4489 8.08493C10.636 8.27208 10.7845 8.49426 10.8858 8.73878C10.987 8.9833 11.0392 9.24538 11.0392 9.51004V9.51004C11.0392 10.0446 10.8268 10.5572 10.4489 10.9352C10.0709 11.3131 9.55828 11.5255 9.02376 11.5255H1.19287L1.19287 7.49463Z"
        stroke="currentColor"
        style={{ stroke: 'currentColor', strokeOpacity: 1 }}
        strokeMiterlimit="10"
      />
      <path
        d="M3.92407 0.489502V3.13593"
        stroke="currentColor"
        style={{ stroke: 'currentColor', strokeOpacity: 1 }}
        strokeMiterlimit="10"
      />
      <path
        d="M7.10791 0.489502V3.13593"
        stroke="currentColor"
        style={{ stroke: 'currentColor', strokeOpacity: 1 }}
        strokeMiterlimit="10"
      />
      <path
        d="M3.92407 11.8186V14.487"
        stroke="currentColor"
        style={{ stroke: 'currentColor', strokeOpacity: 1 }}
        strokeMiterlimit="10"
      />
      <path
        d="M7.10864 11.8186V14.487"
        stroke="currentColor"
        style={{ stroke: 'currentColor', strokeOpacity: 1 }}
        strokeMiterlimit="10"
      />
    </svg>
  );
}

export function Pulse(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M17.4136 3.45947L3.66357 3.45947C3.33205 3.45947 3.01411 3.59117 2.77969 3.82559C2.54527 4.06001 2.41357 4.37795 2.41357 4.70947L2.41357 15.9595C2.41357 16.291 2.54527 16.6089 2.77969 16.8434C3.01411 17.0778 3.33205 17.2095 3.66357 17.2095H17.4136C17.7451 17.2095 18.063 17.0778 18.2975 16.8434C18.5319 16.6089 18.6636 16.291 18.6636 15.9595V4.70947C18.6636 4.37795 18.5319 4.06001 18.2975 3.82559C18.063 3.59117 17.7451 3.45947 17.4136 3.45947ZM16.7886 10.9595H15.2761L12.9604 15.022C12.9054 15.1172 12.8263 15.1963 12.7309 15.2512C12.6356 15.306 12.5275 15.3348 12.4175 15.3345H12.3815C12.2655 15.3277 12.1537 15.2888 12.0586 15.222C11.9635 15.1552 11.889 15.0632 11.8433 14.9563L8.58545 7.35947L6.71045 10.647C6.65512 10.7428 6.57534 10.8222 6.47926 10.8771C6.38317 10.9321 6.27423 10.9605 6.16357 10.9595H4.28857C4.12281 10.9595 3.96384 10.8936 3.84663 10.7764C3.72942 10.6592 3.66357 10.5002 3.66357 10.3345C3.66357 10.1687 3.72942 10.0097 3.84663 9.89253C3.96384 9.77532 4.12281 9.70947 4.28857 9.70947H5.80107L8.12061 5.64697C8.17829 5.54603 8.26298 5.46318 8.36516 5.40773C8.46734 5.35228 8.58297 5.32643 8.69903 5.33309C8.8151 5.33975 8.92701 5.37864 9.02219 5.44541C9.11736 5.51217 9.19203 5.60416 9.23779 5.71104L12.4917 13.3095L14.3667 10.0243C14.4217 9.92905 14.5009 9.84999 14.5962 9.79512C14.6915 9.74025 14.7997 9.71152 14.9097 9.71182H16.7847C16.9504 9.71182 17.1094 9.77766 17.2266 9.89487C17.3438 10.0121 17.4097 10.1711 17.4097 10.3368C17.4097 10.5026 17.3438 10.6615 17.2266 10.7788C17.1094 10.896 16.9504 10.9618 16.7847 10.9618L16.7886 10.9595Z"
        fill="var(--icon)"
      />
    </svg>
  );
}

export function Newspaper(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M17.4136 4.08447L4.91357 4.08447C4.58205 4.08447 4.26411 4.21617 4.02969 4.45059C3.79527 4.68501 3.66357 5.00295 3.66357 5.33447L3.66357 14.7095C3.66357 14.8752 3.59773 15.0342 3.48052 15.1514C3.36331 15.2686 3.20433 15.3345 3.03857 15.3345C2.87281 15.3345 2.71384 15.2686 2.59663 15.1514C2.47942 15.0342 2.41357 14.8752 2.41357 14.7095L2.41357 7.20947C2.41357 7.04371 2.34773 6.88474 2.23052 6.76753C2.11331 6.65032 1.95433 6.58447 1.78857 6.58447C1.62281 6.58447 1.46384 6.65032 1.34663 6.76753C1.22942 6.88474 1.16357 7.04371 1.16357 7.20947L1.16357 14.7181C1.16585 15.2139 1.36439 15.6886 1.71578 16.0383C2.06716 16.3881 2.54278 16.5845 3.03857 16.5845H16.7886C17.2859 16.5845 17.7628 16.3869 18.1144 16.0353C18.466 15.6837 18.6636 15.2068 18.6636 14.7095V5.33447C18.6636 5.00295 18.5319 4.68501 18.2975 4.45059C18.063 4.21617 17.7451 4.08447 17.4136 4.08447ZM14.2886 12.2095H8.03857C7.87281 12.2095 7.71384 12.1436 7.59663 12.0264C7.47942 11.9092 7.41357 11.7502 7.41357 11.5845C7.41357 11.4187 7.47942 11.2597 7.59663 11.1425C7.71384 11.0253 7.87281 10.9595 8.03857 10.9595H14.2886C14.4543 10.9595 14.6133 11.0253 14.7305 11.1425C14.8477 11.2597 14.9136 11.4187 14.9136 11.5845C14.9136 11.7502 14.8477 11.9092 14.7305 12.0264C14.6133 12.1436 14.4543 12.2095 14.2886 12.2095ZM14.2886 9.70947H8.03857C7.87281 9.70947 7.71384 9.64362 7.59663 9.52641C7.47942 9.4092 7.41357 9.25023 7.41357 9.08447C7.41357 8.91871 7.47942 8.75974 7.59663 8.64253C7.71384 8.52532 7.87281 8.45947 8.03857 8.45947H14.2886C14.4543 8.45947 14.6133 8.52532 14.7305 8.64253C14.8477 8.75974 14.9136 8.91871 14.9136 9.08447C14.9136 9.25023 14.8477 9.4092 14.7305 9.52641C14.6133 9.64362 14.4543 9.70947 14.2886 9.70947Z"
        fill="var(--icon)"
      />
    </svg>
  );
}

export function QuestionIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M10.5386 2.20947C8.93167 2.20947 7.36078 2.686 6.02463 3.57878C4.68848 4.47157 3.64708 5.74052 3.03212 7.22517C2.41716 8.70982 2.25625 10.3435 2.56976 11.9196C2.88326 13.4957 3.65709 14.9434 4.7934 16.0797C5.9297 17.216 7.37743 17.9898 8.95353 18.3034C10.5296 18.6169 12.1633 18.456 13.6479 17.841C15.1326 17.226 16.4015 16.1846 17.2943 14.8485C18.1871 13.5123 18.6636 11.9414 18.6636 10.3345C18.6614 8.18029 17.8046 6.11498 16.2814 4.59174C14.7581 3.0685 12.6928 2.21175 10.5386 2.20947ZM10.5386 15.3345C10.3532 15.3345 10.172 15.2795 10.0178 15.1765C9.86362 15.0735 9.74346 14.927 9.6725 14.7557C9.60154 14.5844 9.58298 14.3959 9.61915 14.2141C9.65533 14.0322 9.74461 13.8652 9.87573 13.7341C10.0068 13.6029 10.1739 13.5137 10.3557 13.4775C10.5376 13.4413 10.7261 13.4599 10.8974 13.5308C11.0687 13.6018 11.2151 13.722 11.3181 13.8761C11.4212 14.0303 11.4761 14.2116 11.4761 14.397C11.4761 14.6456 11.3774 14.8841 11.2016 15.0599C11.0257 15.2357 10.7873 15.3345 10.5386 15.3345ZM11.1636 11.5282V11.5845C11.1636 11.7502 11.0978 11.9092 10.9806 12.0264C10.8634 12.1436 10.7044 12.2095 10.5386 12.2095C10.3729 12.2095 10.2139 12.1436 10.0967 12.0264C9.97949 11.9092 9.91364 11.7502 9.91364 11.5845V10.9595C9.91364 10.7937 9.97949 10.6347 10.0967 10.5175C10.2139 10.4003 10.3729 10.3345 10.5386 10.3345C11.5722 10.3345 12.4136 9.63135 12.4136 8.77197C12.4136 7.9126 11.5722 7.20947 10.5386 7.20947C9.50504 7.20947 8.66364 7.9126 8.66364 8.77197V9.08447C8.66364 9.25023 8.59779 9.4092 8.48058 9.52641C8.36337 9.64362 8.2044 9.70947 8.03864 9.70947C7.87288 9.70947 7.71391 9.64362 7.5967 9.52641C7.47949 9.4092 7.41364 9.25023 7.41364 9.08447V8.77197C7.41364 7.22119 8.8152 5.95947 10.5386 5.95947C12.2621 5.95947 13.6636 7.22119 13.6636 8.77197C13.6636 10.1298 12.5886 11.2665 11.1636 11.5282Z"
        fill="var(--icon)"
      />
    </svg>
  );
}

export function Bug(props: any) {
  return (
    <svg
      {...props}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6636 7.52197C13.6636 7.70739 13.6087 7.88864 13.5056 8.04282C13.4026 8.19699 13.2562 8.31715 13.0849 8.38811C12.9136 8.45906 12.7251 8.47763 12.5432 8.44146C12.3614 8.40528 12.1943 8.31599 12.0632 8.18488C11.9321 8.05377 11.8428 7.88672 11.8066 7.70487C11.7705 7.52301 11.789 7.33451 11.86 7.1632C11.931 6.9919 12.0511 6.84548 12.2053 6.74247C12.3595 6.63945 12.5407 6.58447 12.7261 6.58447C12.9748 6.58447 13.2132 6.68324 13.389 6.85906C13.5649 7.03487 13.6636 7.27333 13.6636 7.52197ZM8.35114 6.58447C8.16572 6.58447 7.98446 6.63945 7.83029 6.74247C7.67612 6.84548 7.55596 6.9919 7.485 7.1632C7.41404 7.33451 7.39548 7.52301 7.43165 7.70487C7.46782 7.88672 7.55711 8.05377 7.68822 8.18488C7.81933 8.31599 7.98638 8.40528 8.16824 8.44146C8.3501 8.47763 8.5386 8.45906 8.7099 8.38811C8.88121 8.31715 9.02762 8.19699 9.13064 8.04282C9.23365 7.88864 9.28864 7.70739 9.28864 7.52197C9.28864 7.27333 9.18986 7.03487 9.01405 6.85906C8.83823 6.68324 8.59978 6.58447 8.35114 6.58447ZM17.4136 11.5845C17.4154 12.1912 17.3365 12.7954 17.1793 13.3813L18.9168 14.1407C19.0462 14.1997 19.1516 14.301 19.2157 14.428C19.2798 14.555 19.2986 14.7 19.2691 14.8391C19.2396 14.9783 19.1635 15.1032 19.0534 15.1932C18.9434 15.2833 18.8059 15.3331 18.6636 15.3345C18.5776 15.3347 18.4924 15.3168 18.4136 15.2821L16.7402 14.5532C16.1803 15.7232 15.301 16.7109 14.2036 17.4024C13.1062 18.0938 11.8357 18.4607 10.5386 18.4607C9.24161 18.4607 7.97104 18.0938 6.87368 17.4024C5.77631 16.7109 4.89692 15.7232 4.33707 14.5532L2.66364 15.2821C2.58487 15.3168 2.49971 15.3347 2.41364 15.3345C2.27012 15.3344 2.131 15.2849 2.01966 15.1943C1.90831 15.1038 1.83153 14.9777 1.8022 14.8372C1.77288 14.6967 1.79279 14.5504 1.85861 14.4228C1.92443 14.2953 2.03214 14.1943 2.16364 14.1368L3.89801 13.3813C3.74073 12.7954 3.66192 12.1912 3.66364 11.5845V10.9595H1.78864C1.62287 10.9595 1.4639 10.8936 1.34669 10.7764C1.22948 10.6592 1.16364 10.5002 1.16364 10.3345C1.16364 10.1687 1.22948 10.0097 1.34669 9.89253C1.4639 9.77532 1.62287 9.70947 1.78864 9.70947H3.66364V9.08447C3.66192 8.47778 3.74073 7.87354 3.89801 7.28759L2.16364 6.53213C2.08664 6.50051 2.01673 6.45384 1.95801 6.39484C1.8993 6.33584 1.85296 6.26571 1.82171 6.18856C1.79047 6.11142 1.77495 6.0288 1.77606 5.94557C1.77718 5.86235 1.79491 5.78018 1.82821 5.7039C1.86152 5.62761 1.90972 5.55875 1.97 5.50135C2.03027 5.44395 2.10141 5.39917 2.17923 5.36963C2.25705 5.34009 2.33998 5.3264 2.42317 5.32935C2.50635 5.3323 2.5881 5.35184 2.66364 5.38681L4.33707 6.11572C4.89692 4.94574 5.77631 3.958 6.87368 3.26658C7.97104 2.57515 9.24161 2.20825 10.5386 2.20825C11.8357 2.20825 13.1062 2.57515 14.2036 3.26658C15.301 3.958 16.1803 4.94574 16.7402 6.11572L18.4136 5.38447C18.5648 5.32242 18.7342 5.32202 18.8856 5.38334C19.037 5.44467 19.1584 5.56285 19.2238 5.71258C19.2892 5.86231 19.2933 6.03168 19.2353 6.18442C19.1774 6.33716 19.0619 6.46113 18.9136 6.52978L17.1793 7.2915C17.3365 7.87745 17.4154 8.48169 17.4136 9.08838V9.71338H19.2886C19.4544 9.71338 19.6134 9.77922 19.7306 9.89643C19.8478 10.0136 19.9136 10.1726 19.9136 10.3384C19.9136 10.5041 19.8478 10.6631 19.7306 10.7803C19.6134 10.8975 19.4544 10.9634 19.2886 10.9634H17.4136V11.5845ZM11.1636 11.5845C11.1636 11.4187 11.0978 11.2597 10.9806 11.1425C10.8634 11.0253 10.7044 10.9595 10.5386 10.9595C10.3729 10.9595 10.2139 11.0253 10.0967 11.1425C9.97948 11.2597 9.91364 11.4187 9.91364 11.5845V16.5845C9.91364 16.7502 9.97948 16.9092 10.0967 17.0264C10.2139 17.1436 10.3729 17.2095 10.5386 17.2095C10.7044 17.2095 10.8634 17.1436 10.9806 17.0264C11.0978 16.9092 11.1636 16.7502 11.1636 16.5845V11.5845ZM16.1636 9.08447C16.1636 7.59263 15.571 6.16189 14.5161 5.10699C13.4612 4.0521 12.0305 3.45947 10.5386 3.45947C9.04679 3.45947 7.61605 4.0521 6.56116 5.10699C5.50627 6.16189 4.91364 7.59263 4.91364 9.08447V9.70947H16.1636V9.08447Z"
        fill="var(--icon)"
      />
    </svg>
  );
}

export function DocsLogo(props: any) {
  return (
    <svg
      {...props}
      width="110"
      height="13"
      viewBox="0 0 110 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M55.9891 6.45337C56.5829 6.45337 57.0409 6.0462 57.0409 5.43546C57.0409 4.82471 56.5829 4.40058 55.9891 4.40058C55.3953 4.40058 54.9542 4.82471 54.9542 5.43546C54.9542 6.0462 55.3953 6.45337 55.9891 6.45337ZM55.9891 12.8153C56.5829 12.8153 57.0409 12.4081 57.0409 11.7974C57.0409 11.1867 56.5829 10.7625 55.9891 10.7625C55.3953 10.7625 54.9542 11.1867 54.9542 11.7974C54.9542 12.4081 55.3953 12.8153 55.9891 12.8153Z"
        fill="var(--icon)"
      />
      <path
        d="M71.5979 12.7135C75.1266 12.7135 77.0267 10.3214 77.0267 6.7757C77.0267 3.21302 75.1266 0.837891 71.5979 0.837891H67.8995V12.7135H71.5979ZM69.3754 2.19511H71.5979C74.2953 2.19511 75.5168 3.99341 75.5168 6.7757C75.5168 9.54103 74.2953 11.3563 71.5979 11.3563H69.3754V2.19511Z"
        fill="var(--icon)"
      />
      <path
        d="M84.3031 12.8153C86.8309 12.8153 88.5952 11.017 88.5952 8.3874C88.5952 5.75779 86.8309 3.95948 84.3031 3.95948C81.7752 3.95948 80.0109 5.75779 80.0109 8.3874C80.0109 11.017 81.7752 12.8153 84.3031 12.8153ZM84.3031 11.5768C82.5896 11.5768 81.4359 10.2366 81.4359 8.3874C81.4359 6.53819 82.5896 5.19794 84.3031 5.19794C86.0165 5.19794 87.1702 6.53819 87.1702 8.3874C87.1702 10.2366 86.0165 11.5768 84.3031 11.5768Z"
        fill="var(--icon)"
      />
      <path
        d="M95.7767 12.8153C97.8804 12.8153 99.2885 11.6277 99.6278 9.76158H98.1518C97.8804 10.8643 97.0321 11.5768 95.7937 11.5768C94.1311 11.5768 93.0114 10.2875 93.0114 8.40436C93.0114 6.52123 94.1311 5.19794 95.7937 5.19794C97.066 5.19794 97.9143 5.89352 98.1688 7.04715H99.6278C99.2715 5.14705 97.9313 3.95948 95.8106 3.95948C93.2998 3.95948 91.5863 5.75779 91.5863 8.40436C91.5863 11.1018 93.2489 12.8153 95.7767 12.8153Z"
        fill="var(--icon)"
      />
      <path
        d="M106.214 12.8153C108.131 12.8153 109.674 11.8144 109.674 10.2027C109.674 8.28561 108.097 7.91237 106.129 7.67486C104.873 7.52217 103.957 7.40342 103.957 6.45337C103.957 5.656 104.772 5.14705 105.976 5.14705C107.164 5.14705 107.978 5.80869 108.08 6.69088H109.505C109.369 4.89257 107.944 3.95948 105.976 3.95948C104.025 3.95948 102.583 4.9774 102.583 6.55516C102.583 8.35347 104.127 8.74367 106.061 8.98118C107.35 9.13386 108.3 9.21869 108.3 10.3045C108.3 11.1018 107.435 11.6277 106.214 11.6277C104.772 11.6277 103.872 10.8813 103.822 9.86337H102.396C102.43 11.7635 103.974 12.8153 106.214 12.8153Z"
        fill="var(--icon)"
      />
      <path
        d="M24.5714 11.4422V12.7165H17.9286V11.4422H20.5448V5.32592H17.9286V4.05163H21.9383V11.4422H24.5714ZM20.1882 1.46925C20.1882 0.874367 20.664 0.415527 21.2589 0.415527C21.8537 0.415527 22.3126 0.874367 22.3126 1.46925C22.3126 2.09794 21.8537 2.53988 21.2589 2.53988C20.664 2.53988 20.1882 2.09794 20.1882 1.46925Z"
        fill="var(--icon)"
      />
      <path
        d="M34.2302 4.05176V5.41057H33.1088C31.0867 5.41057 30.4926 6.95694 30.4926 8.33265V11.4415H33.4147V12.7158H27.1624V11.4415H29.0992V5.32604H27.1624V4.05176H30.4242L30.4749 5.5128C30.8653 4.8334 31.647 4.05176 33.2956 4.05176H34.2302Z"
        fill="var(--icon)"
      />
      <path
        d="M36.3799 8.38386C36.3799 5.75077 38.1468 3.94922 40.6785 3.94922C43.2102 3.94922 44.9771 5.74996 44.9771 8.38386C44.9771 11.0178 43.2102 12.8185 40.6785 12.8185C38.1468 12.8185 36.3799 11.0178 36.3799 8.38386ZM43.5499 8.38386C43.5499 6.53241 42.3947 5.1897 40.6785 5.1897C38.9623 5.1897 37.8071 6.5316 37.8071 8.38386C37.8071 10.2361 38.9623 11.578 40.6785 11.578C42.3947 11.578 43.5499 10.2361 43.5499 8.38386Z"
        fill="var(--icon)"
      />
      <path
        d="M10.2899 12.7225L14.3268 0.768555H15.8644L11.8274 12.7225H10.2899Z"
        fill="var(--icon)"
      />
      <path
        d="M0.256714 12.7225L4.2937 0.768555H5.83041L1.79423 12.7225H0.256714Z"
        fill="var(--icon)"
      />
      <path
        d="M10.3434 6.10889H6.21057L5.77991 7.38317H9.91269L10.3434 6.10889Z"
        fill="var(--icon)"
      />
    </svg>
  );
}

export function API(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="9.16729" cy="3.84845" r="2.28644" stroke="currentColor" strokeWidth="1.1" />
      <circle cx="14.8834" cy="14.1373" r="2.28644" stroke="currentColor" strokeWidth="1.1" />
      <circle cx="3.45119" cy="14.1373" r="2.28644" stroke="currentColor" strokeWidth="1.1" />
      <path
        d="M9.16729 7.56372V10.136M9.16729 10.136L6.88085 11.8508M9.16729 10.136L11.4537 11.8508"
        stroke="currentColor"
        strokeWidth="1.1"
      />
    </svg>
  );
}

export function Cloud(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="25"
      height="16"
      viewBox="0 0 25 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M21.7341 15.114L1.97607 15.114" stroke="currentColor" strokeWidth="1.1" />
      <path d="M1.04974 12.9636V7.76025H6.44958" stroke="currentColor" strokeWidth="1.1" />
      <path d="M4.56659 5.8419V0.88623H21.1918V5.8419" stroke="currentColor" strokeWidth="1.1" />
      <path d="M12.9514 12.9636V7.76025H18.0669" stroke="currentColor" strokeWidth="1.1" />
      <path d="M23.9503 12.9636V7.76025H19.7518" stroke="currentColor" strokeWidth="1.1" />
    </svg>
  );
}

export function Js(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.92111 2.81079V21.3582" stroke="currentColor" strokeWidth="1.14856" />
      <path d="M19.4024 2.81079L19.4024 17.734" stroke="currentColor" strokeWidth="1.14856" />
      <path d="M17.6972 1.53198L3.62672 1.53198" stroke="currentColor" strokeWidth="1.14856" />
      <path d="M17.6972 18.1609H5.33223" stroke="currentColor" strokeWidth="1.14856" />
      <path
        d="M3.83958 21.7849H19.4023V20.0793"
        stroke="currentColor"
        strokeWidth="1.14856"
        strokeLinejoin="bevel"
      />
      <path
        d="M16.845 10.6275V9.19556H13.5356V12.0595H16.845V14.9234H13.5355V13.9687"
        stroke="currentColor"
        strokeWidth="1.14856"
        strokeLinejoin="bevel"
      />
      <path
        d="M11.3553 8.71826V13.7301L10.6394 15.162H8.49143L7.77545 14.4461"
        stroke="currentColor"
        strokeWidth="1.14856"
        strokeLinejoin="bevel"
      />
    </svg>
  );
}

export function Frontend(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.19843 2.19873V16.0931" stroke="currentColor" strokeWidth="1.3" />
      <path d="M20.8015 2.19873V16.0931" stroke="currentColor" strokeWidth="1.3" />
      <path d="M18.7293 1.25684L3.27064 1.25684" stroke="currentColor" strokeWidth="1.3" />
      <path d="M18.7293 16.7432L3.27064 16.7432" stroke="currentColor" strokeWidth="1.3" />
      <circle cx="4.75156" cy="4.83826" r="1.04114" fill="currentColor" />
      <circle cx="7.94226" cy="4.83826" r="1.04114" fill="currentColor" />
      <circle cx="11.1177" cy="4.83826" r="1.04114" fill="currentColor" />
    </svg>
  );
}

export function Backend(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.7 5.43912V0.651855H1.40405V12.9478H6.3497"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinejoin="bevel"
      />
      <path
        d="M18.596 17.3479H6.1832V5.43091H18.1002V15.2396"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinejoin="bevel"
      />
      <path d="M1.6265 5.11718L6.074 0.669678" stroke="currentColor" strokeWidth="1.1" />
      <path d="M1.55878 9.05293L9.7748 0.836914" stroke="currentColor" strokeWidth="1.1" />
      <path
        d="M1.8178 12.5341L6.013 8.33893M13.2863 1.06567L8.88959 5.46233"
        stroke="currentColor"
        strokeWidth="1.1"
      />
    </svg>
  );
}

export function Chainhook(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="15"
      height="21"
      viewBox="0 0 15 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.64267 13.9633C2.64267 17.054 5.14825 19.5596 8.23903 19.5596C11.3298 19.5596 13.8354 17.054 13.8354 13.9633C13.8354 10.8725 11.3298 8.36689 8.23903 8.36689V1.50073"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <circle cx="2.64254" cy="13.9629" r="2.10061" fill="currentColor" />
    </svg>
  );
}

export function Clarinet(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5314 0.699463V0.699463C11.5848 0.699463 10.0068 2.27749 10.0068 4.22408V13.7909C10.0068 15.7375 11.5848 17.3155 13.5314 17.3155V17.3155"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <path
        d="M9.14333 0.699463V0.699463C7.19674 0.699463 5.61871 2.27749 5.61871 4.22408V13.7909C5.61871 15.7375 7.19674 17.3155 9.14333 17.3155V17.3155"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <path
        d="M4.75546 0.699463V0.699463C2.80886 0.699463 1.23083 2.27749 1.23083 4.22408V13.7909C1.23083 15.7375 2.80886 17.3155 4.75546 17.3155V17.3155"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      <circle cx="14.8269" cy="9.11588" r="1.94229" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  );
}

export function Hiro(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.51367 11.865L13.2384 0.835693H14.657L10.9323 11.865H9.51367Z"
        fill="currentColor"
      />
      <path
        d="M0.257812 11.8648L3.98254 0.835449H5.40038L1.6764 11.8648H0.257812Z"
        fill="currentColor"
      />
      <path
        d="M9.56251 5.76172H5.7494L5.35205 6.93744H9.16516L9.56251 5.76172Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Blockchain(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.02271 4.62691V11.4456L7.69635 15L14.515 11.4456V8.39941M1.02271 4.62691L7.69635 7.81865L14.515 4.62691L7.69635 1L1.02271 4.62691Z"
        stroke="currentColor"
        strokeLinejoin="bevel"
      />
      <path d="M7.69629 7.67358V14.7099" stroke="currentColor" strokeLinejoin="bevel" />
    </svg>
  );
}

export function Container(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="17"
      viewBox="0 0 24 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.991943"
        y="12.9116"
        width="3.57779"
        height="3.57779"
        rx="1"
        stroke="currentColor"
      />
      <rect
        x="0.991943"
        y="7.15027"
        width="3.57779"
        height="3.57779"
        rx="1"
        stroke="currentColor"
      />
      <rect x="6.98413" y="12.9116" width="3.57779" height="3.57779" rx="1" stroke="currentColor" />
      <rect x="6.98413" y="7.15027" width="3.57779" height="3.57779" rx="1" stroke="currentColor" />
      <rect x="12.9751" y="1.38934" width="3.57779" height="3.57779" rx="1" stroke="currentColor" />
      <rect x="12.9751" y="12.9116" width="3.57779" height="3.57779" rx="1" stroke="currentColor" />
      <rect x="18.9675" y="12.9116" width="3.57779" height="3.57779" rx="1" stroke="currentColor" />
      <rect x="12.9751" y="7.15027" width="3.57779" height="3.57779" rx="1" stroke="currentColor" />
    </svg>
  );
}

export function Shapes(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.7578 5.76844C6.7235 5.66591 6.65782 5.57675 6.57008 5.51358C6.48233 5.4504 6.37694 5.41642 6.26882 5.41642C6.16069 5.41642 6.05531 5.4504 5.96756 5.51358C5.87981 5.57675 5.81414 5.66591 5.77983 5.76844L2.34233 16.0809C2.31646 16.1585 2.30937 16.241 2.32166 16.3218C2.33395 16.4026 2.36527 16.4793 2.41302 16.5456C2.46078 16.6119 2.52361 16.6659 2.59634 16.7031C2.66906 16.7404 2.7496 16.7598 2.83132 16.7599H9.70632C9.78803 16.7598 9.86857 16.7404 9.94129 16.7031C10.014 16.6659 10.0769 16.6119 10.1246 16.5456C10.1724 16.4793 10.2037 16.4026 10.216 16.3218C10.2283 16.241 10.2212 16.1585 10.1953 16.0809L6.7578 5.76844ZM3.54632 15.7286L6.26882 7.56454L8.99132 15.7286H3.54632ZM18.4719 6.96298C18.4719 6.11313 18.2199 5.28238 17.7478 4.57576C17.2756 3.86914 16.6046 3.3184 15.8194 2.99318C15.0343 2.66796 14.1703 2.58287 13.3368 2.74866C12.5033 2.91446 11.7376 3.3237 11.1367 3.92463C10.5358 4.52556 10.1266 5.29119 9.96075 6.1247C9.79496 6.95821 9.88005 7.82217 10.2053 8.60732C10.5305 9.39247 11.0812 10.0635 11.7878 10.5357C12.4945 11.0078 13.3252 11.2599 14.1751 11.2599C15.3142 11.2585 16.4064 10.8053 17.2119 9.99982C18.0174 9.19429 18.4706 8.10216 18.4719 6.96298ZM10.9094 6.96298C10.9094 6.3171 11.101 5.68572 11.4598 5.14869C11.8186 4.61166 12.3286 4.1931 12.9254 3.94593C13.5221 3.69876 14.1787 3.63409 14.8122 3.7601C15.4456 3.8861 16.0275 4.19713 16.4842 4.65383C16.9409 5.11054 17.2519 5.69242 17.3779 6.32588C17.5039 6.95935 17.4393 7.61596 17.1921 8.21268C16.9449 8.80939 16.5264 9.31941 15.9893 9.67824C15.4523 10.0371 14.8209 10.2286 14.1751 10.2286C13.309 10.2286 12.4783 9.88454 11.8659 9.27212C11.2535 8.6597 10.9094 7.82907 10.9094 6.96298ZM20.0188 12.9786H12.4563C12.3196 12.9786 12.1884 13.0329 12.0917 13.1296C11.995 13.2263 11.9407 13.3575 11.9407 13.4942V18.3067C11.9407 18.4435 11.995 18.5746 12.0917 18.6713C12.1884 18.768 12.3196 18.8224 12.4563 18.8224H20.0188C20.1556 18.8224 20.2867 18.768 20.3834 18.6713C20.4801 18.5746 20.5344 18.4435 20.5344 18.3067V13.4942C20.5344 13.3575 20.4801 13.2263 20.3834 13.1296C20.2867 13.0329 20.1556 12.9786 20.0188 12.9786ZM19.5032 17.7911H12.9719V14.0099H19.5032V17.7911Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DAO(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.1594 4.55672V8.68172C19.1594 8.81848 19.1051 8.94963 19.0084 9.04633C18.9117 9.14302 18.7806 9.19735 18.6438 9.19735C18.507 9.19735 18.3759 9.14302 18.2792 9.04633C18.1825 8.94963 18.1282 8.81848 18.1282 8.68172V5.8011L14.1957 9.7336C14.0979 9.82468 13.9686 9.87426 13.8351 9.87191C13.7015 9.86955 13.574 9.81544 13.4796 9.72096C13.3851 9.62649 13.331 9.49904 13.3286 9.36546C13.3263 9.23188 13.3758 9.10259 13.4669 9.00485L17.3994 5.07235H14.5188C14.382 5.07235 14.2509 5.01802 14.1542 4.92133C14.0575 4.82463 14.0032 4.69348 14.0032 4.55672C14.0032 4.41997 14.0575 4.28882 14.1542 4.19212C14.2509 4.09542 14.382 4.0411 14.5188 4.0411H18.6438C18.7806 4.0411 18.9117 4.09542 19.0084 4.19212C19.1051 4.28882 19.1594 4.41997 19.1594 4.55672ZM9.34192 13.1298L5.40942 17.0624V14.1817C5.40942 14.045 5.3551 13.9138 5.2584 13.8171C5.1617 13.7204 5.03055 13.6661 4.8938 13.6661C4.75705 13.6661 4.6259 13.7204 4.5292 13.8171C4.4325 13.9138 4.37817 14.045 4.37817 14.1817V18.3067C4.37817 18.4435 4.4325 18.5746 4.5292 18.6713C4.6259 18.768 4.75705 18.8223 4.8938 18.8223H9.0188C9.15555 18.8223 9.2867 18.768 9.3834 18.6713C9.4801 18.5746 9.53442 18.4435 9.53442 18.3067C9.53442 18.17 9.4801 18.0388 9.3834 17.9421C9.2867 17.8454 9.15555 17.7911 9.0188 17.7911H6.13817L10.0707 13.8586C10.1618 13.7609 10.2113 13.6316 10.209 13.498C10.2066 13.3644 10.1525 13.237 10.058 13.1425C9.96357 13.048 9.83611 12.9939 9.70253 12.9915C9.56895 12.9892 9.43967 13.0388 9.34192 13.1298ZM18.6438 13.6661C18.507 13.6661 18.3759 13.7204 18.2792 13.8171C18.1825 13.9138 18.1282 14.045 18.1282 14.1817V17.0624L14.1957 13.1298C14.0979 13.0388 13.9686 12.9892 13.8351 12.9915C13.7015 12.9939 13.574 13.048 13.4796 13.1425C13.3851 13.237 13.331 13.3644 13.3286 13.498C13.3263 13.6316 13.3758 13.7609 13.4669 13.8586L17.3994 17.7911H14.5188C14.382 17.7911 14.2509 17.8454 14.1542 17.9421C14.0575 18.0388 14.0032 18.17 14.0032 18.3067C14.0032 18.4435 14.0575 18.5746 14.1542 18.6713C14.2509 18.768 14.382 18.8223 14.5188 18.8223H18.6438C18.7806 18.8223 18.9117 18.768 19.0084 18.6713C19.1051 18.5746 19.1594 18.4435 19.1594 18.3067V14.1817C19.1594 14.045 19.1051 13.9138 19.0084 13.8171C18.9117 13.7204 18.7806 13.6661 18.6438 13.6661ZM6.13817 5.07235H9.0188C9.15555 5.07235 9.2867 5.01802 9.3834 4.92133C9.4801 4.82463 9.53442 4.69348 9.53442 4.55672C9.53442 4.41997 9.4801 4.28882 9.3834 4.19212C9.2867 4.09542 9.15555 4.0411 9.0188 4.0411H4.8938C4.75705 4.0411 4.6259 4.09542 4.5292 4.19212C4.4325 4.28882 4.37817 4.41997 4.37817 4.55672V8.68172C4.37817 8.81848 4.4325 8.94963 4.5292 9.04633C4.6259 9.14302 4.75705 9.19735 4.8938 9.19735C5.03055 9.19735 5.1617 9.14302 5.2584 9.04633C5.3551 8.94963 5.40942 8.81848 5.40942 8.68172V5.8011L9.34192 9.7336C9.43967 9.82468 9.56895 9.87426 9.70253 9.87191C9.83611 9.86955 9.96357 9.81544 10.058 9.72096C10.1525 9.62649 10.2066 9.49904 10.209 9.36546C10.2113 9.23188 10.1618 9.10259 10.0707 9.00485L6.13817 5.07235Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Plant(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.8776 3.86924C21.8701 3.74339 21.8167 3.62466 21.7275 3.53551C21.6384 3.44636 21.5196 3.39296 21.3938 3.38541C17.011 3.1276 13.4979 4.45275 11.9965 6.93119C10.9971 8.58205 11.0186 10.599 12.0421 12.5171C11.3858 13.2684 10.9284 14.1722 10.7118 15.146L9.0102 13.4435C9.71059 12.0599 9.7063 10.6119 8.9827 9.41737C7.88184 7.59979 5.32348 6.62525 2.1352 6.81432C2.00921 6.82189 1.89037 6.87541 1.8012 6.96474C1.71203 7.05407 1.65872 7.173 1.65138 7.29901C1.46403 10.4864 2.43684 13.0448 4.25442 14.1456C4.84638 14.5074 5.52691 14.6984 6.22067 14.6974C6.93915 14.69 7.64578 14.5134 8.28317 14.1817L10.5657 16.4574V18.9942C10.5657 19.131 10.62 19.2621 10.7167 19.3588C10.8134 19.4555 10.9445 19.5099 11.0813 19.5099C11.2181 19.5099 11.3492 19.4555 11.4459 19.3588C11.5426 19.2621 11.5969 19.131 11.5969 18.9942V16.4599C11.5935 15.2787 12.0129 14.1352 12.7794 13.2364C13.7428 13.746 14.7319 14.0021 15.6858 14.0021C16.6189 14.0052 17.5346 13.7503 18.3318 13.2656C20.8103 11.766 22.1354 8.25205 21.8776 3.86924ZM4.78895 13.2631C3.38731 12.4149 2.607 10.4005 2.65942 7.82236C5.23755 7.76651 7.24934 8.54768 8.09755 9.94932C8.58567 10.7546 8.62692 11.7007 8.22989 12.6641L5.94567 10.379C5.84892 10.2823 5.7177 10.2279 5.58087 10.2279C5.44404 10.2279 5.31282 10.2823 5.21606 10.379C5.11931 10.4758 5.06496 10.607 5.06496 10.7438C5.06496 10.8806 5.11931 11.0119 5.21606 11.1086L7.50372 13.3954C6.54036 13.7924 5.59419 13.7521 4.78895 13.2631ZM17.7982 12.3848C16.5315 13.1514 15.0361 13.1737 13.5297 12.4621L18.3215 7.67111C18.3694 7.62321 18.4074 7.56633 18.4334 7.50374C18.4593 7.44115 18.4726 7.37406 18.4726 7.30631C18.4726 7.23856 18.4593 7.17147 18.4334 7.10888C18.4074 7.04629 18.3694 6.98941 18.3215 6.94151C18.2736 6.8936 18.2168 6.8556 18.1542 6.82967C18.0916 6.80374 18.0245 6.7904 17.9567 6.7904C17.889 6.7904 17.8219 6.80374 17.7593 6.82967C17.6967 6.8556 17.6398 6.8936 17.5919 6.94151L12.8 11.7334C12.0885 10.2269 12.1125 8.73158 12.8774 7.46572C14.1252 5.40322 17.0935 4.27057 20.8696 4.39346C20.9925 8.16611 19.859 11.1361 17.7982 12.3848Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function HiroSVG(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.51367 11.865L13.2384 0.835693H14.657L10.9323 11.865H9.51367Z"
        fill="currentColor"
      />
      <path
        d="M0.257812 11.8648L3.98254 0.835449H5.40038L1.6764 11.8648H0.257812Z"
        fill="currentColor"
      />
      <path
        d="M9.56251 5.76172H5.7494L5.35205 6.93744H9.16516L9.56251 5.76172Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ContentBackground(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="710"
      height="95"
      viewBox="0 0 710 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M101.627 3.87319V3.1944H105.609V3.87319H101.627ZM101.627 6.01818V5.33938H105.609V6.01818H101.627Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.459 4.04077V3.02673H105.777V4.04077H101.459ZM101.459 6.18576V5.17172H105.777V6.18576H101.459ZM101.627 3.87315H105.609V3.19436H101.627V3.87315ZM101.627 6.01814H105.609V5.33934H101.627V6.01814Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M586.717 7.29184L586.952 5.77135H586.084V5.14686H587.043L587.215 3.95217H586.283V3.32768H587.305L587.541 1.80719H588.156L587.921 3.32768H589.161L589.396 1.80719H590.012L589.776 3.32768H590.645V3.95217H589.686L589.514 5.14686H590.446V5.77135H589.423L589.188 7.29184H588.572L588.808 5.77135H587.568L587.333 7.29184H586.717ZM587.658 5.14686H588.898L589.07 3.95217H587.83L587.658 5.14686Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M586.522 7.45949L586.757 5.93899H585.916V4.97926H586.898L587.021 4.11982H586.115V3.16008H587.162L587.397 1.63959H588.352L588.116 3.16008H589.017L589.252 1.63959H590.207L589.972 3.16008H590.813V4.11982H589.831L589.707 4.97926H590.614V5.93899H589.567L589.332 7.45949H588.377L588.612 5.93899H587.712L587.476 7.45949H586.522ZM587.568 5.77137H588.808L588.572 7.29186H589.188L589.423 5.77137H590.446V5.14688H589.514L589.686 3.9522H590.645V3.3277H589.776L590.011 1.80721H589.396L589.161 3.3277H587.921L588.156 1.80721H587.541L587.305 3.3277H586.283V3.9522H587.215L587.043 5.14688H586.084V5.77137H586.952L586.717 7.29186H587.333L587.568 5.77137ZM588.753 4.97926L588.877 4.11982H587.975L587.852 4.97926H588.753ZM587.658 5.14688H588.898L589.07 3.9522H587.83L587.658 5.14688Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M670.979 7.29183V0.956421H671.766V3.70781H674.391V0.956421H675.178V7.29183H674.391V4.43184H671.766V7.29183H670.979Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M670.811 7.45941V0.788757H671.934V3.54014H674.223V0.788757H675.346V7.45941H674.223V4.59942H671.934V7.45941H670.811ZM671.766 4.4318H674.391V7.29179H675.178V0.95638H674.391V3.70777H671.766V0.95638H670.979V7.29179H671.766V4.4318Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M11.712 17.3876C11.712 17.1161 11.9111 16.9169 12.1827 16.9169C12.4542 16.9169 12.6624 17.1161 12.6624 17.3876C12.6624 17.6592 12.4633 17.8493 12.1827 17.8493C11.9021 17.8493 11.712 17.6501 11.712 17.3876ZM13.3504 17.3876C13.3504 17.1161 13.5677 16.9169 13.8302 16.9169C14.0927 16.9169 14.3009 17.1161 14.3009 17.3876C14.3009 17.6592 14.1017 17.8493 13.8302 17.8493C13.5586 17.8493 13.3504 17.6501 13.3504 17.3876Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5444 17.3876C11.5444 17.0234 11.8186 16.7493 12.1827 16.7493C12.5426 16.7493 12.8301 17.0193 12.8301 17.3876C12.8301 17.566 12.7638 17.726 12.6439 17.8412C12.5245 17.9558 12.3614 18.0169 12.1827 18.0169C11.8095 18.0169 11.5444 17.7427 11.5444 17.3876ZM13.1828 17.3876C13.1828 17.0172 13.4814 16.7493 13.8302 16.7493C14.1831 16.7493 14.4685 17.0213 14.4685 17.3876C14.4685 17.756 14.19 18.0169 13.8302 18.0169C13.4725 18.0169 13.1828 17.749 13.1828 17.3876ZM12.1827 16.9169C11.9111 16.9169 11.712 17.116 11.712 17.3876C11.712 17.6501 11.9021 17.8493 12.1827 17.8493C12.4633 17.8493 12.6625 17.6592 12.6625 17.3876C12.6625 17.116 12.4543 16.9169 12.1827 16.9169ZM13.8302 16.9169C13.5677 16.9169 13.3504 17.116 13.3504 17.3876C13.3504 17.6501 13.5586 17.8493 13.8302 17.8493C14.1017 17.8493 14.3009 17.6592 14.3009 17.3876C14.3009 17.116 14.0927 16.9169 13.8302 16.9169Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M17.5956 17.3876C17.5956 17.1161 17.7948 16.9169 18.0664 16.9169C18.3379 16.9169 18.5461 17.1161 18.5461 17.3876C18.5461 17.6592 18.347 17.8493 18.0664 17.8493C17.7857 17.8493 17.5956 17.6501 17.5956 17.3876ZM19.2341 17.3876C19.2341 17.1161 19.4513 16.9169 19.7138 16.9169C19.9763 16.9169 20.1845 17.1161 20.1845 17.3876C20.1845 17.6592 19.9854 17.8493 19.7138 17.8493C19.4423 17.8493 19.2341 17.6501 19.2341 17.3876Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.428 17.3876C17.428 17.0234 17.7022 16.7493 18.0663 16.7493C18.4262 16.7493 18.7137 17.0193 18.7137 17.3876C18.7137 17.566 18.6474 17.726 18.5275 17.8412C18.4081 17.9558 18.245 18.0169 18.0663 18.0169C17.6931 18.0169 17.428 17.7427 17.428 17.3876ZM19.0664 17.3876C19.0664 17.0172 19.3651 16.7493 19.7138 16.7493C20.0667 16.7493 20.3521 17.0213 20.3521 17.3876C20.3521 17.756 20.0736 18.0169 19.7138 18.0169C19.3561 18.0169 19.0664 17.749 19.0664 17.3876ZM18.0663 16.9169C17.7948 16.9169 17.5956 17.116 17.5956 17.3876C17.5956 17.6501 17.7857 17.8493 18.0663 17.8493C18.3469 17.8493 18.5461 17.6592 18.5461 17.3876C18.5461 17.116 18.3379 16.9169 18.0663 16.9169ZM19.7138 16.9169C19.4513 16.9169 19.234 17.116 19.234 17.3876C19.234 17.6501 19.4422 17.8493 19.7138 17.8493C19.9854 17.8493 20.1845 17.6592 20.1845 17.3876C20.1845 17.116 19.9763 16.9169 19.7138 16.9169Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M115.713 23.1324V16.797H117.858C119.126 16.797 119.967 17.5572 119.967 18.7429C119.967 19.6298 119.433 20.3177 118.619 20.544L120.04 23.1324H119.153L117.813 20.6978H116.501V23.1324H115.713ZM116.501 19.9738H117.795C118.628 19.9738 119.162 19.485 119.162 18.7429C119.162 18.0007 118.628 17.5211 117.804 17.5211H116.501V19.9738Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.546 23.3V16.6293H117.858C118.525 16.6293 119.096 16.8297 119.501 17.2017C119.908 17.5752 120.135 18.1083 120.135 18.7428C120.135 19.6306 119.637 20.3418 118.863 20.6398L120.323 23.3H119.054L117.714 20.8654H116.668V23.3H115.546ZM116.501 20.6978H117.813L119.153 23.1324H120.04L118.619 20.5439C118.674 20.5285 118.728 20.511 118.781 20.4914C119.503 20.2231 119.967 19.5694 119.967 18.7428C119.967 17.5572 119.125 16.797 117.858 16.797H115.713V23.1324H116.501V20.6978ZM116.668 19.8061H117.795C118.179 19.8061 118.478 19.6937 118.678 19.5123C118.877 19.3323 118.994 19.0716 118.994 18.7428C118.994 18.4142 118.877 18.1559 118.68 17.9782C118.48 17.799 118.184 17.6886 117.804 17.6886H116.668V19.8061ZM117.795 19.9737C118.628 19.9737 119.162 19.485 119.162 18.7428C119.162 18.0007 118.628 17.521 117.804 17.521H116.501V19.9737H117.795Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M230.106 19.2248C230.106 18.89 230.351 18.6637 230.676 18.6637C231.002 18.6637 231.247 18.89 231.247 19.2248C231.247 19.5597 231.002 19.786 230.676 19.786C230.351 19.786 230.106 19.5597 230.106 19.2248ZM230.106 22.6188C230.106 22.2839 230.351 22.0577 230.676 22.0577C231.002 22.0577 231.247 22.2839 231.247 22.6188C231.247 22.9537 231.002 23.18 230.676 23.18C230.351 23.18 230.106 22.9537 230.106 22.6188Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M229.938 19.2248C229.938 18.792 230.263 18.496 230.676 18.496C231.089 18.496 231.414 18.792 231.414 19.2248C231.414 19.6575 231.089 19.9536 230.676 19.9536C230.263 19.9536 229.938 19.6575 229.938 19.2248ZM229.938 22.6188C229.938 22.186 230.263 21.89 230.676 21.89C231.089 21.89 231.414 22.186 231.414 22.6188C231.414 23.0515 231.089 23.3475 230.676 23.3475C230.263 23.3475 229.938 23.0515 229.938 22.6188ZM230.676 18.6637C230.35 18.6637 230.106 18.8899 230.106 19.2248C230.106 19.5597 230.35 19.7859 230.676 19.7859C231.002 19.7859 231.246 19.5597 231.246 19.2248C231.246 18.8899 231.002 18.6637 230.676 18.6637ZM230.676 22.0576C230.35 22.0576 230.106 22.2839 230.106 22.6188C230.106 22.9536 230.35 23.1799 230.676 23.1799C231.002 23.1799 231.246 22.9536 231.246 22.6188C231.246 22.2839 231.002 22.0576 230.676 22.0576Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M270.345 17.4508H268.716V22.483H270.345V23.1346H266.299V22.483H267.928V17.4508H266.299V16.7992H270.345V17.4508Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M270.512 17.6185H268.883V22.3154H270.512V23.3022H266.131V22.3154H267.761V17.6185H266.131V16.6316H270.512V17.6185ZM267.928 17.4509V22.483H266.299V23.1346H270.345V22.483H268.716V17.4509H270.345V16.7992H266.299V17.4509H267.928Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M316.694 19.2431C315.581 19.2431 315.246 20.0757 315.246 20.8088V22.4561H317.291V23.1348H313.363V22.4561H314.504V19.1978H313.363V18.519H315.228V19.3155C315.436 18.9625 315.87 18.519 316.775 18.519H317.545V19.2431H316.694Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M317.459 22.2884V23.3024H313.196V22.2884H314.336V19.3654H313.196V18.3514H315.395V18.8396C315.68 18.5735 316.115 18.3514 316.775 18.3514H317.712V19.4107H316.694C316.185 19.4107 315.875 19.598 315.687 19.851C315.493 20.1121 315.413 20.4638 315.413 20.8088V22.2884H317.459ZM315.246 22.456V20.8088C315.246 20.0757 315.581 19.2431 316.694 19.2431H317.545V18.519H316.775C316.064 18.519 315.644 18.7926 315.395 19.0811C315.327 19.1598 315.272 19.2397 315.228 19.3155V18.519H313.363V19.1978H314.504V22.456H313.363V23.1348H317.291V22.456H315.246Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M369.561 20.1841L371.534 16.7992H372.194L374.176 20.1841H373.416L371.841 17.5233L370.285 20.1841H369.561Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M369.269 20.3518L371.437 16.6316H372.29L374.469 20.3518H373.321L371.842 17.8538L370.381 20.3518H369.269ZM371.841 17.5233L373.416 20.1842H374.176L372.194 16.7992H371.534L369.561 20.1842H370.285L371.841 17.5233Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M427.342 20.519L426.835 20.0755L427.867 18.8899L426.382 18.3378L426.654 17.7043L428.039 18.3468L428.02 16.7992H428.672L428.645 18.3559L430.048 17.7043L430.31 18.3468L428.835 18.8989L429.849 20.0755L429.342 20.519L428.337 19.2429L427.342 20.519Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M427.365 20.762L426.599 20.0916L427.581 18.9626L426.159 18.4336L426.568 17.4795L427.868 18.0828L427.851 16.6316H428.843L428.817 18.0911L430.137 17.4782L430.531 18.4433L429.119 18.9717L430.084 20.0921L429.319 20.7614L428.338 19.5146L427.365 20.762ZM428.337 19.2429L429.342 20.519L429.849 20.0755L428.835 18.899L430.31 18.3469L430.048 17.7043L428.645 18.3559L428.672 16.7992H428.02L428.039 18.3469L426.654 17.7043L426.382 18.3378L427.867 18.8899L426.835 20.0755L427.342 20.519L428.337 19.2429Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M483.817 20.519L483.311 20.0755L484.342 18.8899L482.858 18.3378L483.129 17.7043L484.514 18.3468L484.496 16.7992H485.148L485.121 18.3559L486.523 17.7043L486.786 18.3468L485.311 18.8989L486.324 20.0755L485.817 20.519L484.813 19.2429L483.817 20.519Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M483.84 20.762L483.074 20.0916L484.057 18.9626L482.635 18.4336L483.043 17.4795L484.343 18.0828L484.327 16.6316H485.318L485.293 18.0911L486.612 17.4782L487.006 18.4433L485.595 18.9717L486.56 20.0921L485.795 20.7614L484.813 19.5146L483.84 20.762ZM484.813 19.2429L485.817 20.519L486.324 20.0755L485.311 18.899L486.786 18.3469L486.523 17.7043L485.121 18.3559L485.148 16.7992H484.496L484.514 18.3469L483.129 17.7043L482.858 18.3378L484.342 18.8899L483.311 20.0755L483.817 20.519L484.813 19.2429Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M559.555 22.6173C559.555 22.2824 559.799 22.0561 560.125 22.0561C560.451 22.0561 560.696 22.2824 560.696 22.6173C560.696 22.9523 560.451 23.1786 560.125 23.1786C559.799 23.1786 559.555 22.9523 559.555 22.6173Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M559.387 22.6173C559.387 22.1845 559.712 21.8884 560.125 21.8884C560.538 21.8884 560.863 22.1845 560.863 22.6173C560.863 23.0501 560.538 23.3462 560.125 23.3462C559.712 23.3462 559.387 23.0501 559.387 22.6173ZM560.125 22.0561C559.799 22.0561 559.555 22.2824 559.555 22.6173C559.555 22.9522 559.799 23.1785 560.125 23.1785C560.451 23.1785 560.696 22.9522 560.696 22.6173C560.696 22.2824 560.451 22.0561 560.125 22.0561Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M681.922 22.6173C681.922 22.2824 682.167 22.0561 682.492 22.0561C682.818 22.0561 683.063 22.2824 683.063 22.6173C683.063 22.9523 682.818 23.1786 682.492 23.1786C682.167 23.1786 681.922 22.9523 681.922 22.6173Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M681.755 22.6173C681.755 22.1845 682.079 21.8884 682.492 21.8884C682.905 21.8884 683.23 22.1845 683.23 22.6173C683.23 23.0501 682.905 23.3462 682.492 23.3462C682.079 23.3462 681.755 23.0501 681.755 22.6173ZM682.492 22.0561C682.167 22.0561 681.922 22.2824 681.922 22.6173C681.922 22.9522 682.167 23.1785 682.492 23.1785C682.818 23.1785 683.063 22.9522 683.063 22.6173C683.063 22.2824 682.818 22.0561 682.492 22.0561Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M687.806 22.6173C687.806 22.2824 688.05 22.0561 688.376 22.0561C688.702 22.0561 688.946 22.2824 688.946 22.6173C688.946 22.9523 688.702 23.1786 688.376 23.1786C688.05 23.1786 687.806 22.9523 687.806 22.6173Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M687.638 22.6173C687.638 22.1845 687.963 21.8884 688.376 21.8884C688.789 21.8884 689.114 22.1845 689.114 22.6173C689.114 23.0501 688.789 23.3462 688.376 23.3462C687.963 23.3462 687.638 23.0501 687.638 22.6173ZM688.376 22.0561C688.05 22.0561 687.806 22.2824 687.806 22.6173C687.806 22.9522 688.05 23.1785 688.376 23.1785C688.702 23.1785 688.946 22.9522 688.946 22.6173C688.946 22.2824 688.702 22.0561 688.376 22.0561Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M693.689 22.6173C693.689 22.2824 693.934 22.0561 694.26 22.0561C694.585 22.0561 694.83 22.2824 694.83 22.6173C694.83 22.9523 694.585 23.1786 694.26 23.1786C693.934 23.1786 693.689 22.9523 693.689 22.6173Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M693.522 22.6173C693.522 22.1845 693.847 21.8884 694.26 21.8884C694.673 21.8884 694.998 22.1845 694.998 22.6173C694.998 23.0501 694.673 23.3462 694.26 23.3462C693.847 23.3462 693.522 23.0501 693.522 22.6173ZM694.26 22.0561C693.934 22.0561 693.689 22.2824 693.689 22.6173C693.689 22.9522 693.934 23.1785 694.26 23.1785C694.586 23.1785 694.83 22.9522 694.83 22.6173C694.83 22.2824 694.586 22.0561 694.26 22.0561Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M18.4238 39.8777L20.9851 32.368H21.7182L19.1569 39.8777H18.4238Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1895 40.0453L20.8652 32.2003H21.9525L19.2768 40.0453H18.1895ZM18.4238 39.8777H19.1569L21.7182 32.3679H20.9851L18.4238 39.8777Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M27.2555 35.0834C26.1423 35.0834 25.8075 35.9161 25.8075 36.6492V38.2964H27.8529V38.9752H23.9249V38.2964H25.0653V35.0382H23.9249V34.3594H25.7894V35.1558C25.9975 34.8029 26.4319 34.3594 27.337 34.3594H28.1063V35.0834H27.2555Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0205 38.1287V39.1428H23.7573V38.1287H24.8976V35.2058H23.7573V34.1917H25.9569V34.6799C26.2415 34.4138 26.6769 34.1917 27.337 34.1917H28.2739V35.251H27.2555C26.7465 35.251 26.4367 35.4383 26.2485 35.6914C26.0544 35.9525 25.975 36.3042 25.975 36.6491V38.1287H28.0205ZM25.8074 38.2963V36.6491C25.8074 35.916 26.1423 35.0834 27.2555 35.0834H28.1063V34.3593H27.337C26.6261 34.3593 26.2055 34.6329 25.9569 34.9214C25.889 35.0002 25.834 35.0801 25.7893 35.1558V34.3593H23.9249V35.0381H25.0653V38.2963H23.9249V38.9751H27.8528V38.2963H25.8074Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M68.3686 36.6671C68.3686 35.2643 69.3099 34.3049 70.6584 34.3049C72.0069 34.3049 72.9482 35.2643 72.9482 36.6671C72.9482 38.07 72.0069 39.0293 70.6584 39.0293C69.3099 39.0293 68.3686 38.07 68.3686 36.6671ZM72.1879 36.6671C72.1879 35.6806 71.5725 34.9656 70.6584 34.9656C69.7443 34.9656 69.1289 35.6806 69.1289 36.6671C69.1289 37.6537 69.7443 38.3687 70.6584 38.3687C71.5725 38.3687 72.1879 37.6537 72.1879 36.6671Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.8877 34.8431C69.3259 34.3925 69.9431 34.1373 70.6584 34.1373C71.3738 34.1373 71.9909 34.3925 72.4292 34.8431C72.8671 35.2933 73.1158 35.9275 73.1158 36.6671C73.1158 37.4067 72.8671 38.0409 72.4292 38.4911C71.9909 38.9417 71.3738 39.1969 70.6584 39.1969C69.9431 39.1969 69.3259 38.9417 68.8877 38.4911C68.4497 38.0409 68.201 37.4067 68.201 36.6671C68.201 35.9275 68.4497 35.2933 68.8877 34.8431ZM71.6406 35.5577C71.4052 35.2925 71.0689 35.1332 70.6584 35.1332C70.2479 35.1332 69.9116 35.2925 69.6762 35.5577C69.4394 35.8245 69.2965 36.2083 69.2965 36.6671C69.2965 37.1259 69.4394 37.5097 69.6762 37.7765C69.9116 38.0417 70.2479 38.201 70.6584 38.201C71.0689 38.201 71.4052 38.0417 71.6406 37.7765C71.8775 37.5097 72.0203 37.1259 72.0203 36.6671C72.0203 36.2083 71.8775 35.8245 71.6406 35.5577ZM70.6584 34.3049C69.3099 34.3049 68.3686 35.2643 68.3686 36.6671C68.3686 38.0699 69.3099 39.0293 70.6584 39.0293C72.0069 39.0293 72.9482 38.0699 72.9482 36.6671C72.9482 35.2643 72.0069 34.3049 70.6584 34.3049ZM70.6584 34.9656C71.5725 34.9656 72.188 35.6806 72.188 36.6671C72.188 37.6536 71.5725 38.3686 70.6584 38.3686C69.7443 38.3686 69.1289 37.6536 69.1289 36.6671C69.1289 35.6806 69.7443 34.9656 70.6584 34.9656Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M96.5895 36.0246L98.5625 32.6396H99.2232L101.205 36.0246H100.445L98.8702 33.3637L97.3135 36.0246H96.5895Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.2977 36.1922L98.4662 32.472H99.3193L101.498 36.1922H100.349L98.871 33.6942L97.4096 36.1922H96.2977ZM98.8702 33.3637L100.445 36.0245H101.205L99.2232 32.6396H98.5625L96.5895 36.0245H97.3135L98.8702 33.3637Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M106.356 38.0225C106.519 38.2397 106.664 38.294 106.835 38.294H107.252V38.9728H106.691C106.338 38.9728 106.075 38.8823 105.849 38.5836L105.632 38.294C105.215 38.7737 104.718 39.0271 104.138 39.0271C103.089 39.0271 102.41 38.3664 102.41 37.3618C102.41 36.5925 102.844 35.9589 103.568 35.5607C103.134 34.9362 103.016 34.6014 103.016 34.1217C103.016 33.2257 103.677 32.5831 104.6 32.5831C105.415 32.5831 105.994 33.1623 105.994 33.9859C105.994 34.6647 105.532 35.2802 104.645 35.7598L105.641 37.0722L106.446 35.5517H107.252L106.102 37.6876L106.356 38.0225ZM105.215 37.7419L103.966 36.1038L103.948 36.0856C103.451 36.4024 103.17 36.7825 103.17 37.3075C103.17 37.9501 103.586 38.3573 104.175 38.3573C104.609 38.3573 104.953 38.113 105.215 37.7419ZM103.776 34.0674C103.776 34.4747 103.876 34.71 104.265 35.253C104.917 34.9362 105.234 34.5018 105.234 34.0131C105.234 33.5243 104.98 33.2438 104.546 33.2438C104.111 33.2438 103.776 33.5696 103.776 34.0674Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.49 37.9219C106.561 38.0172 106.62 38.0652 106.67 38.091C106.718 38.116 106.768 38.1263 106.835 38.1263H107.419V39.1404H106.691C106.501 39.1404 106.322 39.1161 106.156 39.0439C105.987 38.9709 105.843 38.8537 105.715 38.6848L105.618 38.5547C105.202 38.9691 104.708 39.1947 104.138 39.1947C103.578 39.1947 103.101 39.0178 102.764 38.6917C102.426 38.3651 102.242 37.903 102.242 37.3617C102.242 36.5795 102.655 35.9332 103.329 35.5072C103.164 35.258 103.049 35.0477 102.972 34.8461C102.88 34.6018 102.849 34.3774 102.849 34.1216C102.849 33.1286 103.589 32.4154 104.6 32.4154C105.048 32.4154 105.441 32.5754 105.721 32.8574C106.002 33.1393 106.161 33.5338 106.161 33.9859C106.161 34.7036 105.703 35.3287 104.894 35.811L105.616 36.7616L106.345 35.384H107.532L106.301 37.6722L106.49 37.9219ZM106.102 37.6876L107.252 35.5516H106.446L105.641 37.0721L104.645 35.7598C104.696 35.7325 104.745 35.7048 104.793 35.6766C105.583 35.2099 105.994 34.6261 105.994 33.9859C105.994 33.1623 105.415 32.583 104.6 32.583C103.677 32.583 103.016 33.2256 103.016 34.1216C103.016 34.5644 103.116 34.8838 103.474 35.4215C103.503 35.4663 103.535 35.5126 103.568 35.5607C103.519 35.588 103.47 35.6164 103.423 35.6459C102.787 36.0465 102.41 36.6452 102.41 37.3617C102.41 38.3664 103.089 39.027 104.138 39.027C104.665 39.027 105.124 38.8176 105.516 38.4192C105.555 38.3793 105.594 38.3376 105.632 38.2939L105.849 38.5836C106.075 38.8822 106.338 38.9727 106.691 38.9727H107.252V38.2939H106.835C106.664 38.2939 106.519 38.2397 106.356 38.0224L106.102 37.6876ZM103.948 36.0856L103.966 36.1037L105.215 37.7419C104.953 38.1129 104.609 38.3573 104.175 38.3573C103.586 38.3573 103.17 37.95 103.17 37.3074C103.17 36.7825 103.451 36.4024 103.948 36.0856ZM103.914 36.3112C103.529 36.5882 103.338 36.9008 103.338 37.3074C103.338 37.5919 103.429 37.8101 103.572 37.9563C103.714 38.1024 103.92 38.1897 104.175 38.1897C104.501 38.1897 104.776 38.0266 105.005 37.7425L103.914 36.3112ZM104.265 35.253C104.917 34.9362 105.234 34.5018 105.234 34.013C105.234 33.5243 104.98 33.2437 104.546 33.2437C104.111 33.2437 103.776 33.5696 103.776 34.0673C103.776 34.4746 103.876 34.7099 104.265 35.253ZM104.03 34.5451C104.085 34.6795 104.174 34.8301 104.318 35.037C104.845 34.7467 105.066 34.3859 105.066 34.013C105.066 33.796 105.01 33.6485 104.928 33.557C104.848 33.4681 104.725 33.4114 104.546 33.4114C104.21 33.4114 103.944 33.6557 103.944 34.0673C103.944 34.2544 103.966 34.3923 104.03 34.5451Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M126.132 36.3595L125.625 35.916L126.657 34.7303L125.172 34.1783L125.444 33.5447L126.829 34.1873L126.81 32.6396H127.462L127.435 34.1964L128.838 33.5447L129.1 34.1873L127.625 34.7394L128.639 35.916L128.132 36.3595L127.127 35.0833L126.132 36.3595Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.155 36.6023L125.389 35.932L126.371 34.803L124.949 34.274L125.358 33.3199L126.658 33.9232L126.641 32.472H127.633L127.607 33.9315L128.927 33.3186L129.321 34.2837L127.909 34.8121L128.874 35.9325L128.109 36.6018L127.128 35.355L126.155 36.6023ZM127.127 35.0833L128.132 36.3594L128.639 35.9159L127.625 34.7394L129.1 34.1873L128.838 33.5447L127.435 34.1963L127.462 32.6396H126.81L126.829 34.1873L125.444 33.5447L125.172 34.1782L126.657 34.7303L125.625 35.9159L126.132 36.3594L127.127 35.0833Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M157.618 35.6624V35.952C157.618 37.8798 156.758 39.0292 155.373 39.0292C153.988 39.0292 153.128 37.8798 153.128 35.952V35.6624C153.128 33.7346 153.988 32.5852 155.373 32.5852C156.758 32.5852 157.618 33.7346 157.618 35.6624ZM153.88 35.9249C153.88 36.2778 153.907 36.5946 153.961 36.8661L156.541 34.0242C156.287 33.5265 155.889 33.264 155.373 33.264C154.432 33.264 153.88 34.151 153.88 35.6895V35.9249ZM156.866 35.6895C156.866 35.3366 156.839 35.0198 156.785 34.7392L154.206 37.5992C154.468 38.0789 154.866 38.3414 155.373 38.3414C156.314 38.3414 156.866 37.4635 156.866 35.9249V35.6895Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157.785 35.6624V35.952C157.785 36.9381 157.566 37.7464 157.15 38.3127C156.729 38.8849 156.118 39.1968 155.373 39.1968C154.628 39.1968 154.017 38.8849 153.596 38.3127C153.18 37.7464 152.961 36.9381 152.961 35.952V35.6624C152.961 34.6763 153.18 33.868 153.596 33.3016C154.017 32.7294 154.628 32.4175 155.373 32.4175C156.118 32.4175 156.729 32.7294 157.15 33.3016C157.566 33.868 157.785 34.6763 157.785 35.6624ZM153.961 36.8661L156.541 34.0242C156.287 33.5264 155.889 33.264 155.373 33.264C154.432 33.264 153.88 34.1509 153.88 35.6895V35.9248C153.88 36.1902 153.895 36.4351 153.926 36.6557C153.936 36.7285 153.948 36.7987 153.961 36.8661ZM156.336 34.0001L154.075 36.4916C154.057 36.3175 154.047 36.128 154.047 35.9248V35.6895C154.047 34.9364 154.183 34.3651 154.416 33.9878C154.644 33.6191 154.965 33.4316 155.373 33.4316C155.784 33.4316 156.109 33.619 156.336 34.0001ZM156.785 34.7392L154.205 37.5992C154.468 38.0789 154.866 38.3414 155.373 38.3414C156.314 38.3414 156.866 37.4634 156.866 35.9248V35.6895C156.866 35.4226 156.851 35.1763 156.82 34.9508C156.81 34.8781 156.798 34.8076 156.785 34.7392ZM156.671 35.1159L154.412 37.6201C154.647 37.9873 154.972 38.1737 155.373 38.1737C155.782 38.1737 156.103 37.9878 156.33 37.6217C156.563 37.2468 156.699 36.678 156.699 35.9248V35.6895C156.699 35.4847 156.689 35.2935 156.671 35.1159ZM157.618 35.952V35.6624C157.618 33.7346 156.758 32.5852 155.373 32.5852C153.988 32.5852 153.128 33.7346 153.128 35.6624V35.952C153.128 37.8798 153.988 39.0292 155.373 39.0292C156.758 39.0292 157.618 37.8798 157.618 35.952Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M181.322 36.6671C181.322 35.2643 182.263 34.3049 183.612 34.3049C184.96 34.3049 185.902 35.2643 185.902 36.6671C185.902 38.07 184.96 39.0293 183.612 39.0293C182.263 39.0293 181.322 38.07 181.322 36.6671ZM185.141 36.6671C185.141 35.6806 184.526 34.9656 183.612 34.9656C182.698 34.9656 182.082 35.6806 182.082 36.6671C182.082 37.6537 182.698 38.3687 183.612 38.3687C184.526 38.3687 185.141 37.6537 185.141 36.6671Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M181.841 34.8431C182.279 34.3925 182.896 34.1373 183.612 34.1373C184.327 34.1373 184.944 34.3925 185.383 34.8431C185.821 35.2933 186.069 35.9275 186.069 36.6671C186.069 37.4067 185.821 38.0409 185.383 38.4911C184.944 38.9417 184.327 39.1969 183.612 39.1969C182.896 39.1969 182.279 38.9417 181.841 38.4911C181.403 38.0409 181.154 37.4067 181.154 36.6671C181.154 35.9275 181.403 35.2933 181.841 34.8431ZM184.594 35.5577C184.359 35.2925 184.022 35.1332 183.612 35.1332C183.201 35.1332 182.865 35.2925 182.63 35.5577C182.393 35.8245 182.25 36.2083 182.25 36.6671C182.25 37.1259 182.393 37.5097 182.63 37.7765C182.865 38.0417 183.201 38.201 183.612 38.201C184.022 38.201 184.359 38.0417 184.594 37.7765C184.831 37.5097 184.974 37.1259 184.974 36.6671C184.974 36.2083 184.831 35.8245 184.594 35.5577ZM183.612 34.3049C182.263 34.3049 181.322 35.2643 181.322 36.6671C181.322 38.0699 182.263 39.0293 183.612 39.0293C184.96 39.0293 185.902 38.0699 185.902 36.6671C185.902 35.2643 184.96 34.3049 183.612 34.3049ZM183.612 34.9656C184.526 34.9656 185.141 35.6806 185.141 36.6671C185.141 37.6536 184.526 38.3686 183.612 38.3686C182.698 38.3686 182.082 37.6536 182.082 36.6671C182.082 35.6806 182.698 34.9656 183.612 34.9656Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M188.201 33.2279C188.201 32.9563 188.401 32.7572 188.672 32.7572C188.944 32.7572 189.152 32.9563 189.152 33.2279C189.152 33.4995 188.953 33.6896 188.672 33.6896C188.392 33.6896 188.201 33.4904 188.201 33.2279ZM189.84 33.2279C189.84 32.9563 190.057 32.7572 190.32 32.7572C190.582 32.7572 190.79 32.9563 190.79 33.2279C190.79 33.4995 190.591 33.6896 190.32 33.6896C190.048 33.6896 189.84 33.4904 189.84 33.2279Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M188.034 33.2279C188.034 32.8637 188.308 32.5895 188.672 32.5895C189.032 32.5895 189.32 32.8595 189.32 33.2279C189.32 33.4062 189.253 33.5663 189.133 33.6814C189.014 33.7961 188.851 33.8571 188.672 33.8571C188.299 33.8571 188.034 33.5829 188.034 33.2279ZM189.672 33.2279C189.672 32.8575 189.971 32.5895 190.32 32.5895C190.673 32.5895 190.958 32.8616 190.958 33.2279C190.958 33.5963 190.679 33.8571 190.32 33.8571C189.962 33.8571 189.672 33.5892 189.672 33.2279ZM188.672 32.7572C188.401 32.7572 188.201 32.9563 188.201 33.2279C188.201 33.4904 188.392 33.6895 188.672 33.6895C188.953 33.6895 189.152 33.4994 189.152 33.2279C189.152 32.9563 188.944 32.7572 188.672 32.7572ZM190.32 32.7572C190.057 32.7572 189.84 32.9563 189.84 33.2279C189.84 33.4904 190.048 33.6895 190.32 33.6895C190.591 33.6895 190.79 33.4994 190.79 33.2279C190.79 32.9563 190.582 32.7572 190.32 32.7572Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M194.085 33.2279C194.085 32.9563 194.284 32.7572 194.556 32.7572C194.827 32.7572 195.035 32.9563 195.035 33.2279C195.035 33.4995 194.836 33.6896 194.556 33.6896C194.275 33.6896 194.085 33.4904 194.085 33.2279ZM195.723 33.2279C195.723 32.9563 195.941 32.7572 196.203 32.7572C196.466 32.7572 196.674 32.9563 196.674 33.2279C196.674 33.4995 196.475 33.6896 196.203 33.6896C195.932 33.6896 195.723 33.4904 195.723 33.2279Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M193.917 33.2279C193.917 32.8637 194.191 32.5895 194.556 32.5895C194.915 32.5895 195.203 32.8595 195.203 33.2279C195.203 33.4062 195.137 33.5663 195.017 33.6814C194.897 33.7961 194.734 33.8571 194.556 33.8571C194.182 33.8571 193.917 33.5829 193.917 33.2279ZM195.556 33.2279C195.556 32.8575 195.854 32.5895 196.203 32.5895C196.556 32.5895 196.841 32.8616 196.841 33.2279C196.841 33.5963 196.563 33.8571 196.203 33.8571C195.845 33.8571 195.556 33.5892 195.556 33.2279ZM194.556 32.7572C194.284 32.7572 194.085 32.9563 194.085 33.2279C194.085 33.4904 194.275 33.6895 194.556 33.6895C194.836 33.6895 195.035 33.4994 195.035 33.2279C195.035 32.9563 194.827 32.7572 194.556 32.7572ZM196.203 32.7572C195.941 32.7572 195.723 32.9563 195.723 33.2279C195.723 33.4904 195.931 33.6895 196.203 33.6895C196.475 33.6895 196.674 33.4994 196.674 33.2279C196.674 32.9563 196.466 32.7572 196.203 32.7572Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M239.837 33.0741C239.194 33.0831 238.995 33.5448 238.995 33.8887C238.995 33.934 238.995 33.9793 239.013 34.0155C239.085 33.934 239.23 33.8978 239.348 33.8978C239.647 33.8978 239.873 34.0788 239.873 34.4319C239.873 34.7577 239.638 35.0112 239.221 35.0112C238.732 35.0112 238.434 34.5405 238.434 33.9974C238.434 33.1465 238.959 32.6214 239.837 32.6033V33.0741ZM241.765 33.0741C241.122 33.0831 240.923 33.5448 240.923 33.8887C240.923 33.934 240.923 33.9793 240.941 34.0155C241.014 33.934 241.158 33.8978 241.276 33.8978C241.575 33.8978 241.801 34.0788 241.801 34.4319C241.801 34.7577 241.566 35.0112 241.149 35.0112C240.661 35.0112 240.362 34.5405 240.362 33.9974C240.362 33.1465 240.887 32.6214 241.765 32.6033V33.0741Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M240.004 33.2393L239.839 33.2416C239.562 33.2455 239.4 33.3445 239.305 33.4617C239.236 33.5457 239.195 33.6475 239.176 33.7493C239.234 33.7362 239.293 33.7301 239.348 33.7301C239.531 33.7301 239.706 33.7859 239.838 33.911C239.971 34.0376 240.041 34.2181 240.041 34.4318C240.041 34.6364 239.966 34.8271 239.818 34.9659C239.67 35.1044 239.464 35.1788 239.221 35.1788C238.916 35.1788 238.672 35.0297 238.509 34.8069C238.348 34.5875 238.266 34.2976 238.266 33.9973C238.266 33.5368 238.409 33.1467 238.688 32.8692C238.966 32.5922 239.362 32.4454 239.833 32.4357L240.004 32.4322V33.2393ZM239.163 33.9262C239.103 33.9455 239.049 33.9748 239.013 34.0155C238.995 33.9793 238.995 33.934 238.995 33.8888C238.995 33.8651 238.996 33.8408 238.998 33.8162C239.024 33.4833 239.238 33.0825 239.837 33.074V32.6033C239.779 32.6045 239.723 32.6078 239.669 32.6133C238.892 32.6914 238.434 33.2021 238.434 33.9973C238.434 34.5405 238.732 35.0112 239.221 35.0112C239.638 35.0112 239.873 34.7577 239.873 34.4318C239.873 34.0788 239.647 33.8978 239.348 33.8978C239.289 33.8978 239.223 33.9069 239.163 33.9262ZM241.932 33.2393L241.767 33.2416C241.49 33.2455 241.328 33.3445 241.233 33.4617C241.164 33.5457 241.123 33.6475 241.104 33.7493C241.162 33.7362 241.221 33.7301 241.276 33.7301C241.459 33.7301 241.635 33.7859 241.766 33.911C241.899 34.0376 241.969 34.2182 241.969 34.4318C241.969 34.6364 241.894 34.8271 241.746 34.9659C241.598 35.1044 241.392 35.1788 241.149 35.1788C240.844 35.1788 240.6 35.0297 240.437 34.8069C240.276 34.5875 240.194 34.2976 240.194 33.9973C240.194 33.5368 240.337 33.1467 240.616 32.8692C240.894 32.5922 241.29 32.4454 241.761 32.4357L241.932 32.4322V33.2393ZM241.091 33.9262C241.031 33.9455 240.977 33.9748 240.941 34.0155C240.923 33.9792 240.923 33.934 240.923 33.8887C240.923 33.865 240.924 33.8408 240.926 33.8162C240.952 33.4834 241.166 33.0825 241.765 33.074V32.6033C241.707 32.6045 241.652 32.6078 241.597 32.6133C240.82 32.6914 240.362 33.2021 240.362 33.9973C240.362 34.5405 240.66 35.0112 241.149 35.0112C241.566 35.0112 241.801 34.7577 241.801 34.4318C241.801 34.0788 241.575 33.8978 241.276 33.8978C241.217 33.8978 241.151 33.9069 241.091 33.9262Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M256.562 35.8072C256.562 33.798 257.458 32.5852 258.915 32.5852C260.372 32.5852 261.268 33.798 261.268 35.8072C261.268 37.8164 260.372 39.0292 258.915 39.0292C257.458 39.0292 256.562 37.8164 256.562 35.8072ZM260.463 35.8072C260.463 34.1781 259.929 33.3093 258.915 33.3093C257.901 33.3093 257.367 34.1691 257.367 35.8072C257.367 37.4454 257.901 38.3052 258.915 38.3052C259.929 38.3052 260.463 37.4363 260.463 35.8072Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M257.057 33.3436C257.495 32.7454 258.134 32.4175 258.915 32.4175C259.696 32.4175 260.335 32.7454 260.773 33.3436C261.207 33.936 261.436 34.7804 261.436 35.8072C261.436 36.834 261.207 37.6784 260.773 38.2707C260.335 38.8689 259.696 39.1968 258.915 39.1968C258.134 39.1968 257.495 38.8689 257.057 38.2707C256.623 37.6784 256.394 36.834 256.394 35.8072C256.394 34.7804 256.623 33.936 257.057 33.3436ZM259.926 34.0354C259.697 33.6644 259.364 33.4769 258.915 33.4769C258.465 33.4769 258.133 33.6627 257.903 34.0322C257.667 34.4135 257.535 35.0014 257.535 35.8072C257.535 36.6129 257.667 37.2009 257.903 37.5821C258.133 37.9517 258.465 38.1375 258.915 38.1375C259.364 38.1375 259.697 37.95 259.926 37.5789C260.163 37.1963 260.295 36.6082 260.295 35.8072C260.295 35.0061 260.163 34.418 259.926 34.0354ZM258.915 32.5852C257.458 32.5852 256.562 33.7979 256.562 35.8072C256.562 37.8164 257.458 39.0292 258.915 39.0292C260.372 39.0292 261.268 37.8164 261.268 35.8072C261.268 33.7979 260.372 32.5852 258.915 32.5852ZM258.915 33.3092C259.929 33.3092 260.463 34.1781 260.463 35.8072C260.463 37.4363 259.929 38.3051 258.915 38.3051C257.901 38.3051 257.367 37.4453 257.367 35.8072C257.367 34.169 257.901 33.3092 258.915 33.3092Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M427.776 36.3327C427.776 35.9978 428.021 35.7715 428.347 35.7715C428.673 35.7715 428.917 35.9978 428.917 36.3327C428.917 36.6677 428.673 36.894 428.347 36.894C428.021 36.894 427.776 36.6677 427.776 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M427.609 36.3327C427.609 35.8999 427.933 35.6038 428.347 35.6038C428.76 35.6038 429.084 35.8999 429.084 36.3327C429.084 36.7655 428.76 37.0615 428.347 37.0615C427.934 37.0615 427.609 36.7655 427.609 36.3327ZM428.347 35.7714C428.021 35.7714 427.776 35.9978 427.776 36.3327C427.776 36.6676 428.021 36.8939 428.347 36.8939C428.672 36.8939 428.917 36.6676 428.917 36.3327C428.917 35.9978 428.672 35.7714 428.347 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M484.252 36.3327C484.252 35.9978 484.496 35.7715 484.822 35.7715C485.148 35.7715 485.393 35.9978 485.393 36.3327C485.393 36.6677 485.148 36.894 484.822 36.894C484.496 36.894 484.252 36.6677 484.252 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M484.084 36.3327C484.084 35.8999 484.409 35.6038 484.822 35.6038C485.235 35.6038 485.56 35.8999 485.56 36.3327C485.56 36.7655 485.235 37.0615 484.822 37.0615C484.409 37.0615 484.084 36.7655 484.084 36.3327ZM484.822 35.7714C484.496 35.7714 484.252 35.9978 484.252 36.3327C484.252 36.6676 484.496 36.8939 484.822 36.8939C485.148 36.8939 485.393 36.6676 485.393 36.3327C485.393 35.9978 485.148 35.7714 484.822 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M493.666 36.3327C493.666 35.9978 493.91 35.7715 494.236 35.7715C494.562 35.7715 494.806 35.9978 494.806 36.3327C494.806 36.6677 494.562 36.894 494.236 36.894C493.91 36.894 493.666 36.6677 493.666 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M493.498 36.3327C493.498 35.8999 493.823 35.6038 494.236 35.6038C494.649 35.6038 494.974 35.8999 494.974 36.3327C494.974 36.7655 494.649 37.0615 494.236 37.0615C493.823 37.0615 493.498 36.7655 493.498 36.3327ZM494.236 35.7714C493.91 35.7714 493.666 35.9978 493.666 36.3327C493.666 36.6676 493.91 36.8939 494.236 36.8939C494.562 36.8939 494.806 36.6676 494.806 36.3327C494.806 35.9978 494.562 35.7714 494.236 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M503.077 36.3327C503.077 35.9978 503.322 35.7715 503.647 35.7715C503.973 35.7715 504.218 35.9978 504.218 36.3327C504.218 36.6677 503.973 36.894 503.647 36.894C503.322 36.894 503.077 36.6677 503.077 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M502.91 36.3327C502.91 35.8999 503.234 35.6038 503.647 35.6038C504.061 35.6038 504.385 35.8999 504.385 36.3327C504.385 36.7655 504.06 37.0615 503.647 37.0615C503.234 37.0615 502.91 36.7655 502.91 36.3327ZM503.647 35.7714C503.322 35.7714 503.077 35.9978 503.077 36.3327C503.077 36.6676 503.322 36.8939 503.647 36.8939C503.973 36.8939 504.218 36.6676 504.218 36.3327C504.218 35.9978 503.973 35.7714 503.647 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M549.064 39.8777L551.625 32.368H552.359L549.797 39.8777H549.064Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M548.83 40.0453L551.506 32.2003H552.593L549.917 40.0453H548.83ZM549.064 39.8777H549.797L552.359 32.3679H551.625L549.064 39.8777Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M554.948 39.8777L557.509 32.368H558.242L555.681 39.8777H554.948Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M554.713 40.0453L557.389 32.2003H558.476L555.801 40.0453H554.713ZM554.948 39.8777H555.681L558.242 32.3679H557.509L554.948 39.8777Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M578.38 36.3327C578.38 35.9978 578.625 35.7715 578.951 35.7715C579.276 35.7715 579.521 35.9978 579.521 36.3327C579.521 36.6677 579.276 36.894 578.951 36.894C578.625 36.894 578.38 36.6677 578.38 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M578.213 36.3327C578.213 35.8999 578.537 35.6038 578.951 35.6038C579.364 35.6038 579.688 35.8999 579.688 36.3327C579.688 36.7655 579.364 37.0615 578.951 37.0615C578.538 37.0615 578.213 36.7655 578.213 36.3327ZM578.951 35.7714C578.625 35.7714 578.38 35.9978 578.38 36.3327C578.38 36.6676 578.625 36.8939 578.951 36.8939C579.276 36.8939 579.521 36.6676 579.521 36.3327C579.521 35.9978 579.276 35.7714 578.951 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M584.264 36.3327C584.264 35.9978 584.508 35.7715 584.834 35.7715C585.16 35.7715 585.404 35.9978 585.404 36.3327C585.404 36.6677 585.16 36.894 584.834 36.894C584.508 36.894 584.264 36.6677 584.264 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M584.096 36.3327C584.096 35.8999 584.421 35.6038 584.834 35.6038C585.247 35.6038 585.572 35.8999 585.572 36.3327C585.572 36.7655 585.247 37.0615 584.834 37.0615C584.421 37.0615 584.096 36.7655 584.096 36.3327ZM584.834 35.7714C584.508 35.7714 584.264 35.9978 584.264 36.3327C584.264 36.6676 584.508 36.8939 584.834 36.8939C585.16 36.8939 585.404 36.6676 585.404 36.3327C585.404 35.9978 585.16 35.7714 584.834 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M590.147 36.3327C590.147 35.9978 590.392 35.7715 590.718 35.7715C591.044 35.7715 591.288 35.9978 591.288 36.3327C591.288 36.6677 591.044 36.894 590.718 36.894C590.392 36.894 590.147 36.6677 590.147 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M589.98 36.3327C589.98 35.8999 590.305 35.6038 590.718 35.6038C591.131 35.6038 591.456 35.8999 591.456 36.3327C591.456 36.7655 591.131 37.0615 590.718 37.0615C590.305 37.0615 589.98 36.7655 589.98 36.3327ZM590.718 35.7714C590.392 35.7714 590.147 35.9978 590.147 36.3327C590.147 36.6676 590.392 36.8939 590.718 36.8939C591.044 36.8939 591.288 36.6676 591.288 36.3327C591.288 35.9978 591.044 35.7714 590.718 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M596.031 36.3327C596.031 35.9978 596.275 35.7715 596.601 35.7715C596.927 35.7715 597.172 35.9978 597.172 36.3327C597.172 36.6677 596.927 36.894 596.601 36.894C596.275 36.894 596.031 36.6677 596.031 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M595.863 36.3327C595.863 35.8999 596.188 35.6038 596.601 35.6038C597.014 35.6038 597.339 35.8999 597.339 36.3327C597.339 36.7655 597.014 37.0615 596.601 37.0615C596.188 37.0615 595.863 36.7655 595.863 36.3327ZM596.601 35.7714C596.275 35.7714 596.031 35.9978 596.031 36.3327C596.031 36.6676 596.275 36.8939 596.601 36.8939C596.927 36.8939 597.172 36.6676 597.172 36.3327C597.172 35.9978 596.927 35.7714 596.601 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M616.031 36.3327C616.031 35.9978 616.275 35.7715 616.601 35.7715C616.927 35.7715 617.171 35.9978 617.171 36.3327C617.171 36.6677 616.927 36.894 616.601 36.894C616.275 36.894 616.031 36.6677 616.031 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M615.863 36.3327C615.863 35.8999 616.188 35.6038 616.601 35.6038C617.014 35.6038 617.339 35.8999 617.339 36.3327C617.339 36.7655 617.014 37.0615 616.601 37.0615C616.188 37.0615 615.863 36.7655 615.863 36.3327ZM616.601 35.7714C616.275 35.7714 616.031 35.9978 616.031 36.3327C616.031 36.6676 616.275 36.8939 616.601 36.8939C616.927 36.8939 617.171 36.6676 617.171 36.3327C617.171 35.9978 616.927 35.7714 616.601 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M621.914 36.3327C621.914 35.9978 622.159 35.7715 622.485 35.7715C622.81 35.7715 623.055 35.9978 623.055 36.3327C623.055 36.6677 622.81 36.894 622.485 36.894C622.159 36.894 621.914 36.6677 621.914 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M621.747 36.3327C621.747 35.8999 622.071 35.6038 622.485 35.6038C622.898 35.6038 623.222 35.8999 623.222 36.3327C623.222 36.7655 622.898 37.0615 622.485 37.0615C622.072 37.0615 621.747 36.7655 621.747 36.3327ZM622.485 35.7714C622.159 35.7714 621.914 35.9978 621.914 36.3327C621.914 36.6676 622.159 36.8939 622.485 36.8939C622.81 36.8939 623.055 36.6676 623.055 36.3327C623.055 35.9978 622.81 35.7714 622.485 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M634.858 36.3327C634.858 35.9978 635.103 35.7715 635.429 35.7715C635.754 35.7715 635.999 35.9978 635.999 36.3327C635.999 36.6677 635.754 36.894 635.429 36.894C635.103 36.894 634.858 36.6677 634.858 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M634.691 36.3327C634.691 35.8999 635.015 35.6038 635.429 35.6038C635.842 35.6038 636.166 35.8999 636.166 36.3327C636.166 36.7655 635.842 37.0615 635.429 37.0615C635.015 37.0615 634.691 36.7655 634.691 36.3327ZM635.429 35.7714C635.103 35.7714 634.858 35.9978 634.858 36.3327C634.858 36.6676 635.103 36.8939 635.429 36.8939C635.754 36.8939 635.999 36.6676 635.999 36.3327C635.999 35.9978 635.754 35.7714 635.429 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M640.742 36.3327C640.742 35.9978 640.986 35.7715 641.312 35.7715C641.638 35.7715 641.882 35.9978 641.882 36.3327C641.882 36.6677 641.638 36.894 641.312 36.894C640.986 36.894 640.742 36.6677 640.742 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M640.574 36.3327C640.574 35.8999 640.899 35.6038 641.312 35.6038C641.725 35.6038 642.05 35.8999 642.05 36.3327C642.05 36.7655 641.725 37.0615 641.312 37.0615C640.899 37.0615 640.574 36.7655 640.574 36.3327ZM641.312 35.7714C640.986 35.7714 640.742 35.9978 640.742 36.3327C640.742 36.6676 640.986 36.8939 641.312 36.8939C641.638 36.8939 641.882 36.6676 641.882 36.3327C641.882 35.9978 641.638 35.7714 641.312 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M646.625 36.3327C646.625 35.9978 646.87 35.7715 647.196 35.7715C647.522 35.7715 647.766 35.9978 647.766 36.3327C647.766 36.6677 647.522 36.894 647.196 36.894C646.87 36.894 646.625 36.6677 646.625 36.3327Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M646.458 36.3327C646.458 35.8999 646.783 35.6038 647.196 35.6038C647.609 35.6038 647.934 35.8999 647.934 36.3327C647.934 36.7655 647.609 37.0615 647.196 37.0615C646.783 37.0615 646.458 36.7655 646.458 36.3327ZM647.196 35.7714C646.87 35.7714 646.625 35.9978 646.625 36.3327C646.625 36.6676 646.87 36.8939 647.196 36.8939C647.522 36.8939 647.766 36.6676 647.766 36.3327C647.766 35.9978 647.522 35.7714 647.196 35.7714Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M652.509 38.4576C652.509 38.1226 652.754 37.8963 653.079 37.8963C653.405 37.8963 653.65 38.1226 653.65 38.4576C653.65 38.7925 653.405 39.0188 653.079 39.0188C652.754 39.0188 652.509 38.7925 652.509 38.4576Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M652.341 38.4575C652.341 38.0247 652.666 37.7286 653.079 37.7286C653.492 37.7286 653.817 38.0247 653.817 38.4575C653.817 38.8903 653.492 39.1864 653.079 39.1864C652.666 39.1864 652.341 38.8903 652.341 38.4575ZM653.079 37.8963C652.753 37.8963 652.509 38.1226 652.509 38.4575C652.509 38.7924 652.753 39.0187 653.079 39.0187C653.405 39.0187 653.65 38.7924 653.65 38.4575C653.65 38.1226 653.405 37.8963 653.079 37.8963Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M658.393 38.4576C658.393 38.1226 658.637 37.8963 658.963 37.8963C659.289 37.8963 659.533 38.1226 659.533 38.4576C659.533 38.7925 659.289 39.0188 658.963 39.0188C658.637 39.0188 658.393 38.7925 658.393 38.4576Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M658.225 38.4575C658.225 38.0247 658.55 37.7286 658.963 37.7286C659.376 37.7286 659.701 38.0247 659.701 38.4575C659.701 38.8903 659.376 39.1864 658.963 39.1864C658.55 39.1864 658.225 38.8903 658.225 38.4575ZM658.963 37.8963C658.637 37.8963 658.393 38.1226 658.393 38.4575C658.393 38.7924 658.637 39.0187 658.963 39.0187C659.289 39.0187 659.533 38.7924 659.533 38.4575C659.533 38.1226 659.289 37.8963 658.963 37.8963Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M664.276 38.4576C664.276 38.1226 664.52 37.8963 664.846 37.8963C665.172 37.8963 665.417 38.1226 665.417 38.4576C665.417 38.7925 665.172 39.0188 664.846 39.0188C664.52 39.0188 664.276 38.7925 664.276 38.4576Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M664.108 38.4575C664.108 38.0247 664.433 37.7286 664.846 37.7286C665.259 37.7286 665.584 38.0247 665.584 38.4575C665.584 38.8903 665.259 39.1864 664.846 39.1864C664.433 39.1864 664.108 38.8903 664.108 38.4575ZM664.846 37.8963C664.52 37.8963 664.276 38.1226 664.276 38.4575C664.276 38.7924 664.52 39.0187 664.846 39.0187C665.172 39.0187 665.416 38.7924 665.416 38.4575C665.416 38.1226 665.172 37.8963 664.846 37.8963Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M700.748 38.4576C700.748 38.1226 700.992 37.8963 701.318 37.8963C701.644 37.8963 701.888 38.1226 701.888 38.4576C701.888 38.7925 701.644 39.0188 701.318 39.0188C700.992 39.0188 700.748 38.7925 700.748 38.4576Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M700.58 38.4575C700.58 38.0247 700.905 37.7286 701.318 37.7286C701.731 37.7286 702.056 38.0247 702.056 38.4575C702.056 38.8903 701.731 39.1864 701.318 39.1864C700.905 39.1864 700.58 38.8903 700.58 38.4575ZM701.318 37.8963C700.992 37.8963 700.748 38.1226 700.748 38.4575C700.748 38.7924 700.992 39.0187 701.318 39.0187C701.644 39.0187 701.888 38.7924 701.888 38.4575C701.888 38.1226 701.644 37.8963 701.318 37.8963Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M35.0263 49.1316H33.3972V54.1637H35.0263V54.8154H30.9807V54.1637H32.6098V49.1316H30.9807V48.48H35.0263V49.1316Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.1939 49.2992H33.5648V53.9961H35.1939V54.983H30.813V53.9961H32.4422V49.2992H30.813V48.3123H35.1939V49.2992ZM32.6098 49.1316V54.1637H30.9807V54.8154H35.0263V54.1637H33.3972V49.1316H35.0263V48.4799H30.9807V49.1316H32.6098Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M59.2559 51.3945V50.7157H63.2382V51.3945H59.2559ZM59.2559 53.5395V52.8607H63.2382V53.5395H59.2559Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.0883 51.5621V50.548H63.4058V51.5621H59.0883ZM59.0883 53.7071V52.693H63.4058V53.7071H59.0883ZM59.2559 51.3945H63.2381V50.7157H59.2559V51.3945ZM59.2559 53.5394H63.2381V52.8606H59.2559V53.5394Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M65.1395 51.3945V50.7157H69.1217V51.3945H65.1395ZM65.1395 53.5395V52.8607H69.1217V53.5395H65.1395Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.9719 51.5621V50.548H69.2894V51.5621H64.9719ZM64.9719 53.7071V52.693H69.2894V53.7071H64.9719ZM65.1395 51.3945H69.1217V50.7157H65.1395V51.3945ZM65.1395 53.5394H69.1217V52.8606H65.1395V53.5394Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M77.7642 51.8649L79.7372 48.48H80.3979L82.38 51.8649H81.6198L80.045 49.204L78.4883 51.8649H77.7642Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.4725 52.0325L79.641 48.3123H80.4941L82.6725 52.0325H81.5242L80.0458 49.5345L78.5844 52.0325H77.4725ZM80.045 49.204L81.6198 51.8649H82.3801L80.398 48.4799H79.7373L77.7643 51.8649H78.4883L80.045 49.204Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M83.6479 51.8649L85.6209 48.48H86.2816L88.2637 51.8649H87.5034L85.9286 49.204L84.3719 51.8649H83.6479Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.3561 52.0325L85.5245 48.3123H86.3777L88.556 52.0325H87.4078L85.9294 49.5345L84.468 52.0325H83.3561ZM85.9286 49.204L87.5034 51.8649H88.2636L86.2816 48.4799H85.6209L83.6478 51.8649H84.3719L85.9286 49.204Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M115.433 52.5079C115.433 51.1051 116.374 50.1457 117.723 50.1457C119.071 50.1457 120.012 51.1051 120.012 52.5079C120.012 53.9107 119.071 54.8701 117.723 54.8701C116.374 54.8701 115.433 53.9107 115.433 52.5079ZM119.252 52.5079C119.252 51.5214 118.637 50.8064 117.723 50.8064C116.808 50.8064 116.193 51.5214 116.193 52.5079C116.193 53.4944 116.808 54.2094 117.723 54.2094C118.637 54.2094 119.252 53.4944 119.252 52.5079Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.952 50.6838C116.39 50.2333 117.007 49.978 117.723 49.978C118.438 49.978 119.055 50.2333 119.493 50.6838C119.931 51.134 120.18 51.7683 120.18 52.5079C120.18 53.2475 119.931 53.8817 119.493 54.3319C119.055 54.7824 118.438 55.0377 117.723 55.0377C117.007 55.0377 116.39 54.7824 115.952 54.3319C115.514 53.8817 115.265 53.2475 115.265 52.5079C115.265 51.7683 115.514 51.134 115.952 50.6838ZM118.705 51.3984C118.469 51.1333 118.133 50.974 117.723 50.974C117.312 50.974 116.976 51.1333 116.74 51.3984C116.504 51.6653 116.361 52.0491 116.361 52.5079C116.361 52.9667 116.504 53.3505 116.74 53.6173C116.976 53.8825 117.312 54.0418 117.723 54.0418C118.133 54.0418 118.469 53.8825 118.705 53.6173C118.942 53.3505 119.084 52.9667 119.084 52.5079C119.084 52.0491 118.942 51.6653 118.705 51.3984ZM117.723 50.1457C116.374 50.1457 115.433 51.105 115.433 52.5079C115.433 53.9107 116.374 54.8701 117.723 54.8701C119.071 54.8701 120.012 53.9107 120.012 52.5079C120.012 51.105 119.071 50.1457 117.723 50.1457ZM117.723 50.8064C118.637 50.8064 119.252 51.5214 119.252 52.5079C119.252 53.4944 118.637 54.2094 117.723 54.2094C116.808 54.2094 116.193 53.4944 116.193 52.5079C116.193 51.5214 116.808 50.8064 117.723 50.8064Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M166.805 49.1316H165.176V54.1637H166.805V54.8154H162.759V54.1637H164.389V49.1316H162.759V48.48H166.805V49.1316Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M166.973 49.2992H165.343V53.9961H166.973V54.983H162.592V53.9961H164.221V49.2992H162.592V48.3123H166.973V49.2992ZM164.388 49.1316V54.1637H162.759V54.8154H166.805V54.1637H165.176V49.1316H166.805V48.4799H162.759V49.1316H164.388Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M192.456 52.1733C192.456 51.8384 192.7 51.6121 193.026 51.6121C193.352 51.6121 193.596 51.8384 193.596 52.1733C193.596 52.5082 193.352 52.7345 193.026 52.7345C192.7 52.7345 192.456 52.5082 192.456 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M192.288 52.1733C192.288 51.7405 192.613 51.4444 193.026 51.4444C193.439 51.4444 193.764 51.7405 193.764 52.1733C193.764 52.6061 193.439 52.9021 193.026 52.9021C192.613 52.9021 192.288 52.6061 192.288 52.1733ZM193.026 51.612C192.7 51.612 192.456 51.8383 192.456 52.1733C192.456 52.5082 192.7 52.7345 193.026 52.7345C193.352 52.7345 193.596 52.5082 193.596 52.1733C193.596 51.8383 193.352 51.612 193.026 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M198.339 52.1733C198.339 51.8384 198.584 51.6121 198.91 51.6121C199.235 51.6121 199.48 51.8384 199.48 52.1733C199.48 52.5082 199.235 52.7345 198.91 52.7345C198.584 52.7345 198.339 52.5082 198.339 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M198.172 52.1733C198.172 51.7405 198.496 51.4444 198.91 51.4444C199.323 51.4444 199.647 51.7405 199.647 52.1733C199.647 52.6061 199.323 52.9021 198.91 52.9021C198.496 52.9021 198.172 52.6061 198.172 52.1733ZM198.91 51.612C198.584 51.612 198.339 51.8383 198.339 52.1733C198.339 52.5082 198.584 52.7345 198.91 52.7345C199.235 52.7345 199.48 52.5082 199.48 52.1733C199.48 51.8383 199.235 51.612 198.91 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M204.422 54.1798V52.3516H202.702V51.6728H204.422V49.8536H205.164V51.6728H206.893V52.3516H205.164V54.1798H204.422Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M204.254 54.3475V52.5192H202.535V51.5052H204.254V49.686H205.332V51.5052H207.06V52.5192H205.332V54.3475H204.254ZM205.164 52.3516H206.893V51.6728H205.164V49.8537H204.422V51.6728H202.702V52.3516H204.422V54.1798H205.164V52.3516Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M210.305 54.1798V52.3516H208.586V51.6728H210.305V49.8536H211.048V51.6728H212.776V52.3516H211.048V54.1798H210.305Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M210.138 54.3475V52.5192H208.418V51.5052H210.138V49.686H211.215V51.5052H212.944V52.5192H211.215V54.3475H210.138ZM211.047 52.3516H212.776V51.6728H211.047V49.8537H210.305V51.6728H208.586V52.3516H210.305V54.1798H211.047V52.3516Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M230.305 54.1798V52.3516H228.585V51.6728H230.305V49.8536H231.047V51.6728H232.776V52.3516H231.047V54.1798H230.305Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M230.137 54.3475V52.5192H228.418V51.5052H230.137V49.686H231.215V51.5052H232.943V52.5192H231.215V54.3475H230.137ZM231.047 52.3516H232.776V51.6728H231.047V49.8537H230.305V51.6728H228.585V52.3516H230.305V54.1798H231.047V52.3516Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M275.432 51.8649L277.405 48.48H278.066L280.048 51.8649H279.288L277.713 49.204L276.156 51.8649H275.432Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M275.141 52.0325L277.309 48.3123H278.162L280.34 52.0325H279.192L277.714 49.5345L276.252 52.0325H275.141ZM277.713 49.204L279.288 51.8649H280.048L278.066 48.4799H277.405L275.432 51.8649H276.156L277.713 49.204Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M281.316 51.8649L283.289 48.48H283.95L285.932 51.8649H285.171L283.597 49.204L282.04 51.8649H281.316Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M281.024 52.0325L283.193 48.3123H284.046L286.224 52.0325H285.076L283.597 49.5345L282.136 52.0325H281.024ZM283.597 49.204L285.171 51.8649H285.932L283.949 48.4799H283.289L281.316 51.8649H282.04L283.597 49.204Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M324.234 54.2981C324.234 53.9631 324.479 53.7368 324.805 53.7368C325.13 53.7368 325.375 53.9631 325.375 54.2981C325.375 54.633 325.13 54.8593 324.805 54.8593C324.479 54.8593 324.234 54.633 324.234 54.2981Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M324.067 54.2981C324.067 53.8653 324.392 53.5692 324.805 53.5692C325.218 53.5692 325.542 53.8653 325.542 54.2981C325.542 54.7309 325.218 55.0269 324.805 55.0269C324.392 55.0269 324.067 54.7309 324.067 54.2981ZM324.805 53.7368C324.479 53.7368 324.234 53.9632 324.234 54.2981C324.234 54.633 324.479 54.8593 324.805 54.8593C325.13 54.8593 325.375 54.633 325.375 54.2981C325.375 53.9632 325.13 53.7368 324.805 53.7368Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M330.118 54.2981C330.118 53.9631 330.362 53.7368 330.688 53.7368C331.014 53.7368 331.258 53.9631 331.258 54.2981C331.258 54.633 331.014 54.8593 330.688 54.8593C330.362 54.8593 330.118 54.633 330.118 54.2981Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M329.95 54.2981C329.95 53.8653 330.275 53.5692 330.688 53.5692C331.101 53.5692 331.426 53.8653 331.426 54.2981C331.426 54.7309 331.101 55.0269 330.688 55.0269C330.275 55.0269 329.95 54.7309 329.95 54.2981ZM330.688 53.7368C330.362 53.7368 330.118 53.9632 330.118 54.2981C330.118 54.633 330.362 54.8593 330.688 54.8593C331.014 54.8593 331.258 54.633 331.258 54.2981C331.258 53.9632 331.014 53.7368 330.688 53.7368Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M334.264 51.8649L336.237 48.48H336.897L338.879 51.8649H338.119L336.544 49.204L334.988 51.8649H334.264Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M333.972 52.0325L336.14 48.3123H336.993L339.172 52.0325H338.023L336.545 49.5345L335.084 52.0325H333.972ZM336.544 49.204L338.119 51.8649H338.879L336.897 48.4799H336.237L334.264 51.8649H334.988L336.544 49.204Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M362.086 54.1798V52.3516H360.366V51.6728H362.086V49.8536H362.828V51.6728H364.557V52.3516H362.828V54.1798H362.086Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M361.918 54.3475V52.5192H360.199V51.5052H361.918V49.686H362.996V51.5052H364.724V52.5192H362.996V54.3475H361.918ZM362.828 52.3516H364.557V51.6728H362.828V49.8537H362.086V51.6728H360.366V52.3516H362.086V54.1798H362.828V52.3516Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M367.97 54.1798V52.3516H366.25V51.6728H367.97V49.8536H368.712V51.6728H370.44V52.3516H368.712V54.1798H367.97Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M367.802 54.3475V52.5192H366.082V51.5052H367.802V49.686H368.879V51.5052H370.608V52.5192H368.879V54.3475H367.802ZM368.712 52.3516H370.44V51.6728H368.712V49.8537H367.97V51.6728H366.25V52.3516H367.97V54.1798H368.712V52.3516Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M388.684 54.8132V48.4778H390.829C392.096 48.4778 392.938 49.238 392.938 50.4237C392.938 51.3106 392.404 51.9985 391.59 52.2247L393.011 54.8132H392.124L390.784 52.3786H389.472V54.8132H388.684ZM389.472 51.6545H390.766C391.599 51.6545 392.133 51.1658 392.133 50.4237C392.133 49.6815 391.599 49.2018 390.775 49.2018H389.472V51.6545Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M388.517 54.9807V48.3101H390.829C391.496 48.3101 392.067 48.5104 392.472 48.8825C392.879 49.2559 393.106 49.7891 393.106 50.4236C393.106 51.3113 392.608 52.0225 391.833 52.3205L393.294 54.9807H392.025L390.685 52.5461H389.639V54.9807H388.517ZM389.472 52.3785H390.784L392.124 54.8131H393.011L391.59 52.2246C391.645 52.2092 391.699 52.1917 391.752 52.1721C392.474 51.9038 392.938 51.2501 392.938 50.4236C392.938 49.2379 392.096 48.4777 390.829 48.4777H388.684V54.8131H389.472V52.3785ZM389.639 51.4868H390.766C391.15 51.4868 391.449 51.3744 391.649 51.193C391.848 51.013 391.965 50.7523 391.965 50.4236C391.965 50.0949 391.848 49.8366 391.651 49.659C391.451 49.4797 391.155 49.3694 390.775 49.3694H389.639V51.4868ZM390.766 51.6544C391.599 51.6544 392.133 51.1657 392.133 50.4236C392.133 49.6814 391.599 49.2017 390.775 49.2017H389.472V51.6544H390.766Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M418.363 52.1733C418.363 51.8384 418.607 51.6121 418.933 51.6121C419.259 51.6121 419.503 51.8384 419.503 52.1733C419.503 52.5082 419.259 52.7345 418.933 52.7345C418.607 52.7345 418.363 52.5082 418.363 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M418.195 52.1733C418.195 51.7405 418.52 51.4444 418.933 51.4444C419.346 51.4444 419.671 51.7405 419.671 52.1733C419.671 52.6061 419.346 52.9021 418.933 52.9021C418.52 52.9021 418.195 52.6061 418.195 52.1733ZM418.933 51.612C418.607 51.612 418.363 51.8383 418.363 52.1733C418.363 52.5082 418.607 52.7345 418.933 52.7345C419.259 52.7345 419.503 52.5082 419.503 52.1733C419.503 51.8383 419.259 51.612 418.933 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M424.246 52.1733C424.246 51.8384 424.491 51.6121 424.817 51.6121C425.142 51.6121 425.387 51.8384 425.387 52.1733C425.387 52.5082 425.142 52.7345 424.817 52.7345C424.491 52.7345 424.246 52.5082 424.246 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M424.078 52.1733C424.078 51.7405 424.403 51.4444 424.816 51.4444C425.229 51.4444 425.554 51.7405 425.554 52.1733C425.554 52.6061 425.229 52.9021 424.816 52.9021C424.403 52.9021 424.078 52.6061 424.078 52.1733ZM424.816 51.612C424.491 51.612 424.246 51.8383 424.246 52.1733C424.246 52.5082 424.491 52.7345 424.816 52.7345C425.142 52.7345 425.387 52.5082 425.387 52.1733C425.387 51.8383 425.142 51.612 424.816 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M430.13 52.1733C430.13 51.8384 430.374 51.6121 430.7 51.6121C431.026 51.6121 431.27 51.8384 431.27 52.1733C431.27 52.5082 431.026 52.7345 430.7 52.7345C430.374 52.7345 430.13 52.5082 430.13 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M429.962 52.1733C429.962 51.7405 430.287 51.4444 430.7 51.4444C431.113 51.4444 431.438 51.7405 431.438 52.1733C431.438 52.6061 431.113 52.9021 430.7 52.9021C430.287 52.9021 429.962 52.6061 429.962 52.1733ZM430.7 51.612C430.374 51.612 430.13 51.8383 430.13 52.1733C430.13 52.5082 430.374 52.7345 430.7 52.7345C431.026 52.7345 431.27 52.5082 431.27 52.1733C431.27 51.8383 431.026 51.612 430.7 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M486.976 54.1344V54.8132H482.976V54.1344H484.605V50.8762H482.976V50.1974H485.347V54.1344H486.976ZM484.388 48.7855C484.388 48.4507 484.65 48.1973 484.985 48.1973C485.32 48.1973 485.582 48.4507 485.582 48.7855C485.582 49.1204 485.32 49.3829 484.985 49.3829C484.65 49.3829 484.388 49.1295 484.388 48.7855Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M487.144 53.9668V54.9808H482.808V53.9668H484.437V51.0438H482.808V50.0298H485.515V53.9668H487.144ZM484.605 50.8762V54.1344H482.976V54.8132H486.976V54.1344H485.347V50.1974H482.976V50.8762H484.605ZM484.22 48.7855C484.22 48.3547 484.561 48.0296 484.985 48.0296C485.409 48.0296 485.75 48.3547 485.75 48.7855C485.75 49.213 485.412 49.5505 484.985 49.5505C484.559 49.5505 484.22 49.2237 484.22 48.7855ZM484.985 48.1972C484.65 48.1972 484.388 48.4506 484.388 48.7855C484.388 49.1294 484.65 49.3828 484.985 49.3828C485.32 49.3828 485.582 49.1204 485.582 48.7855C485.582 48.4506 485.32 48.1972 484.985 48.1972Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M493.666 52.1733C493.666 51.8384 493.91 51.6121 494.236 51.6121C494.562 51.6121 494.806 51.8384 494.806 52.1733C494.806 52.5082 494.562 52.7345 494.236 52.7345C493.91 52.7345 493.666 52.5082 493.666 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M493.498 52.1733C493.498 51.7405 493.823 51.4444 494.236 51.4444C494.649 51.4444 494.974 51.7405 494.974 52.1733C494.974 52.6061 494.649 52.9021 494.236 52.9021C493.823 52.9021 493.498 52.6061 493.498 52.1733ZM494.236 51.612C493.91 51.612 493.666 51.8383 493.666 52.1733C493.666 52.5082 493.91 52.7345 494.236 52.7345C494.562 52.7345 494.806 52.5082 494.806 52.1733C494.806 51.8383 494.562 51.612 494.236 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M499.549 52.1733C499.549 51.8384 499.794 51.6121 500.12 51.6121C500.445 51.6121 500.69 51.8384 500.69 52.1733C500.69 52.5082 500.445 52.7345 500.12 52.7345C499.794 52.7345 499.549 52.5082 499.549 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M499.382 52.1733C499.382 51.7405 499.707 51.4444 500.12 51.4444C500.533 51.4444 500.857 51.7405 500.857 52.1733C500.857 52.6061 500.533 52.9021 500.12 52.9021C499.707 52.9021 499.382 52.6061 499.382 52.1733ZM500.12 51.612C499.794 51.612 499.549 51.8383 499.549 52.1733C499.549 52.5082 499.794 52.7345 500.12 52.7345C500.445 52.7345 500.69 52.5082 500.69 52.1733C500.69 51.8383 500.445 51.612 500.12 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M508.247 51.5029V51.7925C508.247 53.7203 507.388 54.8697 506.003 54.8697C504.618 54.8697 503.758 53.7203 503.758 51.7925V51.5029C503.758 49.5751 504.618 48.4257 506.003 48.4257C507.388 48.4257 508.247 49.5751 508.247 51.5029ZM504.509 51.7653C504.509 52.1183 504.537 52.4351 504.591 52.7066L507.17 49.8647C506.917 49.3669 506.519 49.1045 506.003 49.1045C505.062 49.1045 504.509 49.9914 504.509 51.53V51.7653ZM507.496 51.53C507.496 51.177 507.469 50.8603 507.415 50.5797L504.835 53.4397C505.098 53.9194 505.496 54.1818 506.003 54.1818C506.944 54.1818 507.496 53.3039 507.496 51.7653V51.53Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M508.415 51.5028V51.7924C508.415 52.7785 508.195 53.5868 507.779 54.1532C507.359 54.7254 506.747 55.0373 506.003 55.0373C505.258 55.0373 504.646 54.7254 504.226 54.1532C503.81 53.5868 503.591 52.7785 503.591 51.7924V51.5028C503.591 50.5167 503.81 49.7084 504.226 49.1421C504.646 48.5699 505.258 48.258 506.003 48.258C506.747 48.258 507.359 48.5699 507.779 49.1421C508.195 49.7084 508.415 50.5167 508.415 51.5028ZM504.591 52.7066L507.17 49.8647C506.917 49.3669 506.519 49.1044 506.003 49.1044C505.062 49.1044 504.509 49.9914 504.509 51.53V51.7653C504.509 52.0307 504.525 52.2756 504.555 52.4962C504.566 52.569 504.577 52.6392 504.591 52.7066ZM506.966 49.8406L504.704 52.3321C504.686 52.1579 504.677 51.9685 504.677 51.7653V51.53C504.677 50.7769 504.813 50.2056 505.046 49.8283C505.273 49.4596 505.595 49.272 506.003 49.272C506.414 49.272 506.739 49.4595 506.966 49.8406ZM507.415 50.5797L504.835 53.4397C505.098 53.9193 505.496 54.1818 506.003 54.1818C506.944 54.1818 507.496 53.3039 507.496 51.7653V51.53C507.496 51.263 507.481 51.0168 507.45 50.7913C507.44 50.7186 507.428 50.6481 507.415 50.5797ZM507.301 50.9564L505.042 53.4605C505.277 53.8277 505.601 54.0142 506.003 54.0142C506.411 54.0142 506.733 53.8282 506.96 53.4621C507.193 53.0873 507.328 52.5184 507.328 51.7653V51.53C507.328 51.3251 507.319 51.134 507.301 50.9564ZM508.247 51.7924V51.5028C508.247 49.575 507.388 48.4256 506.003 48.4256C504.618 48.4256 503.758 49.575 503.758 51.5028V51.7924C503.758 53.7202 504.618 54.8696 506.003 54.8696C507.388 54.8696 508.247 53.7202 508.247 51.7924Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M511.317 52.1733C511.317 51.8384 511.561 51.6121 511.887 51.6121C512.213 51.6121 512.457 51.8384 512.457 52.1733C512.457 52.5082 512.213 52.7345 511.887 52.7345C511.561 52.7345 511.317 52.5082 511.317 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M511.149 52.1733C511.149 51.7405 511.474 51.4444 511.887 51.4444C512.3 51.4444 512.625 51.7405 512.625 52.1733C512.625 52.6061 512.3 52.9021 511.887 52.9021C511.474 52.9021 511.149 52.6061 511.149 52.1733ZM511.887 51.612C511.561 51.612 511.317 51.8383 511.317 52.1733C511.317 52.5082 511.561 52.7345 511.887 52.7345C512.213 52.7345 512.457 52.5082 512.457 52.1733C512.457 51.8383 512.213 51.612 511.887 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M517.2 52.1733C517.2 51.8384 517.444 51.6121 517.77 51.6121C518.096 51.6121 518.34 51.8384 518.34 52.1733C518.34 52.5082 518.096 52.7345 517.77 52.7345C517.444 52.7345 517.2 52.5082 517.2 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M517.032 52.1733C517.032 51.7405 517.357 51.4444 517.77 51.4444C518.183 51.4444 518.508 51.7405 518.508 52.1733C518.508 52.6061 518.183 52.9021 517.77 52.9021C517.357 52.9021 517.032 52.6061 517.032 52.1733ZM517.77 51.612C517.444 51.612 517.2 51.8383 517.2 52.1733C517.2 52.5082 517.444 52.7345 517.77 52.7345C518.096 52.7345 518.34 52.5082 518.34 52.1733C518.34 51.8383 518.096 51.612 517.77 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M523.084 52.1733C523.084 51.8384 523.328 51.6121 523.654 51.6121C523.98 51.6121 524.224 51.8384 524.224 52.1733C524.224 52.5082 523.98 52.7345 523.654 52.7345C523.328 52.7345 523.084 52.5082 523.084 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M522.916 52.1733C522.916 51.7405 523.241 51.4444 523.654 51.4444C524.067 51.4444 524.392 51.7405 524.392 52.1733C524.392 52.6061 524.067 52.9021 523.654 52.9021C523.241 52.9021 522.916 52.6061 522.916 52.1733ZM523.654 51.612C523.328 51.612 523.084 51.8383 523.084 52.1733C523.084 52.5082 523.328 52.7345 523.654 52.7345C523.98 52.7345 524.224 52.5082 524.224 52.1733C524.224 51.8383 523.98 51.612 523.654 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M568.969 52.1733C568.969 51.8384 569.213 51.6121 569.539 51.6121C569.865 51.6121 570.11 51.8384 570.11 52.1733C570.11 52.5082 569.865 52.7345 569.539 52.7345C569.213 52.7345 568.969 52.5082 568.969 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M568.801 52.1733C568.801 51.7405 569.126 51.4444 569.539 51.4444C569.952 51.4444 570.277 51.7405 570.277 52.1733C570.277 52.6061 569.952 52.9021 569.539 52.9021C569.126 52.9021 568.801 52.6061 568.801 52.1733ZM569.539 51.612C569.213 51.612 568.969 51.8383 568.969 52.1733C568.969 52.5082 569.213 52.7345 569.539 52.7345C569.865 52.7345 570.11 52.5082 570.11 52.1733C570.11 51.8383 569.865 51.612 569.539 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M574.853 52.1733C574.853 51.8384 575.097 51.6121 575.423 51.6121C575.749 51.6121 575.993 51.8384 575.993 52.1733C575.993 52.5082 575.749 52.7345 575.423 52.7345C575.097 52.7345 574.853 52.5082 574.853 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M574.685 52.1733C574.685 51.7405 575.01 51.4444 575.423 51.4444C575.836 51.4444 576.161 51.7405 576.161 52.1733C576.161 52.6061 575.836 52.9021 575.423 52.9021C575.01 52.9021 574.685 52.6061 574.685 52.1733ZM575.423 51.612C575.097 51.612 574.852 51.8383 574.852 52.1733C574.852 52.5082 575.097 52.7345 575.423 52.7345C575.749 52.7345 575.993 52.5082 575.993 52.1733C575.993 51.8383 575.749 51.612 575.423 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M580.736 52.1733C580.736 51.8384 580.98 51.6121 581.306 51.6121C581.632 51.6121 581.877 51.8384 581.877 52.1733C581.877 52.5082 581.632 52.7345 581.306 52.7345C580.98 52.7345 580.736 52.5082 580.736 52.1733Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M580.568 52.1733C580.568 51.7405 580.893 51.4444 581.306 51.4444C581.719 51.4444 582.044 51.7405 582.044 52.1733C582.044 52.6061 581.719 52.9021 581.306 52.9021C580.893 52.9021 580.568 52.6061 580.568 52.1733ZM581.306 51.612C580.98 51.612 580.736 51.8383 580.736 52.1733C580.736 52.5082 580.98 52.7345 581.306 52.7345C581.632 52.7345 581.876 52.5082 581.876 52.1733C581.876 51.8383 581.632 51.612 581.306 51.612Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M587.712 54.1072H589.314V54.8132H585.296V54.1072H586.961V50.3694C586.871 50.4327 586.762 50.4599 586.626 50.4599H585.314V49.7811H586.545C586.825 49.7811 586.97 49.5457 586.97 49.238V48.4778H587.712V54.1072Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M589.482 53.9395V54.9807H585.128V53.9395H586.793V50.6135C586.74 50.6232 586.684 50.6274 586.626 50.6274H585.146V49.6133H586.545C586.632 49.6133 586.688 49.5799 586.727 49.5258C586.771 49.4656 586.802 49.3682 586.802 49.2379V48.3101H587.88V53.9395H589.482ZM587.712 54.1071V48.4777H586.97V49.2379C586.97 49.5456 586.825 49.781 586.545 49.781H585.314V50.4598H586.626C586.687 50.4598 586.743 50.4543 586.793 50.4425C586.856 50.4281 586.911 50.4042 586.961 50.3693V54.1071H585.296V54.8131H589.314V54.1071H587.712Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M590.765 51.8649L592.738 48.48H593.399L595.381 51.8649H594.621L593.046 49.204L591.489 51.8649H590.765Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M590.473 52.0325L592.642 48.3123H593.495L595.673 52.0325H594.525L593.047 49.5345L591.585 52.0325H590.473ZM593.046 49.204L594.621 51.8649H595.381L593.399 48.4799H592.738L590.765 51.8649H591.489L593.046 49.204Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M615.598 52.1998L615.092 51.7563L616.123 50.5707L614.639 50.0186L614.91 49.385L616.295 50.0276L616.277 48.48H616.929L616.902 50.0367L618.304 49.385L618.567 50.0276L617.092 50.5797L618.105 51.7563L617.599 52.1998L616.594 50.9237L615.598 52.1998Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M615.621 52.4427L614.855 51.7723L615.838 50.6433L614.416 50.1143L614.824 49.1603L616.124 49.7636L616.107 48.3123H617.099L617.074 49.7718L618.393 49.159L618.787 50.124L617.376 50.6524L618.341 51.7729L617.576 52.4422L616.594 51.1954L615.621 52.4427ZM616.594 50.9236L617.598 52.1997L618.105 51.7562L617.092 50.5797L618.567 50.0276L618.304 49.385L616.902 50.0366L616.929 48.4799H616.277L616.295 50.0276L614.91 49.385L614.639 50.0186L616.123 50.5706L615.091 51.7562L615.598 52.1997L616.594 50.9236Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M621.482 52.1998L620.975 51.7563L622.007 50.5707L620.522 50.0186L620.794 49.385L622.179 50.0276L622.161 48.48H622.812L622.785 50.0367L624.188 49.385L624.45 50.0276L622.975 50.5797L623.989 51.7563L623.482 52.1998L622.477 50.9237L621.482 52.1998Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M621.505 52.4427L620.739 51.7723L621.721 50.6433L620.299 50.1143L620.708 49.1603L622.008 49.7636L621.991 48.3123H622.983L622.957 49.7718L624.277 49.159L624.671 50.124L623.259 50.6524L624.224 51.7729L623.46 52.4422L622.478 51.1954L621.505 52.4427ZM622.477 50.9236L623.482 52.1997L623.989 51.7562L622.975 50.5797L624.45 50.0276L624.188 49.385L622.785 50.0366L622.812 48.4799H622.161L622.179 50.0276L620.794 49.385L620.522 50.0186L622.007 50.5706L620.975 51.7562L621.482 52.1997L622.477 50.9236Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M663.097 54.2981C663.097 53.9631 663.342 53.7368 663.668 53.7368C663.993 53.7368 664.238 53.9631 664.238 54.2981C664.238 54.633 663.993 54.8593 663.668 54.8593C663.342 54.8593 663.097 54.633 663.097 54.2981Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M662.93 54.2981C662.93 53.8653 663.254 53.5692 663.667 53.5692C664.081 53.5692 664.405 53.8653 664.405 54.2981C664.405 54.7309 664.081 55.0269 663.667 55.0269C663.254 55.0269 662.93 54.7309 662.93 54.2981ZM663.667 53.7368C663.342 53.7368 663.097 53.9632 663.097 54.2981C663.097 54.633 663.342 54.8593 663.667 54.8593C663.993 54.8593 664.238 54.633 664.238 54.2981C664.238 53.9632 663.993 53.7368 663.667 53.7368Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M668.981 54.2981C668.981 53.9631 669.225 53.7368 669.551 53.7368C669.877 53.7368 670.121 53.9631 670.121 54.2981C670.121 54.633 669.877 54.8593 669.551 54.8593C669.225 54.8593 668.981 54.633 668.981 54.2981Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M668.813 54.2981C668.813 53.8653 669.138 53.5692 669.551 53.5692C669.964 53.5692 670.289 53.8653 670.289 54.2981C670.289 54.7309 669.964 55.0269 669.551 55.0269C669.138 55.0269 668.813 54.7309 668.813 54.2981ZM669.551 53.7368C669.225 53.7368 668.981 53.9632 668.981 54.2981C668.981 54.633 669.225 54.8593 669.551 54.8593C669.877 54.8593 670.121 54.633 670.121 54.2981C670.121 53.9632 669.877 53.7368 669.551 53.7368Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M674.864 54.2981C674.864 53.9631 675.109 53.7368 675.435 53.7368C675.761 53.7368 676.005 53.9631 676.005 54.2981C676.005 54.633 675.761 54.8593 675.435 54.8593C675.109 54.8593 674.864 54.633 674.864 54.2981Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M674.697 54.2981C674.697 53.8653 675.022 53.5692 675.435 53.5692C675.848 53.5692 676.173 53.8653 676.173 54.2981C676.173 54.7309 675.848 55.0269 675.435 55.0269C675.022 55.0269 674.697 54.7309 674.697 54.2981ZM675.435 53.7368C675.109 53.7368 674.864 53.9632 674.864 54.2981C674.864 54.633 675.109 54.8593 675.435 54.8593C675.761 54.8593 676.005 54.633 676.005 54.2981C676.005 53.9632 675.761 53.7368 675.435 53.7368Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M691.334 54.2981C691.334 53.9631 691.578 53.7368 691.904 53.7368C692.23 53.7368 692.474 53.9631 692.474 54.2981C692.474 54.633 692.23 54.8593 691.904 54.8593C691.578 54.8593 691.334 54.633 691.334 54.2981Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M691.166 54.2981C691.166 53.8653 691.491 53.5692 691.904 53.5692C692.317 53.5692 692.642 53.8653 692.642 54.2981C692.642 54.7309 692.317 55.0269 691.904 55.0269C691.491 55.0269 691.166 54.7309 691.166 54.2981ZM691.904 53.7368C691.578 53.7368 691.334 53.9632 691.334 54.2981C691.334 54.633 691.578 54.8593 691.904 54.8593C692.23 54.8593 692.474 54.633 692.474 54.2981C692.474 53.9632 692.23 53.7368 691.904 53.7368Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M697.217 54.2981C697.217 53.9631 697.462 53.7368 697.788 53.7368C698.113 53.7368 698.358 53.9631 698.358 54.2981C698.358 54.633 698.113 54.8593 697.788 54.8593C697.462 54.8593 697.217 54.633 697.217 54.2981Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M697.05 54.2981C697.05 53.8653 697.374 53.5692 697.787 53.5692C698.201 53.5692 698.525 53.8653 698.525 54.2981C698.525 54.7309 698.201 55.0269 697.787 55.0269C697.374 55.0269 697.05 54.7309 697.05 54.2981ZM697.787 53.7368C697.462 53.7368 697.217 53.9632 697.217 54.2981C697.217 54.633 697.462 54.8593 697.787 54.8593C698.113 54.8593 698.358 54.633 698.358 54.2981C698.358 53.9632 698.113 53.7368 697.787 53.7368Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M703.101 54.2981C703.101 53.9631 703.345 53.7368 703.671 53.7368C703.997 53.7368 704.242 53.9631 704.242 54.2981C704.242 54.633 703.997 54.8593 703.671 54.8593C703.345 54.8593 703.101 54.633 703.101 54.2981Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M702.933 54.2981C702.933 53.8653 703.258 53.5692 703.671 53.5692C704.084 53.5692 704.409 53.8653 704.409 54.2981C704.409 54.7309 704.084 55.0269 703.671 55.0269C703.258 55.0269 702.933 54.7309 702.933 54.2981ZM703.671 53.7368C703.345 53.7368 703.101 53.9632 703.101 54.2981C703.101 54.633 703.345 54.8593 703.671 54.8593C703.997 54.8593 704.241 54.633 704.241 54.2981C704.241 53.9632 703.997 53.7368 703.671 53.7368Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M708.984 54.2981C708.984 53.9631 709.229 53.7368 709.555 53.7368C709.881 53.7368 710.125 53.9631 710.125 54.2981C710.125 54.633 709.881 54.8593 709.555 54.8593C709.229 54.8593 708.984 54.633 708.984 54.2981Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M708.817 54.2981C708.817 53.8653 709.142 53.5692 709.555 53.5692C709.968 53.5692 710.293 53.8653 710.293 54.2981C710.293 54.7309 709.968 55.0269 709.555 55.0269C709.142 55.0269 708.817 54.7309 708.817 54.2981ZM709.555 53.7368C709.229 53.7368 708.985 53.9632 708.985 54.2981C708.985 54.633 709.229 54.8593 709.555 54.8593C709.881 54.8593 710.125 54.633 710.125 54.2981C710.125 53.9632 709.881 53.7368 709.555 53.7368Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M3.29176 65.5516L2.25983 64.3205H3.12883L3.88015 65.5516H3.29176Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.21349 65.7192L1.90054 64.1528H3.22284L4.17877 65.7192H3.21349ZM3.29171 65.5516L2.25977 64.3205H3.12877L3.88009 65.5516H3.29171Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M9.17528 65.5516L8.14334 64.3205H9.01234L9.76366 65.5516H9.17528Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.09701 65.7192L7.78406 64.1528H9.10636L10.0623 65.7192H9.09701ZM9.17522 65.5516L8.14329 64.3205H9.01228L9.76361 65.5516H9.17522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M14.7964 70.1383C14.7964 69.8034 15.0408 69.577 15.3666 69.577C15.6925 69.577 15.9369 69.8034 15.9369 70.1383C15.9369 70.4732 15.6925 70.6995 15.3666 70.6995C15.0408 70.6995 14.7964 70.4732 14.7964 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6287 70.1383C14.6287 69.7055 14.9535 69.4094 15.3666 69.4094C15.7797 69.4094 16.1045 69.7055 16.1045 70.1383C16.1045 70.5711 15.7796 70.8671 15.3666 70.8671C14.9536 70.8671 14.6287 70.5711 14.6287 70.1383ZM15.3666 69.577C15.0407 69.577 14.7963 69.8034 14.7963 70.1383C14.7963 70.4732 15.0407 70.6995 15.3666 70.6995C15.6925 70.6995 15.9369 70.4732 15.9369 70.1383C15.9369 69.8034 15.6925 69.577 15.3666 69.577Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M20.6799 70.1383C20.6799 69.8034 20.9243 69.577 21.2502 69.577C21.5761 69.577 21.8205 69.8034 21.8205 70.1383C21.8205 70.4732 21.5761 70.6995 21.2502 70.6995C20.9243 70.6995 20.6799 70.4732 20.6799 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5123 70.1383C20.5123 69.7055 20.8372 69.4094 21.2502 69.4094C21.6633 69.4094 21.9881 69.7055 21.9881 70.1383C21.9881 70.5711 21.6633 70.8671 21.2502 70.8671C20.8372 70.8671 20.5123 70.5711 20.5123 70.1383ZM21.2502 69.577C20.9243 69.577 20.6799 69.8034 20.6799 70.1383C20.6799 70.4732 20.9243 70.6995 21.2502 70.6995C21.5761 70.6995 21.8205 70.4732 21.8205 70.1383C21.8205 69.8034 21.5761 69.577 21.2502 69.577Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M26.5635 70.1383C26.5635 69.8034 26.8079 69.577 27.1338 69.577C27.4597 69.577 27.7041 69.8034 27.7041 70.1383C27.7041 70.4732 27.4597 70.6995 27.1338 70.6995C26.8079 70.6995 26.5635 70.4732 26.5635 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3959 70.1383C26.3959 69.7055 26.7207 69.4094 27.1338 69.4094C27.5468 69.4094 27.8717 69.7055 27.8717 70.1383C27.8717 70.5711 27.5468 70.8671 27.1338 70.8671C26.7207 70.8671 26.3959 70.5711 26.3959 70.1383ZM27.1338 69.577C26.8079 69.577 26.5635 69.8034 26.5635 70.1383C26.5635 70.4732 26.8079 70.6995 27.1338 70.6995C27.4597 70.6995 27.7041 70.4732 27.7041 70.1383C27.7041 69.8034 27.4597 69.577 27.1338 69.577Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M32.4471 70.1383C32.4471 69.8034 32.6916 69.577 33.0174 69.577C33.3433 69.577 33.5877 69.8034 33.5877 70.1383C33.5877 70.4732 33.3433 70.6995 33.0174 70.6995C32.6916 70.6995 32.4471 70.4732 32.4471 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.2795 70.1383C32.2795 69.7055 32.6044 69.4094 33.0174 69.4094C33.4305 69.4094 33.7554 69.7055 33.7554 70.1383C33.7554 70.5711 33.4305 70.8671 33.0174 70.8671C32.6044 70.8671 32.2795 70.5711 32.2795 70.1383ZM33.0174 69.577C32.6916 69.577 32.4472 69.8034 32.4472 70.1383C32.4472 70.4732 32.6916 70.6995 33.0174 70.6995C33.3433 70.6995 33.5877 70.4732 33.5877 70.1383C33.5877 69.8034 33.3433 69.577 33.0174 69.577Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M38.3307 70.1383C38.3307 69.8034 38.5751 69.577 38.9009 69.577C39.2268 69.577 39.4712 69.8034 39.4712 70.1383C39.4712 70.4732 39.2268 70.6995 38.9009 70.6995C38.5751 70.6995 38.3307 70.4732 38.3307 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.163 70.1383C38.163 69.7055 38.4879 69.4094 38.9009 69.4094C39.314 69.4094 39.6388 69.7055 39.6388 70.1383C39.6388 70.5711 39.314 70.8671 38.9009 70.8671C38.4879 70.8671 38.163 70.5711 38.163 70.1383ZM38.9009 69.577C38.5751 69.577 38.3306 69.8034 38.3306 70.1383C38.3306 70.4732 38.5751 70.6995 38.9009 70.6995C39.2268 70.6995 39.4712 70.4732 39.4712 70.1383C39.4712 69.8034 39.2268 69.577 38.9009 69.577Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M44.2142 70.1383C44.2142 69.8034 44.4586 69.577 44.7845 69.577C45.1103 69.577 45.3547 69.8034 45.3547 70.1383C45.3547 70.4732 45.1103 70.6995 44.7845 70.6995C44.4586 70.6995 44.2142 70.4732 44.2142 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.0465 70.1383C44.0465 69.7055 44.3714 69.4094 44.7844 69.4094C45.1975 69.4094 45.5223 69.7055 45.5223 70.1383C45.5223 70.5711 45.1975 70.8671 44.7844 70.8671C44.3714 70.8671 44.0465 70.5711 44.0465 70.1383ZM44.7844 69.577C44.4585 69.577 44.2141 69.8034 44.2141 70.1383C44.2141 70.4732 44.4585 70.6995 44.7844 70.6995C45.1103 70.6995 45.3547 70.4732 45.3547 70.1383C45.3547 69.8034 45.1103 69.577 44.7844 69.577Z"
        fill="hsl(var(--content))"
      />
      <path d="M48.6134 68.3913V67.7668H52.7224V68.3913H48.6134Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.4458 68.5589V67.5991H52.89V68.5589H48.4458ZM48.6134 68.3912H52.7224V67.7667H48.6134V68.3912Z"
        fill="hsl(var(--content))"
      />
      <path d="M54.497 68.3913V67.7668H58.606V68.3913H54.497Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.3293 68.5589V67.5991H58.7736V68.5589H54.3293ZM54.497 68.3912H58.6059V67.7667H54.497V68.3912Z"
        fill="hsl(var(--content))"
      />
      <path d="M60.3806 68.3913V67.7668H64.4895V68.3913H60.3806Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.2129 68.5589V67.5991H64.6571V68.5589H60.2129ZM60.3805 68.3912H64.4895V67.7667H60.3805V68.3912Z"
        fill="hsl(var(--content))"
      />
      <path d="M66.2642 68.3913V67.7668H70.3732V68.3913H66.2642Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.0965 68.5589V67.5991H70.5407V68.5589H66.0965ZM66.2641 68.3912H70.3731V67.7667H66.2641V68.3912Z"
        fill="hsl(var(--content))"
      />
      <path d="M72.1477 68.3913V67.7668H76.2567V68.3913H72.1477Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.98 68.5589V67.5991H76.4243V68.5589H71.98ZM72.1477 68.3912H76.2566V67.7667H72.1477V68.3912Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M79.5135 68.0135C79.5135 67.6786 79.7579 67.4523 80.0838 67.4523C80.4096 67.4523 80.6541 67.6786 80.6541 68.0135C80.6541 68.3484 80.4096 68.5747 80.0838 68.5747C79.7579 68.5747 79.5135 68.3484 79.5135 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.3459 68.0135C79.3459 67.5807 79.6707 67.2846 80.0838 67.2846C80.4969 67.2846 80.8217 67.5807 80.8217 68.0135C80.8217 68.4463 80.4968 68.7423 80.0838 68.7423C79.6707 68.7423 79.3459 68.4463 79.3459 68.0135ZM80.0838 67.4522C79.7579 67.4522 79.5135 67.6786 79.5135 68.0135C79.5135 68.3484 79.7579 68.5747 80.0838 68.5747C80.4097 68.5747 80.6541 68.3484 80.6541 68.0135C80.6541 67.6786 80.4097 67.4522 80.0838 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M85.3971 68.0135C85.3971 67.6786 85.6415 67.4523 85.9674 67.4523C86.2933 67.4523 86.5377 67.6786 86.5377 68.0135C86.5377 68.3484 86.2933 68.5747 85.9674 68.5747C85.6415 68.5747 85.3971 68.3484 85.3971 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.2295 68.0135C85.2295 67.5807 85.5543 67.2846 85.9674 67.2846C86.3805 67.2846 86.7053 67.5807 86.7053 68.0135C86.7053 68.4463 86.3804 68.7423 85.9674 68.7423C85.5544 68.7423 85.2295 68.4463 85.2295 68.0135ZM85.9674 67.4522C85.6415 67.4522 85.3971 67.6786 85.3971 68.0135C85.3971 68.3484 85.6415 68.5747 85.9674 68.5747C86.2933 68.5747 86.5377 68.3484 86.5377 68.0135C86.5377 67.6786 86.2933 67.4522 85.9674 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M91.2806 68.0135C91.2806 67.6786 91.5251 67.4523 91.8509 67.4523C92.1768 67.4523 92.4212 67.6786 92.4212 68.0135C92.4212 68.3484 92.1768 68.5747 91.8509 68.5747C91.5251 68.5747 91.2806 68.3484 91.2806 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.113 68.0135C91.113 67.5807 91.4378 67.2846 91.8509 67.2846C92.2639 67.2846 92.5888 67.5807 92.5888 68.0135C92.5888 68.4463 92.2639 68.7423 91.8509 68.7423C91.4378 68.7423 91.113 68.4463 91.113 68.0135ZM91.8509 67.4522C91.525 67.4522 91.2806 67.6786 91.2806 68.0135C91.2806 68.3484 91.525 68.5747 91.8509 68.5747C92.1768 68.5747 92.4212 68.3484 92.4212 68.0135C92.4212 67.6786 92.1768 67.4522 91.8509 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M97.1642 68.0135C97.1642 67.6786 97.4087 67.4523 97.7345 67.4523C98.0604 67.4523 98.3048 67.6786 98.3048 68.0135C98.3048 68.3484 98.0604 68.5747 97.7345 68.5747C97.4087 68.5747 97.1642 68.3484 97.1642 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.9966 68.0135C96.9966 67.5807 97.3214 67.2846 97.7345 67.2846C98.1475 67.2846 98.4724 67.5807 98.4724 68.0135C98.4724 68.4463 98.1475 68.7423 97.7345 68.7423C97.3214 68.7423 96.9966 68.4463 96.9966 68.0135ZM97.7345 67.4522C97.4086 67.4522 97.1642 67.6786 97.1642 68.0135C97.1642 68.3484 97.4086 68.5747 97.7345 68.5747C98.0604 68.5747 98.3048 68.3484 98.3048 68.0135C98.3048 67.6786 98.0604 67.4522 97.7345 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M103.048 68.0135C103.048 67.6786 103.292 67.4523 103.618 67.4523C103.944 67.4523 104.188 67.6786 104.188 68.0135C104.188 68.3484 103.944 68.5747 103.618 68.5747C103.292 68.5747 103.048 68.3484 103.048 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.88 68.0135C102.88 67.5807 103.205 67.2846 103.618 67.2846C104.031 67.2846 104.356 67.5807 104.356 68.0135C104.356 68.4463 104.031 68.7423 103.618 68.7423C103.205 68.7423 102.88 68.4463 102.88 68.0135ZM103.618 67.4522C103.292 67.4522 103.048 67.6786 103.048 68.0135C103.048 68.3484 103.292 68.5747 103.618 68.5747C103.944 68.5747 104.188 68.3484 104.188 68.0135C104.188 67.6786 103.944 67.4522 103.618 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M108.931 68.0135C108.931 67.6786 109.176 67.4523 109.502 67.4523C109.828 67.4523 110.072 67.6786 110.072 68.0135C110.072 68.3484 109.828 68.5747 109.502 68.5747C109.176 68.5747 108.931 68.3484 108.931 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.764 68.0135C108.764 67.5807 109.089 67.2846 109.502 67.2846C109.915 67.2846 110.24 67.5807 110.24 68.0135C110.24 68.4463 109.915 68.7423 109.502 68.7423C109.089 68.7423 108.764 68.4463 108.764 68.0135ZM109.502 67.4522C109.176 67.4522 108.931 67.6786 108.931 68.0135C108.931 68.3484 109.176 68.5747 109.502 68.5747C109.828 68.5747 110.072 68.3484 110.072 68.0135C110.072 67.6786 109.828 67.4522 109.502 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path d="M113.331 68.3913V67.7668H117.44V68.3913H113.331Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.163 68.5589V67.5991H117.607V68.5589H113.163ZM113.331 68.3912H117.44V67.7667H113.331V68.3912Z"
        fill="hsl(var(--content))"
      />
      <path d="M119.087 71.3331V70.7086H123.45V71.3331H119.087Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.92 71.5007V70.541H123.617V71.5007H118.92ZM119.087 71.3331H123.45V70.7086H119.087V71.3331Z"
        fill="hsl(var(--content))"
      />
      <path d="M125.098 68.3913V67.7668H129.207V68.3913H125.098Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.93 68.5589V67.5991H129.374V68.5589H124.93ZM125.098 68.3912H129.207V67.7667H125.098V68.3912Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M132.466 70.1383C132.466 69.8034 132.71 69.577 133.036 69.577C133.362 69.577 133.606 69.8034 133.606 70.1383C133.606 70.4732 133.362 70.6995 133.036 70.6995C132.71 70.6995 132.466 70.4732 132.466 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M132.298 70.1383C132.298 69.7055 132.623 69.4094 133.036 69.4094C133.449 69.4094 133.774 69.7055 133.774 70.1383C133.774 70.5711 133.449 70.8671 133.036 70.8671C132.623 70.8671 132.298 70.5711 132.298 70.1383ZM133.036 69.577C132.71 69.577 132.466 69.8034 132.466 70.1383C132.466 70.4732 132.71 70.6995 133.036 70.6995C133.362 70.6995 133.606 70.4732 133.606 70.1383C133.606 69.8034 133.362 69.577 133.036 69.577Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M138.349 70.1383C138.349 69.8034 138.594 69.577 138.92 69.577C139.245 69.577 139.49 69.8034 139.49 70.1383C139.49 70.4732 139.245 70.6995 138.92 70.6995C138.594 70.6995 138.349 70.4732 138.349 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M138.182 70.1383C138.182 69.7055 138.507 69.4094 138.92 69.4094C139.333 69.4094 139.657 69.7055 139.657 70.1383C139.657 70.5711 139.333 70.8671 138.92 70.8671C138.507 70.8671 138.182 70.5711 138.182 70.1383ZM138.92 69.577C138.594 69.577 138.349 69.8034 138.349 70.1383C138.349 70.4732 138.594 70.6995 138.92 70.6995C139.245 70.6995 139.49 70.4732 139.49 70.1383C139.49 69.8034 139.245 69.577 138.92 69.577Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M144.233 70.1383C144.233 69.8034 144.477 69.577 144.803 69.577C145.129 69.577 145.373 69.8034 145.373 70.1383C145.373 70.4732 145.129 70.6995 144.803 70.6995C144.477 70.6995 144.233 70.4732 144.233 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.065 70.1383C144.065 69.7055 144.39 69.4094 144.803 69.4094C145.216 69.4094 145.541 69.7055 145.541 70.1383C145.541 70.5711 145.216 70.8671 144.803 70.8671C144.39 70.8671 144.065 70.5711 144.065 70.1383ZM144.803 69.577C144.477 69.577 144.233 69.8034 144.233 70.1383C144.233 70.4732 144.477 70.6995 144.803 70.6995C145.129 70.6995 145.373 70.4732 145.373 70.1383C145.373 69.8034 145.129 69.577 144.803 69.577Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M148.587 70.6534V64.318H149.374V67.0694H151.999V64.318H152.786V70.6534H151.999V67.7934H149.374V70.6534H148.587Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M148.419 70.821V64.1504H149.542V66.9018H151.831V64.1504H152.954V70.821H151.831V67.9611H149.542V70.821H148.419ZM149.374 67.7934H151.999V70.6534H152.786V64.318H151.999V67.0694H149.374V64.318H148.587V70.6534H149.374V67.7934Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M156 70.1383C156 69.8034 156.245 69.577 156.57 69.577C156.896 69.577 157.141 69.8034 157.141 70.1383C157.141 70.4732 156.896 70.6995 156.57 70.6995C156.245 70.6995 156 70.4732 156 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M155.832 70.1383C155.832 69.7055 156.157 69.4094 156.57 69.4094C156.983 69.4094 157.308 69.7055 157.308 70.1383C157.308 70.5711 156.983 70.8671 156.57 70.8671C156.157 70.8671 155.832 70.5711 155.832 70.1383ZM156.57 69.577C156.245 69.577 156 69.8034 156 70.1383C156 70.4732 156.245 70.6995 156.57 70.6995C156.896 70.6995 157.141 70.4732 157.141 70.1383C157.141 69.8034 156.896 69.577 156.57 69.577Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M161.884 70.1383C161.884 69.8034 162.128 69.577 162.454 69.577C162.78 69.577 163.024 69.8034 163.024 70.1383C163.024 70.4732 162.78 70.6995 162.454 70.6995C162.128 70.6995 161.884 70.4732 161.884 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M161.716 70.1383C161.716 69.7055 162.041 69.4094 162.454 69.4094C162.867 69.4094 163.192 69.7055 163.192 70.1383C163.192 70.5711 162.867 70.8671 162.454 70.8671C162.041 70.8671 161.716 70.5711 161.716 70.1383ZM162.454 69.577C162.128 69.577 161.884 69.8034 161.884 70.1383C161.884 70.4732 162.128 70.6995 162.454 70.6995C162.78 70.6995 163.024 70.4732 163.024 70.1383C163.024 69.8034 162.78 69.577 162.454 69.577Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M167.767 70.1383C167.767 69.8034 168.012 69.577 168.337 69.577C168.663 69.577 168.908 69.8034 168.908 70.1383C168.908 70.4732 168.663 70.6995 168.337 70.6995C168.012 70.6995 167.767 70.4732 167.767 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M167.6 70.1383C167.6 69.7055 167.924 69.4094 168.337 69.4094C168.75 69.4094 169.075 69.7055 169.075 70.1383C169.075 70.5711 168.75 70.8671 168.337 70.8671C167.924 70.8671 167.6 70.5711 167.6 70.1383ZM168.337 69.577C168.012 69.577 167.767 69.8034 167.767 70.1383C167.767 70.4732 168.012 70.6995 168.337 70.6995C168.663 70.6995 168.908 70.4732 168.908 70.1383C168.908 69.8034 168.663 69.577 168.337 69.577Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M173.651 70.1383C173.651 69.8034 173.895 69.577 174.221 69.577C174.547 69.577 174.791 69.8034 174.791 70.1383C174.791 70.4732 174.547 70.6995 174.221 70.6995C173.895 70.6995 173.651 70.4732 173.651 70.1383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M173.483 70.1383C173.483 69.7055 173.808 69.4094 174.221 69.4094C174.634 69.4094 174.959 69.7055 174.959 70.1383C174.959 70.5711 174.634 70.8671 174.221 70.8671C173.808 70.8671 173.483 70.5711 173.483 70.1383ZM174.221 69.577C173.895 69.577 173.651 69.8034 173.651 70.1383C173.651 70.4732 173.895 70.6995 174.221 70.6995C174.547 70.6995 174.791 70.4732 174.791 70.1383C174.791 69.8034 174.547 69.577 174.221 69.577Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M179.534 68.0135C179.534 67.6786 179.779 67.4523 180.105 67.4523C180.43 67.4523 180.675 67.6786 180.675 68.0135C180.675 68.3484 180.43 68.5747 180.105 68.5747C179.779 68.5747 179.534 68.3484 179.534 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M179.367 68.0135C179.367 67.5807 179.692 67.2846 180.105 67.2846C180.518 67.2846 180.842 67.5807 180.842 68.0135C180.842 68.4463 180.518 68.7423 180.105 68.7423C179.692 68.7423 179.367 68.4463 179.367 68.0135ZM180.105 67.4522C179.779 67.4522 179.534 67.6786 179.534 68.0135C179.534 68.3484 179.779 68.5747 180.105 68.5747C180.43 68.5747 180.675 68.3484 180.675 68.0135C180.675 67.6786 180.43 67.4522 180.105 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M185.418 68.0135C185.418 67.6786 185.662 67.4523 185.988 67.4523C186.314 67.4523 186.559 67.6786 186.559 68.0135C186.559 68.3484 186.314 68.5747 185.988 68.5747C185.662 68.5747 185.418 68.3484 185.418 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M185.25 68.0135C185.25 67.5807 185.575 67.2846 185.988 67.2846C186.401 67.2846 186.726 67.5807 186.726 68.0135C186.726 68.4463 186.401 68.7423 185.988 68.7423C185.575 68.7423 185.25 68.4463 185.25 68.0135ZM185.988 67.4522C185.662 67.4522 185.418 67.6786 185.418 68.0135C185.418 68.3484 185.662 68.5747 185.988 68.5747C186.314 68.5747 186.559 68.3484 186.559 68.0135C186.559 67.6786 186.314 67.4522 185.988 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M191.302 68.0135C191.302 67.6786 191.546 67.4523 191.872 67.4523C192.198 67.4523 192.442 67.6786 192.442 68.0135C192.442 68.3484 192.198 68.5747 191.872 68.5747C191.546 68.5747 191.302 68.3484 191.302 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M191.134 68.0135C191.134 67.5807 191.459 67.2846 191.872 67.2846C192.285 67.2846 192.61 67.5807 192.61 68.0135C192.61 68.4463 192.285 68.7423 191.872 68.7423C191.459 68.7423 191.134 68.4463 191.134 68.0135ZM191.872 67.4522C191.546 67.4522 191.302 67.6786 191.302 68.0135C191.302 68.3484 191.546 68.5747 191.872 68.5747C192.198 68.5747 192.442 68.3484 192.442 68.0135C192.442 67.6786 192.198 67.4522 191.872 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M199.773 64.9721H198.144V70.0043H199.773V70.6559H195.728V70.0043H197.357V64.9721H195.728V64.3205H199.773V64.9721Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M199.941 65.1397H198.312V69.8366H199.941V70.8235H195.56V69.8366H197.189V65.1397H195.56V64.1528H199.941V65.1397ZM197.357 64.9721V70.0042H195.728V70.6559H199.773V70.0042H198.144V64.9721H199.773V64.3205H195.728V64.9721H197.357Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M203.069 68.0135C203.069 67.6786 203.313 67.4523 203.639 67.4523C203.965 67.4523 204.209 67.6786 204.209 68.0135C204.209 68.3484 203.965 68.5747 203.639 68.5747C203.313 68.5747 203.069 68.3484 203.069 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M202.901 68.0135C202.901 67.5807 203.226 67.2846 203.639 67.2846C204.052 67.2846 204.377 67.5807 204.377 68.0135C204.377 68.4463 204.052 68.7423 203.639 68.7423C203.226 68.7423 202.901 68.4463 202.901 68.0135ZM203.639 67.4522C203.313 67.4522 203.069 67.6786 203.069 68.0135C203.069 68.3484 203.313 68.5747 203.639 68.5747C203.965 68.5747 204.209 68.3484 204.209 68.0135C204.209 67.6786 203.965 67.4522 203.639 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M208.952 68.0135C208.952 67.6786 209.197 67.4523 209.523 67.4523C209.848 67.4523 210.093 67.6786 210.093 68.0135C210.093 68.3484 209.848 68.5747 209.523 68.5747C209.197 68.5747 208.952 68.3484 208.952 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208.785 68.0135C208.785 67.5807 209.109 67.2846 209.522 67.2846C209.935 67.2846 210.26 67.5807 210.26 68.0135C210.26 68.4463 209.935 68.7423 209.522 68.7423C209.109 68.7423 208.785 68.4463 208.785 68.0135ZM209.522 67.4522C209.197 67.4522 208.952 67.6786 208.952 68.0135C208.952 68.3484 209.197 68.5747 209.522 68.5747C209.848 68.5747 210.093 68.3484 210.093 68.0135C210.093 67.6786 209.848 67.4522 209.522 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M214.836 68.0135C214.836 67.6786 215.08 67.4523 215.406 67.4523C215.732 67.4523 215.976 67.6786 215.976 68.0135C215.976 68.3484 215.732 68.5747 215.406 68.5747C215.08 68.5747 214.836 68.3484 214.836 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M214.668 68.0135C214.668 67.5807 214.993 67.2846 215.406 67.2846C215.819 67.2846 216.144 67.5807 216.144 68.0135C216.144 68.4463 215.819 68.7423 215.406 68.7423C214.993 68.7423 214.668 68.4463 214.668 68.0135ZM215.406 67.4522C215.08 67.4522 214.836 67.6786 214.836 68.0135C214.836 68.3484 215.08 68.5747 215.406 68.5747C215.732 68.5747 215.976 68.3484 215.976 68.0135C215.976 67.6786 215.732 67.4522 215.406 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M220.719 68.0135C220.719 67.6786 220.964 67.4523 221.29 67.4523C221.616 67.4523 221.86 67.6786 221.86 68.0135C221.86 68.3484 221.616 68.5747 221.29 68.5747C220.964 68.5747 220.719 68.3484 220.719 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.552 68.0135C220.552 67.5807 220.877 67.2846 221.29 67.2846C221.703 67.2846 222.028 67.5807 222.028 68.0135C222.028 68.4463 221.703 68.7423 221.29 68.7423C220.877 68.7423 220.552 68.4463 220.552 68.0135ZM221.29 67.4522C220.964 67.4522 220.719 67.6786 220.719 68.0135C220.719 68.3484 220.964 68.5747 221.29 68.5747C221.616 68.5747 221.86 68.3484 221.86 68.0135C221.86 67.6786 221.616 67.4522 221.29 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M226.603 68.0135C226.603 67.6786 226.848 67.4523 227.173 67.4523C227.499 67.4523 227.744 67.6786 227.744 68.0135C227.744 68.3484 227.499 68.5747 227.173 68.5747C226.848 68.5747 226.603 68.3484 226.603 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.436 68.0135C226.436 67.5807 226.76 67.2846 227.173 67.2846C227.586 67.2846 227.911 67.5807 227.911 68.0135C227.911 68.4463 227.586 68.7423 227.173 68.7423C226.76 68.7423 226.436 68.4463 226.436 68.0135ZM227.173 67.4522C226.848 67.4522 226.603 67.6786 226.603 68.0135C226.603 68.3484 226.848 68.5747 227.173 68.5747C227.499 68.5747 227.744 68.3484 227.744 68.0135C227.744 67.6786 227.499 67.4522 227.173 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M232.487 68.0135C232.487 67.6786 232.731 67.4523 233.057 67.4523C233.383 67.4523 233.627 67.6786 233.627 68.0135C233.627 68.3484 233.383 68.5747 233.057 68.5747C232.731 68.5747 232.487 68.3484 232.487 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M232.319 68.0135C232.319 67.5807 232.644 67.2846 233.057 67.2846C233.47 67.2846 233.795 67.5807 233.795 68.0135C233.795 68.4463 233.47 68.7423 233.057 68.7423C232.644 68.7423 232.319 68.4463 232.319 68.0135ZM233.057 67.4522C232.731 67.4522 232.487 67.6786 232.487 68.0135C232.487 68.3484 232.731 68.5747 233.057 68.5747C233.383 68.5747 233.627 68.3484 233.627 68.0135C233.627 67.6786 233.383 67.4522 233.057 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M256.815 70.6534V64.318H257.603V67.0694H260.227V64.318H261.015V70.6534H260.227V67.7934H257.603V70.6534H256.815Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M256.648 70.821V64.1504H257.77V66.9018H260.06V64.1504H261.182V70.821H260.06V67.9611H257.77V70.821H256.648ZM257.603 67.7934H260.227V70.6534H261.015V64.318H260.227V67.0694H257.603V64.318H256.815V70.6534H257.603V67.7934Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M264.229 68.0135C264.229 67.6786 264.473 67.4523 264.799 67.4523C265.125 67.4523 265.369 67.6786 265.369 68.0135C265.369 68.3484 265.125 68.5747 264.799 68.5747C264.473 68.5747 264.229 68.3484 264.229 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M264.061 68.0135C264.061 67.5807 264.386 67.2846 264.799 67.2846C265.212 67.2846 265.537 67.5807 265.537 68.0135C265.537 68.4463 265.212 68.7423 264.799 68.7423C264.386 68.7423 264.061 68.4463 264.061 68.0135ZM264.799 67.4522C264.473 67.4522 264.229 67.6786 264.229 68.0135C264.229 68.3484 264.473 68.5747 264.799 68.5747C265.125 68.5747 265.369 68.3484 265.369 68.0135C265.369 67.6786 265.125 67.4522 264.799 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M270.112 68.0135C270.112 67.6786 270.357 67.4523 270.682 67.4523C271.008 67.4523 271.253 67.6786 271.253 68.0135C271.253 68.3484 271.008 68.5747 270.682 68.5747C270.357 68.5747 270.112 68.3484 270.112 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M269.945 68.0135C269.945 67.5807 270.269 67.2846 270.682 67.2846C271.095 67.2846 271.42 67.5807 271.42 68.0135C271.42 68.4463 271.095 68.7423 270.682 68.7423C270.269 68.7423 269.945 68.4463 269.945 68.0135ZM270.682 67.4522C270.357 67.4522 270.112 67.6786 270.112 68.0135C270.112 68.3484 270.357 68.5747 270.682 68.5747C271.008 68.5747 271.253 68.3484 271.253 68.0135C271.253 67.6786 271.008 67.4522 270.682 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M275.996 68.0135C275.996 67.6786 276.24 67.4523 276.566 67.4523C276.892 67.4523 277.136 67.6786 277.136 68.0135C277.136 68.3484 276.892 68.5747 276.566 68.5747C276.24 68.5747 275.996 68.3484 275.996 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M275.828 68.0135C275.828 67.5807 276.153 67.2846 276.566 67.2846C276.979 67.2846 277.304 67.5807 277.304 68.0135C277.304 68.4463 276.979 68.7423 276.566 68.7423C276.153 68.7423 275.828 68.4463 275.828 68.0135ZM276.566 67.4522C276.24 67.4522 275.996 67.6786 275.996 68.0135C275.996 68.3484 276.24 68.5747 276.566 68.5747C276.892 68.5747 277.136 68.3484 277.136 68.0135C277.136 67.6786 276.892 67.4522 276.566 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M281.879 68.0135C281.879 67.6786 282.124 67.4523 282.45 67.4523C282.776 67.4523 283.02 67.6786 283.02 68.0135C283.02 68.3484 282.776 68.5747 282.45 68.5747C282.124 68.5747 281.879 68.3484 281.879 68.0135Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M281.712 68.0135C281.712 67.5807 282.037 67.2846 282.45 67.2846C282.863 67.2846 283.188 67.5807 283.188 68.0135C283.188 68.4463 282.863 68.7423 282.45 68.7423C282.037 68.7423 281.712 68.4463 281.712 68.0135ZM282.45 67.4522C282.124 67.4522 281.879 67.6786 281.879 68.0135C281.879 68.3484 282.124 68.5747 282.45 68.5747C282.776 68.5747 283.02 68.3484 283.02 68.0135C283.02 67.6786 282.776 67.4522 282.45 67.4522Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M296.258 65.5516L295.226 64.3205H296.095L296.846 65.5516H296.258Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M296.18 65.7192L294.867 64.1528H296.189L297.145 65.7192H296.18ZM296.258 65.5516L295.226 64.3205H296.095L296.846 65.5516H296.258Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M302.142 65.5516L301.11 64.3205H301.979L302.73 65.5516H302.142Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M302.063 65.7192L300.75 64.1528H302.073L303.029 65.7192H302.063ZM302.142 65.5516L301.11 64.3205H301.979L302.73 65.5516H302.142Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M308.025 65.5516L306.993 64.3205H307.862L308.613 65.5516H308.025Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M307.947 65.7192L306.634 64.1528H307.956L308.912 65.7192H307.947ZM308.025 65.5516L306.993 64.3205H307.862L308.613 65.5516H308.025Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M313.909 65.5516L312.877 64.3205H313.746L314.497 65.5516H313.909Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M313.83 65.7192L312.518 64.1528H313.84L314.796 65.7192H313.83ZM313.909 65.5516L312.877 64.3205H313.746L314.497 65.5516H313.909Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M324.497 65.5516L323.465 64.3205H324.334L325.085 65.5516H324.497Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M324.419 65.7192L323.106 64.1528H324.428L325.384 65.7192H324.419ZM324.497 65.5516L323.465 64.3205H324.334L325.085 65.5516H324.497Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M330.38 65.5516L329.349 64.3205H330.218L330.969 65.5516H330.38Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M330.302 65.7192L328.989 64.1528H330.312L331.268 65.7192H330.302ZM330.38 65.5516L329.349 64.3205H330.218L330.969 65.5516H330.38Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M336.264 65.5516L335.232 64.3205H336.101L336.853 65.5516H336.264Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M336.186 65.7192L334.873 64.1528H336.195L337.151 65.7192H336.186ZM336.264 65.5516L335.232 64.3205H336.101L336.852 65.5516H336.264Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M342.148 65.5516L341.116 64.3205H341.985L342.736 65.5516H342.148Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M342.069 65.7192L340.756 64.1528H342.079L343.035 65.7192H342.069ZM342.148 65.5516L341.116 64.3205H341.985L342.736 65.5516H342.148Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M348.031 65.5516L346.999 64.3205H347.868L348.62 65.5516H348.031Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M347.953 65.7192L346.64 64.1528H347.962L348.918 65.7192H347.953ZM348.031 65.5516L346.999 64.3205H347.868L348.62 65.5516H348.031Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M353.915 65.5516L352.883 64.3205H353.752L354.503 65.5516H353.915Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M353.837 65.7192L352.524 64.1528H353.846L354.802 65.7192H353.837ZM353.915 65.5516L352.883 64.3205H353.752L354.503 65.5516H353.915Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M362.142 68.0855V70.6559H361.4V68.1308C361.4 67.1895 360.966 66.6646 360.196 66.6646C359.373 66.6646 358.848 67.3163 358.848 68.348V70.6559H358.106V64.3205H358.848V66.6646C359.192 66.2392 359.726 65.9858 360.323 65.9858C361.482 65.9858 362.142 66.7551 362.142 68.0855Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M362.31 70.8235H361.233V68.1307C361.233 67.6831 361.129 67.3598 360.957 67.1512C360.79 66.9475 360.54 66.8322 360.196 66.8322C359.833 66.8322 359.545 66.9739 359.344 67.2243C359.14 67.4785 359.016 67.8587 359.016 68.348V70.8235H357.938V64.1528H359.016V66.2633C359.372 65.9787 359.829 65.8181 360.323 65.8181C360.942 65.8181 361.446 66.025 361.794 66.4271C362.139 66.8257 362.31 67.3946 362.31 68.0855V70.8235ZM359.016 66.4846C358.956 66.5405 358.9 66.6006 358.848 66.6646V64.3205H358.106V70.6559H358.848V68.348C358.848 67.3162 359.373 66.6646 360.196 66.6646C360.966 66.6646 361.4 67.1895 361.4 68.1307V70.6559H362.142V68.0855C362.142 66.7551 361.482 65.9858 360.323 65.9858C359.816 65.9858 359.354 66.1687 359.016 66.4846Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M402.262 69.9747V70.6535H398.261V69.9747H399.89V66.7164H398.261V66.0376H400.632V69.9747H402.262ZM399.673 64.6258C399.673 64.2909 399.936 64.0375 400.27 64.0375C400.605 64.0375 400.868 64.2909 400.868 64.6258C400.868 64.9606 400.605 65.2231 400.27 65.2231C399.936 65.2231 399.673 64.9697 399.673 64.6258Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M402.429 69.8071V70.8211H398.094V69.8071H399.723V66.8841H398.094V65.87H400.8V69.8071H402.429ZM399.89 66.7165V69.9747H398.261V70.6535H402.261V69.9747H400.632V66.0377H398.261V66.7165H399.89ZM399.505 64.6258C399.505 64.195 399.846 63.8699 400.27 63.8699C400.694 63.8699 401.035 64.195 401.035 64.6258C401.035 65.0532 400.698 65.3907 400.27 65.3907C399.845 65.3907 399.505 65.064 399.505 64.6258ZM400.27 64.0375C399.936 64.0375 399.673 64.2909 399.673 64.6258C399.673 64.9697 399.936 65.2231 400.27 65.2231C400.605 65.2231 400.868 64.9607 400.868 64.6258C400.868 64.2909 400.605 64.0375 400.27 64.0375Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M426.337 70.6534V64.318H428.482C429.749 64.318 430.591 65.0782 430.591 66.2639C430.591 67.1508 430.057 67.8387 429.242 68.0649L430.663 70.6534H429.776L428.437 68.2188H427.124V70.6534H426.337ZM427.124 67.4948H428.419C429.251 67.4948 429.785 67.006 429.785 66.2639C429.785 65.5217 429.251 65.0421 428.428 65.0421H427.124V67.4948Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M426.169 70.821V64.1504H428.482C429.149 64.1504 429.719 64.3508 430.125 64.7228C430.532 65.0962 430.759 65.6294 430.759 66.2639C430.759 67.1516 430.261 67.8628 429.486 68.1608L430.947 70.821H429.677L428.338 68.3864H427.292V70.821H426.169ZM427.125 68.2188H428.437L429.776 70.6534H430.663L429.242 68.065C429.298 68.0496 429.352 68.032 429.405 68.0124C430.127 67.7441 430.591 67.0905 430.591 66.2639C430.591 65.0783 429.749 64.318 428.482 64.318H426.337V70.6534H427.125V68.2188ZM427.292 67.3272H428.419C428.803 67.3272 429.101 67.2148 429.302 67.0333C429.501 66.8534 429.618 66.5926 429.618 66.2639C429.618 65.9353 429.501 65.6769 429.303 65.4993C429.104 65.32 428.808 65.2097 428.428 65.2097H427.292V67.3272ZM428.419 67.4948C429.251 67.4948 429.785 67.006 429.785 66.2639C429.785 65.5217 429.251 65.0421 428.428 65.0421H427.125V67.4948H428.419Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M432.583 71.5585L435.144 64.0488H435.877L433.316 71.5585H432.583Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M432.349 71.7261L435.024 63.8811H436.111L433.436 71.7261H432.349ZM432.583 71.5584H433.316L435.877 64.0487H435.144L432.583 71.5584Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M438.466 71.5585L441.028 64.0488H441.761L439.2 71.5585H438.466Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M438.232 71.7261L440.908 63.8811H441.995L439.319 71.7261H438.232ZM438.466 71.5584H439.199L441.761 64.0487H441.028L438.466 71.5584Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M445.69 65.5516L444.658 64.3205H445.527L446.278 65.5516H445.69Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M445.611 65.7192L444.298 64.1528H445.621L446.577 65.7192H445.611ZM445.69 65.5516L444.658 64.3205H445.527L446.278 65.5516H445.69Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M451.573 65.5516L450.541 64.3205H451.41L452.162 65.5516H451.573Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M451.495 65.7192L450.182 64.1528H451.504L452.46 65.7192H451.495ZM451.573 65.5516L450.541 64.3205H451.41L452.162 65.5516H451.573Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M457.457 65.5516L456.425 64.3205H457.294L458.045 65.5516H457.457Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M457.379 65.7192L456.066 64.1528H457.388L458.344 65.7192H457.379ZM457.457 65.5516L456.425 64.3205H457.294L458.045 65.5516H457.457Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M463.341 65.5516L462.309 64.3205H463.178L463.929 65.5516H463.341Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M463.262 65.7192L461.949 64.1528H463.272L464.228 65.7192H463.262ZM463.341 65.5516L462.309 64.3205H463.178L463.929 65.5516H463.341Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M469.224 65.5516L468.192 64.3205H469.061L469.812 65.5516H469.224Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M469.146 65.7192L467.833 64.1528H469.155L470.111 65.7192H469.146ZM469.224 65.5516L468.192 64.3205H469.061L469.812 65.5516H469.224Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M475.108 65.5516L474.076 64.3205H474.945L475.696 65.5516H475.108Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M475.029 65.7192L473.716 64.1528H475.039L475.995 65.7192H475.029ZM475.108 65.5516L474.076 64.3205H474.945L475.696 65.5516H475.108Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M480.991 65.5516L479.959 64.3205H480.828L481.58 65.5516H480.991Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M480.913 65.7192L479.6 64.1528H480.922L481.878 65.7192H480.913ZM480.991 65.5516L479.959 64.3205H480.828L481.58 65.5516H480.991Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M486.875 65.5516L485.843 64.3205H486.712L487.463 65.5516H486.875Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M486.796 65.7192L485.483 64.1528H486.806L487.762 65.7192H486.796ZM486.875 65.5516L485.843 64.3205H486.712L487.463 65.5516H486.875Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M492.756 65.5516L491.724 64.3205H492.593L493.344 65.5516H492.756Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M492.678 65.7192L491.365 64.1528H492.687L493.643 65.7192H492.678ZM492.756 65.5516L491.724 64.3205H492.593L493.344 65.5516H492.756Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M515.215 69.9747V70.6535H511.215V69.9747H512.844V66.7164H511.215V66.0376H513.586V69.9747H515.215ZM512.627 64.6258C512.627 64.2909 512.889 64.0375 513.224 64.0375C513.559 64.0375 513.821 64.2909 513.821 64.6258C513.821 64.9606 513.559 65.2231 513.224 65.2231C512.889 65.2231 512.627 64.9697 512.627 64.6258Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M515.383 69.8071V70.8211H511.047V69.8071H512.676V66.8841H511.047V65.87H513.754V69.8071H515.383ZM512.844 66.7165V69.9747H511.215V70.6535H515.215V69.9747H513.586V66.0377H511.215V66.7165H512.844ZM512.459 64.6258C512.459 64.195 512.8 63.8699 513.224 63.8699C513.648 63.8699 513.989 64.195 513.989 64.6258C513.989 65.0532 513.651 65.3907 513.224 65.3907C512.798 65.3907 512.459 65.064 512.459 64.6258ZM513.224 64.0375C512.889 64.0375 512.627 64.2909 512.627 64.6258C512.627 64.9697 512.889 65.2231 513.224 65.2231C513.559 65.2231 513.821 64.9607 513.821 64.6258C513.821 64.2909 513.559 64.0375 513.224 64.0375Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M530.882 68.0403L530.375 67.5968L531.407 66.4112L529.922 65.8591L530.194 65.2256L531.578 65.8681L531.56 64.3205H532.212L532.185 65.8772L533.588 65.2256L533.85 65.8681L532.375 66.4202L533.389 67.5968L532.882 68.0403L531.877 66.7642L530.882 68.0403Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M530.905 68.2832L530.139 67.6128L531.121 66.4838L529.699 65.9548L530.108 65.0008L531.408 65.6041L531.391 64.1528H532.383L532.357 65.6123L533.676 64.9995L534.071 65.9646L532.659 66.4929L533.624 67.6134L532.859 68.2827L531.878 67.0359L530.905 68.2832ZM531.877 66.7641L532.882 68.0403L533.389 67.5968L532.375 66.4202L533.85 65.8681L533.588 65.2255L532.185 65.8772L532.212 64.3205H531.56L531.578 65.8681L530.194 65.2255L529.922 65.8591L531.407 66.4111L530.375 67.5968L530.882 68.0403L531.877 66.7641Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M537.399 70.0202V68.192H535.679V67.5132H537.399V65.694H538.141V67.5132H539.869V68.192H538.141V70.0202H537.399Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M537.231 70.1878V68.3596H535.511V67.3455H537.231V65.5264H538.308V67.3455H540.037V68.3596H538.308V70.1878H537.231ZM538.141 68.1919H539.869V67.5131H538.141V65.694H537.399V67.5131H535.679V68.1919H537.399V70.0202H538.141V68.1919Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M543.346 65.5516L542.314 64.3205H543.183L543.934 65.5516H543.346Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M543.268 65.7192L541.955 64.1528H543.277L544.233 65.7192H543.268ZM543.346 65.5516L542.314 64.3205H543.183L543.934 65.5516H543.346Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M549.166 70.0202V68.192H547.446V67.5132H549.166V65.694H549.908V67.5132H551.636V68.192H549.908V70.0202H549.166Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M548.998 70.1878V68.3596H547.278V67.3455H548.998V65.5264H550.075V67.3455H551.804V68.3596H550.075V70.1878H548.998ZM549.908 68.1919H551.636V67.5131H549.908V65.694H549.166V67.5131H547.446V68.1919H549.166V70.0202H549.908V68.1919Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M555.05 70.0202V68.192H553.33V67.5132H555.05V65.694H555.792V67.5132H557.52V68.192H555.792V70.0202H555.05Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M554.882 70.1878V68.3596H553.162V67.3455H554.882V65.5264H555.959V67.3455H557.688V68.3596H555.959V70.1878H554.882ZM555.792 68.1919H557.52V67.5131H555.792V65.694H555.05V67.5131H553.33V68.1919H555.05V70.0202H555.792V68.1919Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M560.933 70.0202V68.192H559.213V67.5132H560.933V65.694H561.675V67.5132H563.404V68.192H561.675V70.0202H560.933Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M560.765 70.1878V68.3596H559.046V67.3455H560.765V65.5264H561.843V67.3455H563.571V68.3596H561.843V70.1878H560.765ZM561.675 68.1919H563.404V67.5131H561.675V65.694H560.933V67.5131H559.213V68.1919H560.933V70.0202H561.675V68.1919Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M566.816 70.0202V68.192H565.097V67.5132H566.816V65.694H567.559V67.5132H569.287V68.192H567.559V70.0202H566.816Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M566.649 70.1878V68.3596H564.929V67.3455H566.649V65.5264H567.726V67.3455H569.455V68.3596H567.726V70.1878H566.649ZM567.559 68.1919H569.287V67.5131H567.559V65.694H566.816V67.5131H565.097V68.1919H566.816V70.0202H567.559V68.1919Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M571.424 71.5585L573.985 64.0488H574.718L572.157 71.5585H571.424Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M571.19 71.7261L573.865 63.8811H574.953L572.277 71.7261H571.19ZM571.424 71.5584H572.157L574.718 64.0487H573.985L571.424 71.5584Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M576.665 68.3482C576.665 66.9453 577.606 65.986 578.955 65.986C580.303 65.986 581.245 66.9453 581.245 68.3482C581.245 69.751 580.303 70.7104 578.955 70.7104C577.606 70.7104 576.665 69.751 576.665 68.3482ZM580.484 68.3482C580.484 67.3617 579.869 66.6467 578.955 66.6467C578.041 66.6467 577.425 67.3617 577.425 68.3482C577.425 69.3347 578.041 70.0497 578.955 70.0497C579.869 70.0497 580.484 69.3347 580.484 68.3482Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M577.184 66.5241C577.622 66.0736 578.239 65.8184 578.955 65.8184C579.67 65.8184 580.287 66.0736 580.725 66.5241C581.163 66.9744 581.412 67.6086 581.412 68.3482C581.412 69.0878 581.163 69.722 580.725 70.1722C580.287 70.6228 579.67 70.878 578.955 70.878C578.239 70.878 577.622 70.6228 577.184 70.1722C576.746 69.722 576.497 69.0878 576.497 68.3482C576.497 67.6086 576.746 66.9744 577.184 66.5241ZM579.937 67.2388C579.702 66.9736 579.365 66.8143 578.955 66.8143C578.544 66.8143 578.208 66.9736 577.973 67.2388C577.736 67.5056 577.593 67.8894 577.593 68.3482C577.593 68.807 577.736 69.1908 577.973 69.4576C578.208 69.7228 578.544 69.8821 578.955 69.8821C579.365 69.8821 579.702 69.7228 579.937 69.4576C580.174 69.1908 580.317 68.807 580.317 68.3482C580.317 67.8894 580.174 67.5056 579.937 67.2388ZM578.955 65.986C577.606 65.986 576.665 66.9454 576.665 68.3482C576.665 69.751 577.606 70.7104 578.955 70.7104C580.303 70.7104 581.245 69.751 581.245 68.3482C581.245 66.9454 580.303 65.986 578.955 65.986ZM578.955 66.6467C579.869 66.6467 580.484 67.3617 580.484 68.3482C580.484 69.3347 579.869 70.0497 578.955 70.0497C578.041 70.0497 577.425 69.3347 577.425 68.3482C577.425 67.3617 578.041 66.6467 578.955 66.6467Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M606.882 65.5516L605.85 64.3205H606.719L607.47 65.5516H606.882Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M606.803 65.7192L605.491 64.1528H606.813L607.769 65.7192H606.803ZM606.882 65.5516L605.85 64.3205H606.719L607.47 65.5516H606.882Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M612.765 65.5516L611.733 64.3205H612.602L613.354 65.5516H612.765Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M612.687 65.7192L611.374 64.1528H612.696L613.652 65.7192H612.687ZM612.765 65.5516L611.733 64.3205H612.602L613.354 65.5516H612.765Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M618.649 65.5516L617.617 64.3205H618.486L619.237 65.5516H618.649Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M618.57 65.7192L617.258 64.1528H618.58L619.536 65.7192H618.57ZM618.649 65.5516L617.617 64.3205H618.486L619.237 65.5516H618.649Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M624.533 65.5516L623.501 64.3205H624.37L625.121 65.5516H624.533Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M624.454 65.7192L623.141 64.1528H624.464L625.42 65.7192H624.454ZM624.532 65.5516L623.501 64.3205H624.37L625.121 65.5516H624.532Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M630.416 65.5516L629.384 64.3205H630.253L631.004 65.5516H630.416Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M630.338 65.7192L629.025 64.1528H630.347L631.303 65.7192H630.338ZM630.416 65.5516L629.384 64.3205H630.253L631.004 65.5516H630.416Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M636.3 65.5516L635.268 64.3205H636.137L636.888 65.5516H636.3Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M636.221 65.7192L634.909 64.1528H636.231L637.187 65.7192H636.221ZM636.3 65.5516L635.268 64.3205H636.137L636.888 65.5516H636.3Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M642.183 65.5516L641.151 64.3205H642.02L642.772 65.5516H642.183Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M642.105 65.7192L640.792 64.1528H642.114L643.07 65.7192H642.105ZM642.183 65.5516L641.151 64.3205H642.02L642.772 65.5516H642.183Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M648.067 65.5516L647.035 64.3205H647.904L648.655 65.5516H648.067Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M647.989 65.7192L646.676 64.1528H647.998L648.954 65.7192H647.989ZM648.067 65.5516L647.035 64.3205H647.904L648.655 65.5516H648.067Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M667.605 70.7108L666.573 69.4797H667.442L668.193 70.7108H667.605Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M667.527 70.8784L666.214 69.3121H667.536L668.492 70.8784H667.527ZM667.605 70.7108L666.573 69.4797H667.442L668.193 70.7108H667.605Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M678.655 65.5516L677.623 64.3205H678.492L679.243 65.5516H678.655Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M678.576 65.7192L677.263 64.1528H678.586L679.542 65.7192H678.576ZM678.655 65.5516L677.623 64.3205H678.492L679.243 65.5516H678.655Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M684.538 65.5516L683.506 64.3205H684.375L685.127 65.5516H684.538Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M684.46 65.7192L683.147 64.1528H684.47L685.425 65.7192H684.46ZM684.538 65.5516L683.506 64.3205H684.375L685.127 65.5516H684.538Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M690.422 65.5516L689.39 64.3205H690.259L691.01 65.5516H690.422Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M690.344 65.7192L689.031 64.1528H690.353L691.309 65.7192H690.344ZM690.422 65.5516L689.39 64.3205H690.259L691.01 65.5516H690.422Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M696.305 65.5516L695.273 64.3205H696.142L696.894 65.5516H696.305Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M696.227 65.7192L694.914 64.1528H696.237L697.192 65.7192H696.227ZM696.305 65.5516L695.273 64.3205H696.142L696.894 65.5516H696.305Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M700.397 70.6534V64.318H701.184V67.0694H703.809V64.318H704.596V70.6534H703.809V67.7934H701.184V70.6534H700.397Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M700.229 70.821V64.1504H701.352V66.9018H703.641V64.1504H704.764V70.821H703.641V67.9611H701.352V70.821H700.229ZM701.184 67.7934H703.809V70.6534H704.596V64.318H703.809V67.0694H701.184V64.318H700.397V70.6534H701.184V67.7934Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M706.389 67.235V66.5562H710.371V67.235H706.389ZM706.389 69.38V68.7012H710.371V69.38H706.389Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M706.221 67.4026V66.3885H710.539V67.4026H706.221ZM706.221 69.5476V68.5335H710.539V69.5476H706.221ZM706.389 67.235H710.371V66.5562H706.389V67.235ZM706.389 69.38H710.371V68.7012H706.389V69.38Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M3.28725 81.392L2.25531 80.1609H3.12431L3.87563 81.392H3.28725Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.20894 81.5596L1.896 79.9933H3.2183L4.17422 81.5596H3.20894ZM3.28716 81.392L2.25522 80.1609H3.12422L3.87555 81.392H3.28716Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M9.17085 81.392L8.13892 80.1609H9.00791L9.75924 81.392H9.17085Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.09255 81.5596L7.7796 79.9933H9.1019L10.0578 81.5596H9.09255ZM9.17077 81.392L8.13883 80.1609H9.00783L9.75915 81.392H9.17077Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M15.0544 81.392L14.0225 80.1609H14.8915L15.6428 81.392H15.0544Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9762 81.5596L13.6632 79.9933H14.9855L15.9414 81.5596H14.9762ZM15.0544 81.392L14.0224 80.1609H14.8914L15.6428 81.392H15.0544Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M20.9379 81.392L19.906 80.1609H20.775L21.5263 81.392H20.9379Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8597 81.5596L19.5468 79.9933H20.8691L21.825 81.5596H20.8597ZM20.9379 81.392L19.906 80.1609H20.775L21.5263 81.392H20.9379Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M26.8215 81.392L25.7896 80.1609H26.6585L27.4099 81.392H26.8215Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7432 81.5596L25.4303 79.9933H26.7526L27.7085 81.5596H26.7432ZM26.8215 81.392L25.7895 80.1609H26.6585L27.4098 81.392H26.8215Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M30.9128 86.494V80.1586H31.7002V82.91H34.3249V80.1586H35.1123V86.494H34.3249V83.634H31.7002V86.494H30.9128Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.7452 86.6616V79.9909H31.8678V82.7423H34.1573V79.9909H35.2799V86.6616H34.1573V83.8016H31.8678V86.6616H30.7452ZM31.7002 83.634H34.3249V86.4939H35.1123V80.1585H34.3249V82.9099H31.7002V80.1585H30.9128V86.4939H31.7002V83.634Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M38.5887 81.392L37.5568 80.1609H38.4258L39.1771 81.392H38.5887Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.5104 81.5596L37.1974 79.9933H38.5197L39.4757 81.5596H38.5104ZM38.5886 81.392L37.5567 80.1609H38.4257L39.177 81.392H38.5886Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M44.4723 81.392L43.4403 80.1609H44.3093L45.0607 81.392H44.4723Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.3941 81.5596L43.0811 79.9933H44.4034L45.3593 81.5596H44.3941ZM44.4723 81.392L43.4403 80.1609H44.3093L45.0607 81.392H44.4723Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M50.3559 81.392L49.3239 80.1609H50.1929L50.9443 81.392H50.3559Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.2776 81.5596L48.9647 79.9933H50.287L51.2429 81.5596H50.2776ZM50.3559 81.392L49.3239 80.1609H50.1929L50.9442 81.392H50.3559Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M56.2395 81.392L55.2076 80.1609H56.0765L56.8279 81.392H56.2395Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.1612 81.5596L54.8483 79.9933H56.1706L57.1265 81.5596H56.1612ZM56.2394 81.392L55.2075 80.1609H56.0765L56.8278 81.392H56.2394Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M62.1231 81.392L61.0911 80.1609H61.9601L62.7114 81.392H62.1231Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.0448 81.5596L60.7319 79.9933H62.0542L63.0101 81.5596H62.0448ZM62.123 81.392L61.0911 80.1609H61.9601L62.7114 81.392H62.123Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M68.0066 81.392L66.9747 80.1609H67.8437L68.595 81.392H68.0066Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.9283 81.5596L66.6154 79.9933H67.9377L68.8936 81.5596H67.9283ZM68.0066 81.392L66.9746 80.1609H67.8436L68.5949 81.392H68.0066Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M73.6277 82.5868C73.6277 82.2519 73.8721 82.0256 74.1979 82.0256C74.5237 82.0256 74.7681 82.2519 74.7681 82.5868C74.7681 82.9216 74.5237 83.1479 74.1979 83.1479C73.8721 83.1479 73.6277 82.9216 73.6277 82.5868ZM73.6277 85.9807C73.6277 85.6459 73.8721 85.4196 74.1979 85.4196C74.5237 85.4196 74.7681 85.6459 74.7681 85.9807C74.7681 86.3156 74.5237 86.5419 74.1979 86.5419C73.8721 86.5419 73.6277 86.3156 73.6277 85.9807Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.46 82.5867C73.46 82.154 73.7848 81.858 74.1978 81.858C74.6108 81.858 74.9357 82.154 74.9357 82.5867C74.9357 83.0195 74.6108 83.3155 74.1978 83.3155C73.7848 83.3155 73.46 83.0195 73.46 82.5867ZM73.46 85.9807C73.46 85.5479 73.7848 85.2519 74.1978 85.2519C74.6108 85.2519 74.9357 85.5479 74.9357 85.9807C74.9357 86.4134 74.6108 86.7095 74.1978 86.7095C73.7848 86.7095 73.46 86.4134 73.46 85.9807ZM74.1978 82.0256C73.872 82.0256 73.6276 82.2519 73.6276 82.5867C73.6276 82.9216 73.872 83.1479 74.1978 83.1479C74.5237 83.1479 74.768 82.9216 74.768 82.5867C74.768 82.2519 74.5237 82.0256 74.1978 82.0256ZM74.1978 85.4196C73.872 85.4196 73.6276 85.6458 73.6276 85.9807C73.6276 86.3156 73.872 86.5419 74.1978 86.5419C74.5237 86.5419 74.768 86.3156 74.768 85.9807C74.768 85.6458 74.5237 85.4196 74.1978 85.4196Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M79.7715 81.392L78.7396 80.1609H79.6086L80.3599 81.392H79.7715Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.6933 81.5596L78.3803 79.9933H79.7026L80.6585 81.5596H79.6933ZM79.7715 81.392L78.7395 80.1609H79.6085L80.3599 81.392H79.7715Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M85.655 81.392L84.6231 80.1609H85.4921L86.2434 81.392H85.655Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.5768 81.5596L84.2639 79.9933H85.5862L86.5421 81.5596H85.5768ZM85.655 81.392L84.6231 80.1609H85.4921L86.2434 81.392H85.655Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M91.5386 81.392L90.5067 80.1609H91.3757L92.127 81.392H91.5386Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.4604 81.5596L90.1475 79.9933H91.4698L92.4257 81.5596H91.4604ZM91.5386 81.392L90.5067 80.1609H91.3757L92.127 81.392H91.5386Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M96.0848 87.3991L98.6461 79.8893H99.3793L96.8179 87.3991H96.0848Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.8505 87.5667L98.5262 79.7217H99.6135L96.9378 87.5667H95.8505ZM96.0848 87.3991H96.8179L99.3792 79.8894H98.6461L96.0848 87.3991Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M103.306 81.392L102.274 80.1609H103.143L103.894 81.392H103.306Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.228 81.5596L101.915 79.9933H103.237L104.193 81.5596H103.228ZM103.306 81.392L102.274 80.1609H103.143L103.894 81.392H103.306Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M109.189 81.392L108.158 80.1609H109.027L109.778 81.392H109.189Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.111 81.5596L107.798 79.9933H109.121L110.076 81.5596H109.111ZM109.189 81.392L108.158 80.1609H109.027L109.778 81.392H109.189Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M115.073 81.392L114.041 80.1609H114.91L115.661 81.392H115.073Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.995 81.5596L113.682 79.9933H115.004L115.96 81.5596H114.995ZM115.073 81.392L114.041 80.1609H114.91L115.661 81.392H115.073Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M118.911 83.3285C118.911 81.3193 119.807 80.1065 121.264 80.1065C122.721 80.1065 123.617 81.3193 123.617 83.3285C123.617 85.3377 122.721 86.5505 121.264 86.5505C119.807 86.5505 118.911 85.3377 118.911 83.3285ZM122.812 83.3285C122.812 81.6994 122.278 80.8306 121.264 80.8306C120.25 80.8306 119.716 81.6904 119.716 83.3285C119.716 84.9667 120.25 85.8265 121.264 85.8265C122.278 85.8265 122.812 84.9576 122.812 83.3285Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.406 80.8649C119.844 80.2667 120.483 79.9388 121.264 79.9388C122.045 79.9388 122.684 80.2667 123.122 80.8649C123.556 81.4573 123.785 82.3017 123.785 83.3285C123.785 84.3553 123.556 85.1997 123.122 85.792C122.684 86.3902 122.045 86.7181 121.264 86.7181C120.483 86.7181 119.844 86.3902 119.406 85.792C118.972 85.1997 118.743 84.3553 118.743 83.3285C118.743 82.3017 118.972 81.4573 119.406 80.8649ZM122.275 81.5567C122.046 81.1857 121.713 80.9982 121.264 80.9982C120.814 80.9982 120.482 81.184 120.253 81.5535C120.016 81.9348 119.884 82.5227 119.884 83.3285C119.884 84.1342 120.016 84.7222 120.253 85.1034C120.482 85.473 120.814 85.6588 121.264 85.6588C121.713 85.6588 122.046 85.4713 122.275 85.1002C122.512 84.7176 122.644 84.1295 122.644 83.3285C122.644 82.5274 122.512 81.9393 122.275 81.5567ZM121.264 80.1065C119.807 80.1065 118.911 81.3192 118.911 83.3285C118.911 85.3377 119.807 86.5505 121.264 86.5505C122.721 86.5505 123.617 85.3377 123.617 83.3285C123.617 81.3192 122.721 80.1065 121.264 80.1065ZM121.264 80.8305C122.278 80.8305 122.812 81.6994 122.812 83.3285C122.812 84.9576 122.278 85.8264 121.264 85.8264C120.25 85.8264 119.716 84.9666 119.716 83.3285C119.716 81.6903 120.25 80.8305 121.264 80.8305Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M126.84 81.392L125.808 80.1609H126.677L127.429 81.392H126.84Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.762 81.5596L125.449 79.9933H126.771L127.727 81.5596H126.762ZM126.84 81.392L125.808 80.1609H126.677L127.429 81.392H126.84Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M132.724 81.392L131.692 80.1609H132.561L133.312 81.392H132.724Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M132.646 81.5596L131.333 79.9933H132.655L133.611 81.5596H132.646ZM132.724 81.392L131.692 80.1609H132.561L133.312 81.392H132.724Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M138.607 81.392L137.575 80.1609H138.444L139.196 81.392H138.607Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M138.529 81.5596L137.216 79.9933H138.538L139.494 81.5596H138.529ZM138.607 81.392L137.575 80.1609H138.444L139.196 81.392H138.607Z"
        fill="hsl(var(--content))"
      />
      <path d="M142.744 84.2318V83.6073H146.853V84.2318H142.744Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M142.576 84.3994V83.4396H147.021V84.3994H142.576ZM142.744 84.2318H146.853V83.6073H142.744V84.2318Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M151.985 82.6047C150.872 82.6047 150.537 83.4373 150.537 84.1704V85.8176H152.583V86.4964H148.655V85.8176H149.795V82.5594H148.655V81.8806H150.519V82.6771C150.727 82.3241 151.162 81.8806 152.067 81.8806H152.836V82.6047H151.985Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M152.75 85.65V86.664H148.487V85.65H149.627V82.727H148.487V81.713H150.687V82.2011C150.971 81.9351 151.407 81.713 152.067 81.713H153.004V82.7723H151.985C151.476 82.7723 151.166 82.9595 150.978 83.2126C150.784 83.4737 150.705 83.8254 150.705 84.1704V85.65H152.75ZM150.537 85.8176V84.1704C150.537 83.4373 150.872 82.6046 151.985 82.6046H152.836V81.8806H152.067C151.356 81.8806 150.935 82.1542 150.687 82.4426C150.619 82.5214 150.564 82.6013 150.519 82.677V81.8806H148.655V82.5594H149.795V85.8176H148.655V86.4964H152.583V85.8176H150.537Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M156.258 81.392L155.226 80.1609H156.095L156.847 81.392H156.258Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.18 81.5596L154.867 79.9933H156.189L157.145 81.5596H156.18ZM156.258 81.392L155.226 80.1609H156.095L156.846 81.392H156.258Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M162.142 81.392L161.11 80.1609H161.979L162.73 81.392H162.142Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M162.063 81.5596L160.75 79.9933H162.073L163.029 81.5596H162.063ZM162.142 81.392L161.11 80.1609H161.979L162.73 81.392H162.142Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M168.025 81.392L166.993 80.1609H167.862L168.614 81.392H168.025Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M167.947 81.5596L166.634 79.9933H167.956L168.912 81.5596H167.947ZM168.025 81.392L166.993 80.1609H167.862L168.614 81.392H168.025Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M173.909 81.392L172.877 80.1609H173.746L174.497 81.392H173.909Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M173.831 81.5596L172.518 79.9933H173.84L174.796 81.5596H173.831ZM173.909 81.392L172.877 80.1609H173.746L174.497 81.392H173.909Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M179.792 81.392L178.76 80.1609H179.629L180.381 81.392H179.792Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M179.714 81.5596L178.401 79.9933H179.724L180.68 81.5596H179.714ZM179.792 81.392L178.761 80.1609H179.63L180.381 81.392H179.792Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M188.228 83.1837V83.4733C188.228 85.4011 187.368 86.5505 185.984 86.5505C184.599 86.5505 183.739 85.4011 183.739 83.4733V83.1837C183.739 81.2559 184.599 80.1065 185.984 80.1065C187.368 80.1065 188.228 81.2559 188.228 83.1837ZM184.49 83.4462C184.49 83.7991 184.517 84.1159 184.572 84.3874L187.151 81.5455C186.898 81.0478 186.499 80.7853 185.984 80.7853C185.042 80.7853 184.49 81.6723 184.49 83.2109V83.4462ZM187.477 83.2109C187.477 82.8579 187.45 82.5411 187.395 82.2606L184.816 85.1205C185.079 85.6002 185.477 85.8627 185.984 85.8627C186.925 85.8627 187.477 84.9848 187.477 83.4462V83.2109Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M188.396 83.1837V83.4733C188.396 84.4594 188.176 85.2677 187.76 85.834C187.34 86.4062 186.728 86.7181 185.984 86.7181C185.239 86.7181 184.627 86.4062 184.207 85.834C183.791 85.2677 183.571 84.4594 183.571 83.4733V83.1837C183.571 82.1976 183.791 81.3893 184.207 80.8229C184.627 80.2507 185.239 79.9388 185.984 79.9388C186.728 79.9388 187.34 80.2507 187.76 80.8229C188.176 81.3893 188.396 82.1976 188.396 83.1837ZM184.572 84.3874L187.151 81.5455C186.898 81.0477 186.499 80.7853 185.984 80.7853C185.042 80.7853 184.49 81.6722 184.49 83.2108V83.4461C184.49 83.7115 184.506 83.9564 184.536 84.177C184.546 84.2498 184.558 84.32 184.572 84.3874ZM186.947 81.5214L184.685 84.0129C184.667 83.8388 184.658 83.6493 184.658 83.4461V83.2108C184.658 82.4577 184.794 81.8864 185.026 81.5091C185.254 81.1404 185.576 80.9529 185.984 80.9529C186.395 80.9529 186.719 81.1403 186.947 81.5214ZM187.395 82.2605L184.816 85.1205C185.078 85.6002 185.477 85.8627 185.984 85.8627C186.925 85.8627 187.477 84.9847 187.477 83.4461V83.2108C187.477 82.9439 187.461 82.6977 187.43 82.4721C187.42 82.3994 187.409 82.3289 187.395 82.2605ZM187.281 82.6372L185.023 85.1414C185.257 85.5086 185.582 85.695 185.984 85.695C186.392 85.695 186.713 85.5091 186.941 85.143C187.173 84.7681 187.309 84.1993 187.309 83.4461V83.2108C187.309 83.006 187.3 82.8148 187.281 82.6372ZM188.228 83.4733V83.1837C188.228 81.2559 187.368 80.1065 185.984 80.1065C184.599 80.1065 183.739 81.2559 183.739 83.1837V83.4733C183.739 85.4011 184.599 86.5505 185.984 86.5505C187.368 86.5505 188.228 85.4011 188.228 83.4733Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M191.56 81.392L190.528 80.1609H191.397L192.148 81.392H191.56Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M191.481 81.5596L190.168 79.9933H191.491L192.447 81.5596H191.481ZM191.56 81.392L190.528 80.1609H191.397L192.148 81.392H191.56Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M197.443 81.392L196.411 80.1609H197.28L198.032 81.392H197.443Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M197.365 81.5596L196.052 79.9933H197.374L198.33 81.5596H197.365ZM197.443 81.392L196.411 80.1609H197.28L198.032 81.392H197.443Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M203.064 85.9789C203.064 85.644 203.309 85.4177 203.634 85.4177C203.96 85.4177 204.205 85.644 204.205 85.9789C204.205 86.3138 203.96 86.5401 203.634 86.5401C203.309 86.5401 203.064 86.3138 203.064 85.9789Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M202.897 85.9789C202.897 85.5461 203.221 85.2501 203.635 85.2501C204.048 85.2501 204.372 85.5461 204.372 85.9789C204.372 86.4117 204.048 86.7078 203.635 86.7078C203.221 86.7078 202.897 86.4118 202.897 85.9789ZM203.635 85.4177C203.309 85.4177 203.064 85.644 203.064 85.9789C203.064 86.3139 203.309 86.5402 203.635 86.5402C203.96 86.5402 204.205 86.3139 204.205 85.9789C204.205 85.644 203.96 85.4177 203.635 85.4177Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M208.948 85.9789C208.948 85.644 209.192 85.4177 209.518 85.4177C209.844 85.4177 210.088 85.644 210.088 85.9789C210.088 86.3138 209.844 86.5401 209.518 86.5401C209.192 86.5401 208.948 86.3138 208.948 85.9789Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208.78 85.9789C208.78 85.5461 209.105 85.2501 209.518 85.2501C209.931 85.2501 210.256 85.5461 210.256 85.9789C210.256 86.4117 209.931 86.7078 209.518 86.7078C209.105 86.7078 208.78 86.4118 208.78 85.9789ZM209.518 85.4177C209.192 85.4177 208.948 85.644 208.948 85.9789C208.948 86.3139 209.192 86.5402 209.518 86.5402C209.844 86.5402 210.088 86.3139 210.088 85.9789C210.088 85.644 209.844 85.4177 209.518 85.4177Z"
        fill="hsl(var(--content))"
      />
      <path d="M213.347 84.2318V83.6073H217.456V84.2318H213.347Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M213.179 84.3994V83.4396H217.623V84.3994H213.179ZM213.347 84.2318H217.456V83.6073H213.347V84.2318Z"
        fill="hsl(var(--content))"
      />
      <path d="M219.23 84.2318V83.6073H223.339V84.2318H219.23Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.063 84.3994V83.4396H223.507V84.3994H219.063ZM219.23 84.2318H223.339V83.6073H219.23V84.2318Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M226.599 82.5868C226.599 82.2519 226.843 82.0256 227.169 82.0256C227.495 82.0256 227.739 82.2519 227.739 82.5868C227.739 82.9216 227.495 83.1479 227.169 83.1479C226.843 83.1479 226.599 82.9216 226.599 82.5868ZM226.599 85.9807C226.599 85.6459 226.843 85.4196 227.169 85.4196C227.495 85.4196 227.739 85.6459 227.739 85.9807C227.739 86.3156 227.495 86.5419 227.169 86.5419C226.843 86.5419 226.599 86.3156 226.599 85.9807Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.431 82.5867C226.431 82.154 226.756 81.858 227.169 81.858C227.582 81.858 227.907 82.154 227.907 82.5867C227.907 83.0195 227.582 83.3155 227.169 83.3155C226.756 83.3155 226.431 83.0195 226.431 82.5867ZM226.431 85.9807C226.431 85.5479 226.756 85.2519 227.169 85.2519C227.582 85.2519 227.907 85.5479 227.907 85.9807C227.907 86.4134 227.582 86.7095 227.169 86.7095C226.756 86.7095 226.431 86.4134 226.431 85.9807ZM227.169 82.0256C226.843 82.0256 226.599 82.2519 226.599 82.5867C226.599 82.9216 226.843 83.1479 227.169 83.1479C227.495 83.1479 227.739 82.9216 227.739 82.5867C227.739 82.2519 227.495 82.0256 227.169 82.0256ZM227.169 85.4196C226.843 85.4196 226.599 85.6458 226.599 85.9807C226.599 86.3156 226.843 86.5419 227.169 86.5419C227.495 86.5419 227.739 86.3156 227.739 85.9807C227.739 85.6458 227.495 85.4196 227.169 85.4196Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M232.482 82.5868C232.482 82.2519 232.726 82.0256 233.052 82.0256C233.378 82.0256 233.622 82.2519 233.622 82.5868C233.622 82.9216 233.378 83.1479 233.052 83.1479C232.726 83.1479 232.482 82.9216 232.482 82.5868ZM232.482 85.9807C232.482 85.6459 232.726 85.4196 233.052 85.4196C233.378 85.4196 233.622 85.6459 233.622 85.9807C233.622 86.3156 233.378 86.5419 233.052 86.5419C232.726 86.5419 232.482 86.3156 232.482 85.9807Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M232.314 82.5867C232.314 82.154 232.639 81.858 233.052 81.858C233.465 81.858 233.79 82.154 233.79 82.5867C233.79 83.0195 233.465 83.3155 233.052 83.3155C232.639 83.3155 232.314 83.0195 232.314 82.5867ZM232.314 85.9807C232.314 85.5479 232.639 85.2519 233.052 85.2519C233.465 85.2519 233.79 85.5479 233.79 85.9807C233.79 86.4134 233.465 86.7095 233.052 86.7095C232.639 86.7095 232.314 86.4134 232.314 85.9807ZM233.052 82.0256C232.726 82.0256 232.482 82.2519 232.482 82.5867C232.482 82.9216 232.726 83.1479 233.052 83.1479C233.378 83.1479 233.622 82.9216 233.622 82.5867C233.622 82.2519 233.378 82.0256 233.052 82.0256ZM233.052 85.4196C232.726 85.4196 232.482 85.6458 232.482 85.9807C232.482 86.3156 232.726 86.5419 233.052 86.5419C233.378 86.5419 233.622 86.3156 233.622 85.9807C233.622 85.6458 233.378 85.4196 233.052 85.4196Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M238.366 82.5868C238.366 82.2519 238.61 82.0256 238.936 82.0256C239.262 82.0256 239.506 82.2519 239.506 82.5868C239.506 82.9216 239.262 83.1479 238.936 83.1479C238.61 83.1479 238.366 82.9216 238.366 82.5868ZM238.366 85.9807C238.366 85.6459 238.61 85.4196 238.936 85.4196C239.262 85.4196 239.506 85.6459 239.506 85.9807C239.506 86.3156 239.262 86.5419 238.936 86.5419C238.61 86.5419 238.366 86.3156 238.366 85.9807Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M238.198 82.5867C238.198 82.154 238.523 81.858 238.936 81.858C239.349 81.858 239.674 82.154 239.674 82.5867C239.674 83.0195 239.349 83.3155 238.936 83.3155C238.523 83.3155 238.198 83.0195 238.198 82.5867ZM238.198 85.9807C238.198 85.5479 238.523 85.2519 238.936 85.2519C239.349 85.2519 239.674 85.5479 239.674 85.9807C239.674 86.4134 239.349 86.7095 238.936 86.7095C238.523 86.7095 238.198 86.4134 238.198 85.9807ZM238.936 82.0256C238.61 82.0256 238.366 82.2519 238.366 82.5867C238.366 82.9216 238.61 83.1479 238.936 83.1479C239.262 83.1479 239.506 82.9216 239.506 82.5867C239.506 82.2519 239.262 82.0256 238.936 82.0256ZM238.936 85.4196C238.61 85.4196 238.366 85.6458 238.366 85.9807C238.366 86.3156 238.61 86.5419 238.936 86.5419C239.262 86.5419 239.506 86.3156 239.506 85.9807C239.506 85.6458 239.262 85.4196 238.936 85.4196Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M244.448 85.8605V84.0323H242.729V83.3535H244.448V81.5344H245.19V83.3535H246.919V84.0323H245.19V85.8605H244.448Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M244.281 86.0281V84.1999H242.561V83.1858H244.281V81.3667H245.358V83.1858H247.087V84.1999H245.358V86.0281H244.281ZM245.19 84.0323H246.919V83.3535H245.19V81.5343H244.448V83.3535H242.729V84.0323H244.448V85.8605H245.19V84.0323Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M250.332 85.8605V84.0323H248.612V83.3535H250.332V81.5344H251.074V83.3535H252.803V84.0323H251.074V85.8605H250.332Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M250.164 86.0281V84.1999H248.445V83.1858H250.164V81.3667H251.242V83.1858H252.97V84.1999H251.242V86.0281H250.164ZM251.074 84.0323H252.803V83.3535H251.074V81.5343H250.332V83.3535H248.612V84.0323H250.332V85.8605H251.074V84.0323Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M256.215 85.8605V84.0323H254.496V83.3535H256.215V81.5344H256.958V83.3535H258.686V84.0323H256.958V85.8605H256.215Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M256.048 86.0281V84.1999H254.328V83.1858H256.048V81.3667H257.125V83.1858H258.854V84.1999H257.125V86.0281H256.048ZM256.958 84.0323H258.686V83.3535H256.958V81.5343H256.215V83.3535H254.496V84.0323H256.215V85.8605H256.958V84.0323Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M262.099 85.8605V84.0323H260.379V83.3535H262.099V81.5344H262.841V83.3535H264.57V84.0323H262.841V85.8605H262.099Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M261.931 86.0281V84.1999H260.212V83.1858H261.931V81.3667H263.009V83.1858H264.737V84.1999H263.009V86.0281H261.931ZM262.841 84.0323H264.57V83.3535H262.841V81.5343H262.099V83.3535H260.379V84.0323H262.099V85.8605H262.841V84.0323Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M267.983 85.8605V84.0323H266.263V83.3535H267.983V81.5344H268.725V83.3535H270.453V84.0323H268.725V85.8605H267.983Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M267.815 86.0281V84.1999H266.095V83.1858H267.815V81.3667H268.892V83.1858H270.621V84.1999H268.892V86.0281H267.815ZM268.725 84.0323H270.453V83.3535H268.725V81.5343H267.983V83.3535H266.263V84.0323H267.983V85.8605H268.725V84.0323Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M272.138 86.494V80.1586H272.925V82.91H275.55V80.1586H276.337V86.494H275.55V83.634H272.925V86.494H272.138Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M271.97 86.6616V79.9909H273.093V82.7423H275.382V79.9909H276.505V86.6616H275.382V83.8016H273.093V86.6616H271.97ZM272.925 83.634H275.55V86.4939H276.337V80.1585H275.55V82.9099H272.925V80.1585H272.138V86.4939H272.925V83.634Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M279.116 83.8808L278.609 83.4373L279.641 82.2516L278.157 81.6996L278.428 81.066L279.813 81.7086L279.795 80.1609H280.447L280.42 81.7177L281.822 81.066L282.085 81.7086L280.61 82.2607L281.623 83.4373L281.116 83.8808L280.112 82.6046L279.116 83.8808Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M279.139 84.1236L278.373 83.4533L279.356 82.3243L277.934 81.7953L278.342 80.8412L279.642 81.4445L279.625 79.9933H280.617L280.592 81.4528L281.911 80.8399L282.305 81.805L280.894 82.3334L281.859 83.4538L281.094 84.1231L280.112 82.8763L279.139 84.1236ZM280.112 82.6046L281.116 83.8807L281.623 83.4372L280.61 82.2607L282.085 81.7086L281.822 81.066L280.42 81.7176L280.447 80.1609H279.795L279.813 81.7086L278.428 81.066L278.157 81.6995L279.641 82.2516L278.609 83.4372L279.116 83.8807L280.112 82.6046Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M285 83.8808L284.493 83.4373L285.525 82.2516L284.04 81.6996L284.312 81.066L285.697 81.7086L285.679 80.1609H286.33L286.303 81.7177L287.706 81.066L287.968 81.7086L286.493 82.2607L287.507 83.4373L287 83.8808L285.995 82.6046L285 83.8808Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M285.023 84.1236L284.257 83.4533L285.239 82.3243L283.817 81.7953L284.226 80.8412L285.526 81.4445L285.509 79.9933H286.501L286.475 81.4528L287.795 80.8399L288.189 81.805L286.777 82.3334L287.742 83.4538L286.977 84.1231L285.996 82.8763L285.023 84.1236ZM285.995 82.6046L287 83.8807L287.507 83.4372L286.493 82.2607L287.968 81.7086L287.706 81.066L286.303 81.7176L286.33 80.1609H285.679L285.697 81.7086L284.312 81.066L284.04 81.6995L285.525 82.2516L284.493 83.4372L285 83.8807L285.995 82.6046Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M291.581 81.392L290.549 80.1609H291.418L292.169 81.392H291.581Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M291.502 81.5596L290.189 79.9933H291.512L292.468 81.5596H291.502ZM291.581 81.392L290.549 80.1609H291.418L292.169 81.392H291.581Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M297.464 81.392L296.432 80.1609H297.301L298.053 81.392H297.464Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M297.386 81.5596L296.073 79.9933H297.395L298.351 81.5596H297.386ZM297.464 81.392L296.432 80.1609H297.301L298.052 81.392H297.464Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M303.348 81.392L302.316 80.1609H303.185L303.936 81.392H303.348Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M303.27 81.5596L301.957 79.9933H303.279L304.235 81.5596H303.27ZM303.348 81.392L302.316 80.1609H303.185L303.936 81.392H303.348Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M307.231 83.5459L309.204 80.1609H309.865L311.847 83.5459H311.086L309.512 80.885L307.955 83.5459H307.231Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M306.939 83.7135L309.108 79.9933H309.961L312.139 83.7135H310.991L309.512 81.2155L308.051 83.7135H306.939ZM309.512 80.885L311.086 83.5458H311.847L309.865 80.1609H309.204L307.231 83.5458H307.955L309.512 80.885Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M313.114 83.5459L315.087 80.1609H315.748L317.73 83.5459H316.97L315.395 80.885L313.839 83.5459H313.114Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M312.823 83.7135L314.991 79.9933H315.844L318.023 83.7135H316.874L315.396 81.2155L313.935 83.7135H312.823ZM315.395 80.885L316.97 83.5458H317.73L315.748 80.1609H315.087L313.114 83.5458H313.838L315.395 80.885Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M343.259 85.8605V84.0323H341.539V83.3535H343.259V81.5344H344.001V83.3535H345.729V84.0323H344.001V85.8605H343.259Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M343.091 86.0281V84.1999H341.371V83.1858H343.091V81.3667H344.168V83.1858H345.897V84.1999H344.168V86.0281H343.091ZM344.001 84.0323H345.729V83.3535H344.001V81.5343H343.259V83.3535H341.539V84.0323H343.259V85.8605H344.001V84.0323Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M348.943 85.9789C348.943 85.644 349.187 85.4177 349.513 85.4177C349.839 85.4177 350.084 85.644 350.084 85.9789C350.084 86.3138 349.839 86.5401 349.513 86.5401C349.187 86.5401 348.943 86.3138 348.943 85.9789Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M348.775 85.9789C348.775 85.5461 349.1 85.2501 349.513 85.2501C349.926 85.2501 350.251 85.5461 350.251 85.9789C350.251 86.4118 349.926 86.7078 349.513 86.7078C349.1 86.7078 348.775 86.4117 348.775 85.9789ZM349.513 85.4177C349.187 85.4177 348.943 85.644 348.943 85.9789C348.943 86.3139 349.187 86.5402 349.513 86.5402C349.839 86.5402 350.084 86.3139 350.084 85.9789C350.084 85.644 349.839 85.4177 349.513 85.4177Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M354.827 85.9789C354.827 85.644 355.071 85.4177 355.397 85.4177C355.723 85.4177 355.967 85.644 355.967 85.9789C355.967 86.3138 355.723 86.5401 355.397 86.5401C355.071 86.5401 354.827 86.3138 354.827 85.9789Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M354.659 85.9789C354.659 85.5461 354.984 85.2501 355.397 85.2501C355.81 85.2501 356.135 85.5461 356.135 85.9789C356.135 86.4118 355.81 86.7078 355.397 86.7078C354.984 86.7078 354.659 86.4117 354.659 85.9789ZM355.397 85.4177C355.071 85.4177 354.827 85.644 354.827 85.9789C354.827 86.3139 355.071 86.5402 355.397 86.5402C355.723 86.5402 355.967 86.3139 355.967 85.9789C355.967 85.644 355.723 85.4177 355.397 85.4177Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M378.974 83.5459L380.947 80.1609H381.608L383.59 83.5459H382.83L381.255 80.885L379.698 83.5459H378.974Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M378.683 83.7135L380.851 79.9933H381.704L383.883 83.7135H382.734L381.256 81.2155L379.795 83.7135H378.683ZM381.255 80.885L382.83 83.5458H383.59L381.608 80.1609H380.947L378.974 83.5458H379.698L381.255 80.885Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M386.895 81.383L387.664 80.1609H388.533L387.474 81.383H386.895Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M386.591 81.5506L387.571 79.9933H388.9L387.55 81.5506H386.591ZM386.895 81.3829H387.474L388.533 80.1609H387.664L386.895 81.3829Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M392.778 81.383L393.548 80.1609H394.417L393.358 81.383H392.778Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M392.475 81.5506L393.455 79.9933H394.784L393.434 81.5506H392.475ZM392.778 81.3829H393.358L394.417 80.1609H393.548L392.778 81.3829Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M398.662 81.383L399.431 80.1609H400.3L399.241 81.383H398.662Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M398.358 81.5506L399.339 79.9933H400.667L399.318 81.5506H398.358ZM398.662 81.3829H399.241L400.3 80.1609H399.431L398.662 81.3829Z"
        fill="hsl(var(--content))"
      />
      <path d="M426.292 84.2318V83.6073H430.401V84.2318H426.292Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M426.124 84.3994V83.4396H430.568V84.3994H426.124ZM426.292 84.2318H430.401V83.6073H426.292V84.2318Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M435.063 87.6707C433.823 86.5031 433.207 85.2179 433.207 83.7789C433.207 82.3398 433.832 81.0366 435.063 79.8871H435.968C434.556 81.1904 433.94 82.376 433.94 83.7789C433.94 85.1817 434.556 86.3855 435.968 87.6707H435.063Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M434.996 87.8382L434.948 87.7927C433.681 86.6 433.04 85.2728 433.04 83.7788C433.04 82.285 433.69 80.9396 434.948 79.7646L434.997 79.7195H436.397L436.082 80.0103C434.691 81.2938 434.108 82.4379 434.108 83.7788C434.108 85.1204 434.692 86.2823 436.081 87.5467L436.401 87.8382H434.996ZM435.063 87.6706H435.968C435.906 87.6146 435.846 87.5587 435.788 87.503C434.503 86.2801 433.94 85.1205 433.94 83.7788C433.94 82.4364 434.504 81.2928 435.79 80.0547C435.848 79.9991 435.907 79.9432 435.968 79.8871H435.063C433.832 81.0365 433.207 82.3398 433.207 83.7788C433.207 85.2179 433.823 86.5031 435.063 87.6706Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M440.946 87.6707C439.707 86.5031 439.091 85.2179 439.091 83.7789C439.091 82.3398 439.716 81.0366 440.946 79.8871H441.852C440.44 81.1904 439.824 82.376 439.824 83.7789C439.824 85.1817 440.44 86.3855 441.852 87.6707H440.946Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M440.88 87.8382L440.832 87.7927C439.565 86.6 438.923 85.2728 438.923 83.7788C438.923 82.285 439.574 80.9396 440.832 79.7646L440.88 79.7195H442.28L441.965 80.0103C440.575 81.2938 439.992 82.4379 439.992 83.7788C439.992 85.1204 440.575 86.2823 441.964 87.5467L442.285 87.8382H440.88ZM440.946 87.6706H441.851C441.79 87.6146 441.73 87.5587 441.671 87.503C440.387 86.2801 439.824 85.1205 439.824 83.7788C439.824 82.4364 440.388 81.2928 441.674 80.0547C441.731 79.9991 441.791 79.9432 441.851 79.8871H440.946C439.716 81.0365 439.091 82.3398 439.091 83.7788C439.091 85.2179 439.707 86.5031 440.946 87.6706Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M446.83 87.6707C445.59 86.5031 444.974 85.2179 444.974 83.7789C444.974 82.3398 445.599 81.0366 446.83 79.8871H447.735C446.323 81.1904 445.708 82.376 445.708 83.7789C445.708 85.1817 446.323 86.3855 447.735 87.6707H446.83Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M446.763 87.8382L446.715 87.7927C445.448 86.6 444.807 85.2728 444.807 83.7788C444.807 82.285 445.457 80.9396 446.716 79.7646L446.764 79.7195H448.164L447.849 80.0103C446.458 81.2938 445.875 82.4379 445.875 83.7788C445.875 85.1204 446.459 86.2823 447.848 87.5467L448.168 87.8382H446.763ZM446.83 87.6706H447.735C447.673 87.6146 447.613 87.5587 447.555 87.503C446.271 86.2801 445.708 85.1205 445.708 83.7788C445.708 82.4364 446.271 81.2928 447.557 80.0547C447.615 79.9991 447.674 79.9432 447.735 79.8871H446.83C445.599 81.0365 444.975 82.3398 444.975 83.7788C444.975 85.2179 445.59 86.5031 446.83 87.6706Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M451.311 85.9789C451.311 85.644 451.555 85.4177 451.881 85.4177C452.207 85.4177 452.451 85.644 452.451 85.9789C452.451 86.3138 452.207 86.5401 451.881 86.5401C451.555 86.5401 451.311 86.3138 451.311 85.9789Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M451.143 85.9789C451.143 85.5461 451.468 85.2501 451.881 85.2501C452.294 85.2501 452.619 85.5461 452.619 85.9789C452.619 86.4118 452.294 86.7078 451.881 86.7078C451.468 86.7078 451.143 86.4118 451.143 85.9789ZM451.881 85.4177C451.555 85.4177 451.311 85.644 451.311 85.9789C451.311 86.3139 451.555 86.5402 451.881 86.5402C452.207 86.5402 452.451 86.3139 452.451 85.9789C452.451 85.644 452.207 85.4177 451.881 85.4177Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M457.194 85.9789C457.194 85.644 457.439 85.4177 457.765 85.4177C458.09 85.4177 458.335 85.644 458.335 85.9789C458.335 86.3138 458.09 86.5401 457.765 86.5401C457.439 86.5401 457.194 86.3138 457.194 85.9789Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M457.027 85.9789C457.027 85.5461 457.352 85.2501 457.765 85.2501C458.178 85.2501 458.502 85.5461 458.502 85.9789C458.502 86.4118 458.178 86.7078 457.765 86.7078C457.352 86.7078 457.027 86.4118 457.027 85.9789ZM457.765 85.4177C457.439 85.4177 457.194 85.644 457.194 85.9789C457.194 86.3139 457.439 86.5402 457.765 86.5402C458.09 86.5402 458.335 86.3139 458.335 85.9789C458.335 85.644 458.09 85.4177 457.765 85.4177Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M463.078 85.9789C463.078 85.644 463.322 85.4177 463.648 85.4177C463.974 85.4177 464.219 85.644 464.219 85.9789C464.219 86.3138 463.974 86.5401 463.648 86.5401C463.322 86.5401 463.078 86.3138 463.078 85.9789Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M462.91 85.9789C462.91 85.5461 463.235 85.2501 463.648 85.2501C464.061 85.2501 464.386 85.5461 464.386 85.9789C464.386 86.4118 464.061 86.7078 463.648 86.7078C463.235 86.7078 462.91 86.4118 462.91 85.9789ZM463.648 85.4177C463.322 85.4177 463.078 85.644 463.078 85.9789C463.078 86.3139 463.322 86.5402 463.648 86.5402C463.974 86.5402 464.218 86.3139 464.218 85.9789C464.218 85.644 463.974 85.4177 463.648 85.4177Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M468.961 83.8541C468.961 83.5192 469.206 83.2928 469.532 83.2928C469.858 83.2928 470.102 83.5192 470.102 83.8541C470.102 84.189 469.858 84.4153 469.532 84.4153C469.206 84.4153 468.961 84.189 468.961 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M468.794 83.854C468.794 83.4212 469.119 83.1251 469.532 83.1251C469.945 83.1251 470.27 83.4212 470.27 83.854C470.27 84.2868 469.945 84.5828 469.532 84.5828C469.119 84.5828 468.794 84.2868 468.794 83.854ZM469.532 83.2927C469.206 83.2927 468.961 83.5191 468.961 83.854C468.961 84.1889 469.206 84.4152 469.532 84.4152C469.857 84.4152 470.102 84.1889 470.102 83.854C470.102 83.5191 469.857 83.2927 469.532 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M474.845 83.8541C474.845 83.5192 475.089 83.2928 475.415 83.2928C475.741 83.2928 475.986 83.5192 475.986 83.8541C475.986 84.189 475.741 84.4153 475.415 84.4153C475.089 84.4153 474.845 84.189 474.845 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M474.677 83.854C474.677 83.4212 475.002 83.1251 475.415 83.1251C475.828 83.1251 476.153 83.4212 476.153 83.854C476.153 84.2868 475.828 84.5828 475.415 84.5828C475.002 84.5828 474.677 84.2868 474.677 83.854ZM475.415 83.2927C475.089 83.2927 474.845 83.5191 474.845 83.854C474.845 84.1889 475.089 84.4152 475.415 84.4152C475.741 84.4152 475.986 84.1889 475.986 83.854C475.986 83.5191 475.741 83.2927 475.415 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M480.729 83.8541C480.729 83.5192 480.973 83.2928 481.299 83.2928C481.625 83.2928 481.869 83.5192 481.869 83.8541C481.869 84.189 481.625 84.4153 481.299 84.4153C480.973 84.4153 480.729 84.189 480.729 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M480.561 83.854C480.561 83.4212 480.886 83.1251 481.299 83.1251C481.712 83.1251 482.037 83.4212 482.037 83.854C482.037 84.2868 481.712 84.5828 481.299 84.5828C480.886 84.5828 480.561 84.2868 480.561 83.854ZM481.299 83.2927C480.973 83.2927 480.729 83.5191 480.729 83.854C480.729 84.1889 480.973 84.4152 481.299 84.4152C481.625 84.4152 481.869 84.1889 481.869 83.854C481.869 83.5191 481.625 83.2927 481.299 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M486.612 83.8541C486.612 83.5192 486.857 83.2928 487.182 83.2928C487.508 83.2928 487.753 83.5192 487.753 83.8541C487.753 84.189 487.508 84.4153 487.182 84.4153C486.857 84.4153 486.612 84.189 486.612 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M486.445 83.854C486.445 83.4212 486.769 83.1251 487.182 83.1251C487.595 83.1251 487.92 83.4212 487.92 83.854C487.92 84.2868 487.595 84.5828 487.182 84.5828C486.769 84.5828 486.445 84.2868 486.445 83.854ZM487.182 83.2927C486.857 83.2927 486.612 83.5191 486.612 83.854C486.612 84.1889 486.857 84.4152 487.182 84.4152C487.508 84.4152 487.753 84.1889 487.753 83.854C487.753 83.5191 487.508 83.2927 487.182 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M492.692 85.8605V84.0323H490.973V83.3535H492.692V81.5344H493.435V83.3535H495.163V84.0323H493.435V85.8605H492.692Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M492.525 86.0281V84.1999H490.805V83.1858H492.525V81.3667H493.602V83.1858H495.331V84.1999H493.602V86.0281H492.525ZM493.435 84.0323H495.163V83.3535H493.435V81.5343H492.692V83.3535H490.973V84.0323H492.692V85.8605H493.435V84.0323Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M498.377 83.8541C498.377 83.5192 498.621 83.2928 498.947 83.2928C499.273 83.2928 499.518 83.5192 499.518 83.8541C499.518 84.189 499.273 84.4153 498.947 84.4153C498.621 84.4153 498.377 84.189 498.377 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M498.209 83.854C498.209 83.4212 498.534 83.1251 498.947 83.1251C499.36 83.1251 499.685 83.4212 499.685 83.854C499.685 84.2868 499.36 84.5828 498.947 84.5828C498.534 84.5828 498.209 84.2868 498.209 83.854ZM498.947 83.2927C498.621 83.2927 498.377 83.5191 498.377 83.854C498.377 84.1889 498.621 84.4152 498.947 84.4152C499.273 84.4152 499.518 84.1889 499.518 83.854C499.518 83.5191 499.273 83.2927 498.947 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M504.261 83.8541C504.261 83.5192 504.505 83.2928 504.831 83.2928C505.157 83.2928 505.401 83.5192 505.401 83.8541C505.401 84.189 505.157 84.4153 504.831 84.4153C504.505 84.4153 504.261 84.189 504.261 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M504.093 83.854C504.093 83.4212 504.418 83.1251 504.831 83.1251C505.244 83.1251 505.569 83.4212 505.569 83.854C505.569 84.2868 505.244 84.5828 504.831 84.5828C504.418 84.5828 504.093 84.2868 504.093 83.854ZM504.831 83.2927C504.505 83.2927 504.261 83.5191 504.261 83.854C504.261 84.1889 504.505 84.4152 504.831 84.4152C505.157 84.4152 505.401 84.1889 505.401 83.854C505.401 83.5191 505.157 83.2927 504.831 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M510.144 83.8541C510.144 83.5192 510.389 83.2928 510.715 83.2928C511.04 83.2928 511.285 83.5192 511.285 83.8541C511.285 84.189 511.04 84.4153 510.715 84.4153C510.389 84.4153 510.144 84.189 510.144 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M509.977 83.854C509.977 83.4212 510.301 83.1251 510.715 83.1251C511.128 83.1251 511.452 83.4212 511.452 83.854C511.452 84.2868 511.128 84.5828 510.715 84.5828C510.301 84.5828 509.977 84.2868 509.977 83.854ZM510.715 83.2927C510.389 83.2927 510.144 83.5191 510.144 83.854C510.144 84.1889 510.389 84.4152 510.715 84.4152C511.04 84.4152 511.285 84.1889 511.285 83.854C511.285 83.5191 511.04 83.2927 510.715 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M516.028 83.8541C516.028 83.5192 516.272 83.2928 516.598 83.2928C516.924 83.2928 517.168 83.5192 517.168 83.8541C517.168 84.189 516.924 84.4153 516.598 84.4153C516.272 84.4153 516.028 84.189 516.028 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M515.86 83.854C515.86 83.4212 516.185 83.1251 516.598 83.1251C517.011 83.1251 517.336 83.4212 517.336 83.854C517.336 84.2868 517.011 84.5828 516.598 84.5828C516.185 84.5828 515.86 84.2868 515.86 83.854ZM516.598 83.2927C516.272 83.2927 516.028 83.5191 516.028 83.854C516.028 84.1889 516.272 84.4152 516.598 84.4152C516.924 84.4152 517.168 84.1889 517.168 83.854C517.168 83.5191 516.924 83.2927 516.598 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M521.911 83.8541C521.911 83.5192 522.156 83.2928 522.482 83.2928C522.808 83.2928 523.052 83.5192 523.052 83.8541C523.052 84.189 522.808 84.4153 522.482 84.4153C522.156 84.4153 521.911 84.189 521.911 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M521.744 83.854C521.744 83.4212 522.069 83.1251 522.482 83.1251C522.895 83.1251 523.22 83.4212 523.22 83.854C523.22 84.2868 522.895 84.5828 522.482 84.5828C522.069 84.5828 521.744 84.2868 521.744 83.854ZM522.482 83.2927C522.156 83.2927 521.911 83.5191 521.911 83.854C521.911 84.1889 522.156 84.4152 522.482 84.4152C522.808 84.4152 523.052 84.1889 523.052 83.854C523.052 83.5191 522.808 83.2927 522.482 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M526.718 87.3991L529.279 79.8893H530.012L527.451 87.3991H526.718Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M526.484 87.5667L529.159 79.7217H530.246L527.571 87.5667H526.484ZM526.718 87.3991H527.451L530.012 79.8894H529.279L526.718 87.3991Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M532.149 86.494V80.1586H532.936V82.91H535.561V80.1586H536.348V86.494H535.561V83.634H532.936V86.494H532.149Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M531.981 86.6616V79.9909H533.104V82.7423H535.393V79.9909H536.516V86.6616H535.393V83.8016H533.104V86.6616H531.981ZM532.936 83.634H535.561V86.4939H536.348V80.1585H535.561V82.9099H532.936V80.1585H532.149V86.4939H532.936V83.634Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M538.141 83.0755V82.3967H542.123V83.0755H538.141ZM538.141 85.2204V84.5417H542.123V85.2204H538.141Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M537.973 83.243V82.229H542.291V83.243H537.973ZM537.973 85.388V84.374H542.291V85.388H537.973ZM538.141 83.0754H542.123V82.3966H538.141V83.0754ZM538.141 85.2204H542.123V84.5416H538.141V85.2204Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M545.446 83.8541C545.446 83.5192 545.69 83.2928 546.016 83.2928C546.342 83.2928 546.586 83.5192 546.586 83.8541C546.586 84.189 546.342 84.4153 546.016 84.4153C545.69 84.4153 545.446 84.189 545.446 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M545.278 83.854C545.278 83.4212 545.603 83.1251 546.016 83.1251C546.429 83.1251 546.754 83.4212 546.754 83.854C546.754 84.2868 546.429 84.5828 546.016 84.5828C545.603 84.5828 545.278 84.2868 545.278 83.854ZM546.016 83.2927C545.69 83.2927 545.446 83.5191 545.446 83.854C545.446 84.1889 545.69 84.4152 546.016 84.4152C546.342 84.4152 546.586 84.1889 546.586 83.854C546.586 83.5191 546.342 83.2927 546.016 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M551.329 83.8541C551.329 83.5192 551.574 83.2928 551.9 83.2928C552.226 83.2928 552.47 83.5192 552.47 83.8541C552.47 84.189 552.226 84.4153 551.9 84.4153C551.574 84.4153 551.329 84.189 551.329 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M551.162 83.854C551.162 83.4212 551.487 83.1251 551.9 83.1251C552.313 83.1251 552.638 83.4212 552.638 83.854C552.638 84.2868 552.313 84.5828 551.9 84.5828C551.487 84.5828 551.162 84.2868 551.162 83.854ZM551.9 83.2927C551.574 83.2927 551.329 83.5191 551.329 83.854C551.329 84.1889 551.574 84.4152 551.9 84.4152C552.226 84.4152 552.47 84.1889 552.47 83.854C552.47 83.5191 552.226 83.2927 551.9 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M557.213 83.8541C557.213 83.5192 557.457 83.2928 557.783 83.2928C558.109 83.2928 558.354 83.5192 558.354 83.8541C558.354 84.189 558.109 84.4153 557.783 84.4153C557.457 84.4153 557.213 84.189 557.213 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M557.045 83.854C557.045 83.4212 557.37 83.1251 557.783 83.1251C558.196 83.1251 558.521 83.4212 558.521 83.854C558.521 84.2868 558.196 84.5828 557.783 84.5828C557.37 84.5828 557.045 84.2868 557.045 83.854ZM557.783 83.2927C557.457 83.2927 557.213 83.5191 557.213 83.854C557.213 84.1889 557.457 84.4152 557.783 84.4152C558.109 84.4152 558.353 84.1889 558.353 83.854C558.353 83.5191 558.109 83.2927 557.783 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M563.096 83.8541C563.096 83.5192 563.341 83.2928 563.667 83.2928C563.993 83.2928 564.237 83.5192 564.237 83.8541C564.237 84.189 563.993 84.4153 563.667 84.4153C563.341 84.4153 563.096 84.189 563.096 83.8541Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M562.929 83.854C562.929 83.4212 563.254 83.1251 563.667 83.1251C564.08 83.1251 564.405 83.4212 564.405 83.854C564.405 84.2868 564.08 84.5828 563.667 84.5828C563.254 84.5828 562.929 84.2868 562.929 83.854ZM563.667 83.2927C563.341 83.2927 563.096 83.5191 563.096 83.854C563.096 84.1889 563.341 84.4152 563.667 84.4152C563.993 84.4152 564.237 84.1889 564.237 83.854C564.237 83.5191 563.993 83.2927 563.667 83.2927Z"
        fill="hsl(var(--content))"
      />
      <path d="M586.31 84.2318V83.6073H590.419V84.2318H586.31Z" fill="hsl(var(--content))" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M586.142 84.3994V83.4396H590.586V84.3994H586.142ZM586.31 84.2318H590.419V83.6073H586.31V84.2318Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M593.678 82.5868C593.678 82.2519 593.922 82.0256 594.248 82.0256C594.574 82.0256 594.818 82.2519 594.818 82.5868C594.818 82.9216 594.574 83.1479 594.248 83.1479C593.922 83.1479 593.678 82.9216 593.678 82.5868ZM593.678 85.9807C593.678 85.6459 593.922 85.4196 594.248 85.4196C594.574 85.4196 594.818 85.6459 594.818 85.9807C594.818 86.3156 594.574 86.5419 594.248 86.5419C593.922 86.5419 593.678 86.3156 593.678 85.9807Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M593.51 82.5867C593.51 82.154 593.835 81.858 594.248 81.858C594.661 81.858 594.986 82.154 594.986 82.5867C594.986 83.0195 594.661 83.3155 594.248 83.3155C593.835 83.3155 593.51 83.0195 593.51 82.5867ZM593.51 85.9807C593.51 85.5479 593.835 85.2519 594.248 85.2519C594.661 85.2519 594.986 85.5479 594.986 85.9807C594.986 86.4134 594.661 86.7095 594.248 86.7095C593.835 86.7095 593.51 86.4134 593.51 85.9807ZM594.248 82.0256C593.922 82.0256 593.678 82.2519 593.678 82.5867C593.678 82.9216 593.922 83.1479 594.248 83.1479C594.574 83.1479 594.818 82.9216 594.818 82.5867C594.818 82.2519 594.574 82.0256 594.248 82.0256ZM594.248 85.4196C593.922 85.4196 593.678 85.6458 593.678 85.9807C593.678 86.3156 593.922 86.5419 594.248 86.5419C594.574 86.5419 594.818 86.3156 594.818 85.9807C594.818 85.6458 594.574 85.4196 594.248 85.4196Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M599.561 82.5868C599.561 82.2519 599.806 82.0256 600.131 82.0256C600.457 82.0256 600.702 82.2519 600.702 82.5868C600.702 82.9216 600.457 83.1479 600.131 83.1479C599.806 83.1479 599.561 82.9216 599.561 82.5868ZM599.561 85.9807C599.561 85.6459 599.806 85.4196 600.131 85.4196C600.457 85.4196 600.702 85.6459 600.702 85.9807C600.702 86.3156 600.457 86.5419 600.131 86.5419C599.806 86.5419 599.561 86.3156 599.561 85.9807Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M599.394 82.5867C599.394 82.154 599.718 81.858 600.131 81.858C600.544 81.858 600.869 82.154 600.869 82.5867C600.869 83.0195 600.544 83.3155 600.131 83.3155C599.718 83.3155 599.394 83.0195 599.394 82.5867ZM599.394 85.9807C599.394 85.5479 599.718 85.2519 600.131 85.2519C600.544 85.2519 600.869 85.5479 600.869 85.9807C600.869 86.4134 600.544 86.7095 600.131 86.7095C599.718 86.7095 599.394 86.4134 599.394 85.9807ZM600.131 82.0256C599.806 82.0256 599.561 82.2519 599.561 82.5867C599.561 82.9216 599.806 83.1479 600.131 83.1479C600.457 83.1479 600.702 82.9216 600.702 82.5867C600.702 82.2519 600.457 82.0256 600.131 82.0256ZM600.131 85.4196C599.806 85.4196 599.561 85.6458 599.561 85.9807C599.561 86.3156 599.806 86.5419 600.131 86.5419C600.457 86.5419 600.702 86.3156 600.702 85.9807C600.702 85.6458 600.457 85.4196 600.131 85.4196Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M605.445 82.5868C605.445 82.2519 605.689 82.0256 606.015 82.0256C606.341 82.0256 606.585 82.2519 606.585 82.5868C606.585 82.9216 606.341 83.1479 606.015 83.1479C605.689 83.1479 605.445 82.9216 605.445 82.5868ZM605.445 85.9807C605.445 85.6459 605.689 85.4196 606.015 85.4196C606.341 85.4196 606.585 85.6459 606.585 85.9807C606.585 86.3156 606.341 86.5419 606.015 86.5419C605.689 86.5419 605.445 86.3156 605.445 85.9807Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M605.277 82.5867C605.277 82.154 605.602 81.858 606.015 81.858C606.428 81.858 606.753 82.154 606.753 82.5867C606.753 83.0195 606.428 83.3155 606.015 83.3155C605.602 83.3155 605.277 83.0195 605.277 82.5867ZM605.277 85.9807C605.277 85.5479 605.602 85.2519 606.015 85.2519C606.428 85.2519 606.753 85.5479 606.753 85.9807C606.753 86.4134 606.428 86.7095 606.015 86.7095C605.602 86.7095 605.277 86.4134 605.277 85.9807ZM606.015 82.0256C605.689 82.0256 605.445 82.2519 605.445 82.5867C605.445 82.9216 605.689 83.1479 606.015 83.1479C606.341 83.1479 606.585 82.9216 606.585 82.5867C606.585 82.2519 606.341 82.0256 606.015 82.0256ZM606.015 85.4196C605.689 85.4196 605.445 85.6458 605.445 85.9807C605.445 86.3156 605.689 86.5419 606.015 86.5419C606.341 86.5419 606.585 86.3156 606.585 85.9807C606.585 85.6458 606.341 85.4196 606.015 85.4196Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M611.328 82.5868C611.328 82.2519 611.573 82.0256 611.898 82.0256C612.224 82.0256 612.469 82.2519 612.469 82.5868C612.469 82.9216 612.224 83.1479 611.898 83.1479C611.573 83.1479 611.328 82.9216 611.328 82.5868ZM611.328 85.9807C611.328 85.6459 611.573 85.4196 611.898 85.4196C612.224 85.4196 612.469 85.6459 612.469 85.9807C612.469 86.3156 612.224 86.5419 611.898 86.5419C611.573 86.5419 611.328 86.3156 611.328 85.9807Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M611.161 82.5867C611.161 82.154 611.485 81.858 611.898 81.858C612.311 81.858 612.636 82.154 612.636 82.5867C612.636 83.0195 612.311 83.3155 611.898 83.3155C611.485 83.3155 611.161 83.0195 611.161 82.5867ZM611.161 85.9807C611.161 85.5479 611.485 85.2519 611.898 85.2519C612.311 85.2519 612.636 85.5479 612.636 85.9807C612.636 86.4134 612.311 86.7095 611.898 86.7095C611.485 86.7095 611.161 86.4134 611.161 85.9807ZM611.898 82.0256C611.573 82.0256 611.328 82.2519 611.328 82.5867C611.328 82.9216 611.573 83.1479 611.898 83.1479C612.224 83.1479 612.469 82.9216 612.469 82.5867C612.469 82.2519 612.224 82.0256 611.898 82.0256ZM611.898 85.4196C611.573 85.4196 611.328 85.6458 611.328 85.9807C611.328 86.3156 611.573 86.5419 611.898 86.5419C612.224 86.5419 612.469 86.3156 612.469 85.9807C612.469 85.6458 612.224 85.4196 611.898 85.4196Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M617.185 82.5868C617.185 82.2519 617.429 82.0256 617.755 82.0256C618.081 82.0256 618.325 82.2519 618.325 82.5868C618.325 82.9216 618.081 83.1479 617.755 83.1479C617.429 83.1479 617.185 82.9216 617.185 82.5868ZM617.239 87.3564C617.882 87.3474 618.081 86.8858 618.081 86.5419C618.081 86.4966 618.081 86.4514 618.063 86.4152C617.99 86.4966 617.845 86.5328 617.728 86.5328C617.429 86.5328 617.203 86.3518 617.203 85.9989C617.203 85.673 617.438 85.4196 617.854 85.4196C618.343 85.4196 618.642 85.8902 618.642 86.4333C618.642 87.284 618.117 87.809 617.239 87.8271V87.3564Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M617.071 87.1911L617.237 87.1888C617.514 87.1849 617.675 87.086 617.771 86.9688C617.839 86.8848 617.881 86.783 617.9 86.6813C617.842 86.6944 617.782 86.7004 617.728 86.7004C617.545 86.7004 617.369 86.6447 617.238 86.5196C617.105 86.393 617.035 86.2125 617.035 85.9988C617.035 85.7943 617.11 85.6037 617.258 85.4648C617.405 85.3263 617.612 85.2519 617.854 85.2519C618.159 85.2519 618.404 85.401 618.567 85.6238C618.727 85.8432 618.809 86.133 618.809 86.4332C618.809 86.8937 618.667 87.2837 618.388 87.5612C618.11 87.8381 617.714 87.9849 617.242 87.9946L617.071 87.9981V87.1911ZM617.913 86.5044C617.972 86.4851 618.026 86.4558 618.063 86.4151C618.081 86.4513 618.081 86.4964 618.081 86.5416C618.081 86.5653 618.08 86.5898 618.078 86.6144C618.051 86.9472 617.837 87.348 617.239 87.3564V87.827C617.296 87.8258 617.352 87.8225 617.407 87.817C618.183 87.7389 618.642 87.2284 618.642 86.4332C618.642 85.8902 618.343 85.4196 617.854 85.4196C617.438 85.4196 617.203 85.673 617.203 85.9988C617.203 86.3518 617.429 86.5328 617.728 86.5328C617.787 86.5328 617.852 86.5237 617.913 86.5044ZM617.017 82.5867C617.017 82.154 617.342 81.858 617.755 81.858C618.168 81.858 618.493 82.154 618.493 82.5867C618.493 83.0195 618.168 83.3155 617.755 83.3155C617.342 83.3155 617.017 83.0195 617.017 82.5867ZM617.755 82.0256C617.429 82.0256 617.185 82.2519 617.185 82.5867C617.185 82.9216 617.429 83.1479 617.755 83.1479C618.081 83.1479 618.325 82.9216 618.325 82.5867C618.325 82.2519 618.081 82.0256 617.755 82.0256Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M623.095 85.9789C623.095 85.644 623.34 85.4177 623.666 85.4177C623.992 85.4177 624.236 85.644 624.236 85.9789C624.236 86.3138 623.992 86.5401 623.666 86.5401C623.34 86.5401 623.095 86.3138 623.095 85.9789Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M622.928 85.9789C622.928 85.5461 623.253 85.2501 623.666 85.2501C624.079 85.2501 624.404 85.5461 624.404 85.9789C624.404 86.4118 624.079 86.7078 623.666 86.7078C623.253 86.7078 622.928 86.4118 622.928 85.9789ZM623.666 85.4177C623.34 85.4177 623.095 85.644 623.095 85.9789C623.095 86.3139 623.34 86.5402 623.666 86.5402C623.992 86.5402 624.236 86.3139 624.236 85.9789C624.236 85.644 623.992 85.4177 623.666 85.4177Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M631.791 83.1837V83.4733C631.791 85.4011 630.932 86.5505 629.547 86.5505C628.162 86.5505 627.302 85.4011 627.302 83.4733V83.1837C627.302 81.2559 628.162 80.1065 629.547 80.1065C630.932 80.1065 631.791 81.2559 631.791 83.1837ZM628.054 83.4462C628.054 83.7991 628.081 84.1159 628.135 84.3874L630.714 81.5455C630.461 81.0478 630.063 80.7853 629.547 80.7853C628.606 80.7853 628.054 81.6723 628.054 83.2109V83.4462ZM631.04 83.2109C631.04 82.8579 631.013 82.5411 630.959 82.2606L628.379 85.1205C628.642 85.6002 629.04 85.8627 629.547 85.8627C630.488 85.8627 631.04 84.9848 631.04 83.4462V83.2109Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M631.959 83.1837V83.4733C631.959 84.4594 631.74 85.2677 631.324 85.834C630.903 86.4062 630.292 86.7181 629.547 86.7181C628.802 86.7181 628.191 86.4062 627.77 85.834C627.354 85.2677 627.135 84.4594 627.135 83.4733V83.1837C627.135 82.1976 627.354 81.3893 627.77 80.8229C628.191 80.2507 628.802 79.9388 629.547 79.9388C630.292 79.9388 630.903 80.2507 631.324 80.8229C631.74 81.3893 631.959 82.1976 631.959 83.1837ZM628.135 84.3874L630.714 81.5455C630.461 81.0477 630.063 80.7853 629.547 80.7853C628.606 80.7853 628.054 81.6722 628.054 83.2108V83.4461C628.054 83.7115 628.069 83.9564 628.1 84.177C628.11 84.2498 628.122 84.32 628.135 84.3874ZM630.51 81.5214L628.249 84.0129C628.23 83.8388 628.221 83.6493 628.221 83.4461V83.2108C628.221 82.4577 628.357 81.8864 628.59 81.5091C628.818 81.1404 629.139 80.9529 629.547 80.9529C629.958 80.9529 630.283 81.1403 630.51 81.5214ZM630.959 82.2605L628.379 85.1205C628.642 85.6002 629.04 85.8627 629.547 85.8627C630.488 85.8627 631.04 84.9847 631.04 83.4461V83.2108C631.04 82.9439 631.025 82.6977 630.994 82.4721C630.984 82.3994 630.972 82.3289 630.959 82.2605ZM630.845 82.6372L628.586 85.1414C628.821 85.5086 629.146 85.695 629.547 85.695C629.956 85.695 630.277 85.5091 630.504 85.143C630.737 84.7681 630.873 84.1993 630.873 83.4461V83.2108C630.873 83.006 630.863 82.8148 630.845 82.6372ZM631.791 83.4733V83.1837C631.791 81.2559 630.932 80.1065 629.547 80.1065C628.162 80.1065 627.302 81.2559 627.302 83.1837V83.4733C627.302 85.4011 628.162 86.5505 629.547 86.5505C630.932 86.5505 631.791 85.4011 631.791 83.4733Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M654.778 85.788H656.38V86.494H652.362V85.788H654.027V82.0501C653.937 82.1135 653.828 82.1407 653.692 82.1407H652.38V81.4619H653.611C653.891 81.4619 654.036 81.2265 654.036 80.9188V80.1586H654.778V85.788Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M656.548 85.6204V86.6616H652.194V85.6204H653.86V82.2944C653.806 82.304 653.75 82.3082 653.692 82.3082H652.212V81.2942H653.611C653.698 81.2942 653.754 81.2608 653.794 81.2066C653.838 81.1465 653.869 81.0491 653.869 80.9188V79.9909H654.946V85.6204H656.548ZM654.778 85.788V80.1585H654.036V80.9188C654.036 81.2265 653.891 81.4618 653.611 81.4618H652.38V82.1406H653.692C653.753 82.1406 653.809 82.1351 653.86 82.1234C653.922 82.1089 653.977 82.085 654.027 82.0501V85.788H652.362V86.4939H656.38V85.788H654.778Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M663.296 85.8605V84.0323H661.576V83.3535H663.296V81.5344H664.038V83.3535H665.767V84.0323H664.038V85.8605H663.296Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M663.128 86.0281V84.1999H661.409V83.1858H663.128V81.3667H664.206V83.1858H665.934V84.1999H664.206V86.0281H663.128ZM664.038 84.0323H665.767V83.3535H664.038V81.5343H663.296V83.3535H661.576V84.0323H663.296V85.8605H664.038V84.0323Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M667.383 83.5459L669.356 80.1609H670.017L671.999 83.5459H671.239L669.664 80.885L668.107 83.5459H667.383Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M667.091 83.7135L669.26 79.9933H670.113L672.291 83.7135H671.143L669.665 81.2155L668.203 83.7135H667.091ZM669.664 80.885L671.239 83.5458H671.999L670.017 80.1609H669.356L667.383 83.5458H668.107L669.664 80.885Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M675.407 81.392L674.375 80.1609H675.245L675.996 81.392H675.407Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M675.329 81.5596L674.016 79.9933H675.339L676.294 81.5596H675.329ZM675.407 81.392L674.375 80.1609H675.244L675.996 81.392H675.407Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M681.431 81.392L680.399 80.1609H681.268L682.02 81.392H681.431Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M681.353 81.5596L680.04 79.9933H681.362L682.318 81.5596H681.353ZM681.431 81.392L680.399 80.1609H681.268L682.02 81.392H681.431Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M687.455 81.392L686.423 80.1609H687.292L688.044 81.392H687.455Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M687.377 81.5596L686.064 79.9933H687.386L688.342 81.5596H687.377ZM687.455 81.392L686.423 80.1609H687.292L688.044 81.392H687.455Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M693.481 81.392L692.449 80.1609H693.318L694.07 81.392H693.481Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M693.403 81.5596L692.09 79.9933H693.413L694.369 81.5596H693.403ZM693.482 81.392L692.45 80.1609H693.319L694.07 81.392H693.482Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M699.505 81.392L698.473 80.1609H699.342L700.094 81.392H699.505Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M699.427 81.5596L698.114 79.9933H699.436L700.392 81.5596H699.427ZM699.505 81.392L698.473 80.1609H699.342L700.094 81.392H699.505Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M703.828 86.494V80.1586H705.973C707.24 80.1586 708.081 80.9188 708.081 82.1044C708.081 82.9914 707.547 83.6793 706.733 83.9055L708.154 86.494H707.267L705.927 84.0594H704.615V86.494H703.828ZM704.615 83.3353H705.909C706.742 83.3353 707.276 82.8466 707.276 82.1044C707.276 81.3623 706.742 80.8826 705.918 80.8826H704.615V83.3353Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M703.66 86.6616V79.9909H705.973C706.639 79.9909 707.21 80.1913 707.615 80.5633C708.023 80.9367 708.249 81.4699 708.249 82.1044C708.249 82.9922 707.752 83.7033 706.977 84.0013L708.437 86.6616H707.168L705.828 84.227H704.783V86.6616H703.66ZM704.615 84.0593H705.927L707.267 86.4939H708.154L706.733 83.9055C706.788 83.8901 706.842 83.8725 706.895 83.8529C707.618 83.5846 708.081 82.931 708.081 82.1044C708.081 80.9188 707.24 80.1585 705.973 80.1585H703.828V86.4939H704.615V84.0593ZM704.783 83.1677H705.909C706.293 83.1677 706.592 83.0553 706.792 82.8739C706.991 82.6939 707.108 82.4331 707.108 82.1044C707.108 81.7758 706.991 81.5175 706.794 81.3398C706.594 81.1605 706.298 81.0502 705.918 81.0502H704.783V83.1677ZM705.909 83.3353C706.742 83.3353 707.276 82.8465 707.276 82.1044C707.276 81.3623 706.742 80.8826 705.918 80.8826H704.615V83.3353H705.909Z"
        fill="hsl(var(--content))"
      />
      <path
        d="M299.792 96.6527H298.163V101.685H299.792V102.336H295.747V101.685H297.376V96.6527H295.747V96.001H299.792V96.6527ZM298.045 95.458H297.457L296.425 94.2271H297.294L298.045 95.458Z"
        fill="hsl(var(--content))"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M299.96 96.8206H298.331V101.518H299.96V102.505H295.579V101.518H297.208V96.8206H295.579V95.8336H299.96V96.8206ZM297.376 96.6529V101.686H295.747V102.337H299.793V101.686H298.163V96.6529H299.793V96.0012H295.747V96.6529H297.376ZM298.344 95.6257H297.379L296.066 94.0594H297.388L298.344 95.6257ZM298.046 95.4581L297.294 94.2271H296.425L297.457 95.4581H298.046Z"
        fill="hsl(var(--content))"
      />
    </svg>
  );
}

export function X(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.53071 7.86068L10.6863 13.4687H14.7787L5.71311 1.09106H1.51691L6.53071 7.86068ZM6.53071 7.86068L1.77879 13.4687M9.56868 6.35521L14.0292 1.09106"
        stroke="var(--icon)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Discord(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.3855 1.40691C15.1742 0.880071 13.8959 0.504383 12.5826 0.289257C12.5706 0.287148 12.5583 0.288658 12.5473 0.293571C12.5364 0.298484 12.5273 0.306551 12.5215 0.316623C12.3572 0.593455 12.1753 0.954525 12.0479 1.23829C10.6119 1.03456 9.18311 1.03456 7.77655 1.23829C7.64919 0.948181 7.46065 0.593455 7.29569 0.316623C7.28958 0.306781 7.28048 0.298911 7.26957 0.294043C7.25867 0.289174 7.24648 0.287532 7.23458 0.289331C5.92111 0.503956 4.6427 0.879613 3.43155 1.40684C3.42119 1.41103 3.41245 1.41817 3.40656 1.42727C0.984397 4.85606 0.320821 8.20055 0.646381 11.5036C0.647302 11.5117 0.649926 11.5195 0.654098 11.5266C0.65827 11.5337 0.663905 11.5399 0.67067 11.545C2.26873 12.657 3.81674 13.3321 5.33602 13.7795C5.34783 13.7829 5.36044 13.7827 5.37216 13.7791C5.38387 13.7754 5.39413 13.7685 5.40157 13.7592C5.76091 13.2942 6.08126 12.8038 6.35598 12.2882C6.35976 12.2811 6.36191 12.2734 6.36231 12.2655C6.3627 12.2576 6.36132 12.2497 6.35826 12.2423C6.3552 12.235 6.35053 12.2283 6.34456 12.2228C6.33858 12.2172 6.33144 12.213 6.3236 12.2102C5.81541 12.0276 5.33158 11.8049 4.86613 11.552C4.85764 11.5473 4.85051 11.5407 4.84537 11.5327C4.84023 11.5248 4.83723 11.5157 4.83665 11.5064C4.83606 11.4971 4.83791 11.4878 4.84202 11.4793C4.84613 11.4709 4.85238 11.4635 4.86021 11.4578C4.95815 11.3883 5.05616 11.316 5.14965 11.2429C5.15796 11.2364 5.16802 11.2322 5.17869 11.2309C5.18936 11.2295 5.20023 11.231 5.21006 11.2352C8.26777 12.5579 11.578 12.5579 14.5996 11.2352C14.6095 11.2307 14.6204 11.229 14.6312 11.2303C14.6421 11.2315 14.6523 11.2356 14.6607 11.2422C14.7543 11.3152 14.8522 11.3883 14.9509 11.4578C14.9588 11.4634 14.9651 11.4708 14.9692 11.4792C14.9734 11.4876 14.9753 11.4969 14.9748 11.5062C14.9743 11.5155 14.9714 11.5245 14.9663 11.5325C14.9613 11.5405 14.9542 11.5472 14.9458 11.552C14.4802 11.8097 13.9924 12.0296 13.4877 12.2095C13.4799 12.2123 13.4728 12.2167 13.4668 12.2223C13.4609 12.228 13.4563 12.2347 13.4533 12.2421C13.4503 12.2496 13.449 12.2575 13.4495 12.2654C13.4499 12.2734 13.4522 12.2811 13.456 12.2882C13.7366 12.8031 14.0569 13.2934 14.4097 13.7584C14.4169 13.768 14.4271 13.7752 14.4388 13.779C14.4506 13.7828 14.4633 13.783 14.4752 13.7795C16.0018 13.332 17.5498 12.6569 19.1479 11.545C19.1548 11.5402 19.1605 11.5341 19.1647 11.5271C19.1689 11.5201 19.1715 11.5123 19.1722 11.5042C19.5618 7.68554 18.5197 4.36849 16.4098 1.42794C16.4046 1.41838 16.396 1.4109 16.3855 1.40684V1.40691ZM6.81256 9.49236C5.89201 9.49236 5.13346 8.69151 5.13346 7.70803C5.13346 6.72463 5.8773 5.92378 6.81264 5.92378C7.75522 5.92378 8.50638 6.73163 8.49166 7.70811C8.49166 8.69151 7.74783 9.49236 6.81256 9.49236ZM13.0208 9.49236C12.1002 9.49236 11.3417 8.69151 11.3417 7.70803C11.3417 6.72463 12.0854 5.92378 13.0208 5.92378C13.9634 5.92378 14.7145 6.73163 14.6998 7.70811C14.6998 8.69151 13.9634 9.49236 13.0208 9.49236Z"
        fill="var(--icon)"
      />
    </svg>
  );
}

export function Github(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.38443 0.966553C4.2231 0.966553 0.0426636 5.25553 0.0426636 10.5455C0.0426636 14.7786 2.71908 18.3683 6.4301 19.6335C6.89718 19.7237 7.06845 19.4276 7.06845 19.1729C7.06845 18.9454 7.06067 18.3428 7.05677 17.5445C4.45821 18.1225 3.91015 16.2593 3.91015 16.2593C3.4851 15.1538 2.87088 14.8584 2.87088 14.8584C2.02467 14.2645 2.93628 14.2765 2.93628 14.2765C3.87434 14.3436 4.36712 15.2631 4.36712 15.2631C5.2001 16.7279 6.55387 16.3048 7.08791 16.0598C7.17199 15.4403 7.41254 15.0181 7.67956 14.7786C5.60491 14.5391 3.42438 13.7153 3.42438 10.045C3.42438 8.9993 3.78638 8.14518 4.38581 7.47465C4.28071 7.23278 3.96543 6.25892 4.46755 4.93942C4.46755 4.93942 5.24992 4.68239 7.03653 5.92127C7.78387 5.70813 8.57792 5.60277 9.37197 5.59798C10.166 5.60277 10.9601 5.70813 11.7074 5.92127C13.4824 4.68239 14.2647 4.93942 14.2647 4.93942C14.7668 6.25892 14.4516 7.23278 14.3581 7.47465C14.9537 8.14518 15.3157 8.9993 15.3157 10.045C15.3157 13.7249 13.132 14.5351 11.0535 14.7706C11.3805 15.058 11.6841 15.6455 11.6841 16.5427C11.6841 17.8247 11.6724 18.8544 11.6724 19.1658C11.6724 19.4172 11.8359 19.7166 12.3146 19.6208C16.0521 18.3643 18.7262 14.7722 18.7262 10.5455C18.7262 5.25553 14.5434 0.966553 9.38443 0.966553Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Youtube(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="21"
      height="15"
      viewBox="0 0 21 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.9942 2.53253C19.8818 2.09858 19.6602 1.70252 19.3515 1.38401C19.0428 1.06549 18.6579 0.835705 18.2353 0.717652C16.6844 0.288574 10.4634 0.288574 10.4634 0.288574C10.4634 0.288574 4.24248 0.288574 2.69077 0.717652C2.26836 0.835913 1.88365 1.06579 1.57512 1.38428C1.26659 1.70277 1.04505 2.09872 0.932653 2.53253C0.516541 4.13328 0.516541 7.47245 0.516541 7.47245C0.516541 7.47245 0.516541 10.8116 0.932653 12.4124C1.04504 12.8463 1.26668 13.2424 1.57538 13.5609C1.88408 13.8794 2.269 14.1092 2.6916 14.2272C4.24248 14.6563 10.4634 14.6563 10.4634 14.6563C10.4634 14.6563 16.6844 14.6563 18.2361 14.2272C18.6588 14.1093 19.0437 13.8795 19.3524 13.561C19.6611 13.2424 19.8827 12.8463 19.9951 12.4124C20.4103 10.8116 20.4103 7.47245 20.4103 7.47245C20.4103 7.47245 20.4103 4.13328 19.9942 2.53253ZM8.42847 10.504V4.44086L13.6282 7.47245L8.42847 10.504Z"
        fill="var(--icon)"
      />
    </svg>
  );
}

export function Clarity(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 91.49 91.49"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M27.47,22.73c2.32-2.25,5.5-3.37,9.57-3.37V23.6q-4.2.11-6.27,2.58c-1.38,1.65-2.08,4.12-2.08,7.42V57.89c0,3.3.7,5.77,2.08,7.42s3.47,2.51,6.27,2.57v4.25c-4.07,0-7.25-1.12-9.57-3.37S24,63,24,58.29V33.2Q24,26.1,27.47,22.73Z" />
      <path d="M42.69,22.73q3.48-3.37,9.57-3.37V23.6q-4.18.11-6.27,2.58T43.92,33.6V57.89q0,4.95,2.07,7.42t6.27,2.57v4.25q-6.09,0-9.57-3.37T39.22,58.29V33.2Q39.22,26.1,42.69,22.73Z" />
      <path d="M57.92,22.73q3.46-3.37,9.57-3.37V23.6q-4.2.11-6.27,2.58T59.14,33.6V57.89q0,4.95,2.08,7.42t6.27,2.57v4.25q-6.1,0-9.57-3.37T54.45,58.29V33.2Q54.45,26.1,57.92,22.73Z" />
    </svg>
  );
}

export function StacksCardIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="92"
      height="88"
      viewBox="0 0 92 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_1005_5937)">
        <rect
          x="17.3506"
          y="-0.551514"
          width="72"
          height="72"
          rx="8"
          transform="rotate(7.98575 17.3506 -0.551514)"
          fill="#141312"
          fillOpacity="0.4"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_1005_5937)">
        <rect x="4" y="0.09375" width="72" height="72" rx="8" fill="#141312" />
      </g>
      <g clipPath="url(#clip0_1005_5937)">
        <path
          d="M31.125 17.0767C31.1165 17.0734 31.1072 17.0715 31.0975 17.0715H26.3462C26.1729 17.0715 26.0179 16.9802 25.9369 16.8283C25.8559 16.6765 25.8654 16.4976 25.9608 16.3508C25.9609 16.3507 25.9609 16.3505 25.961 16.3504L29.0651 11.7376L29.0652 11.7373C29.1278 11.6435 29.133 11.5276 29.081 11.4289C29.0284 11.3289 28.9277 11.2709 28.8181 11.2709H27.6038C27.5065 11.2709 27.4108 11.3169 27.3562 11.4033L23.7217 16.806L23.7215 16.8063C23.6099 16.9737 23.4252 17.0715 23.2219 17.0715H22.77C22.5667 17.0715 22.382 16.9737 22.2704 16.8063L22.2702 16.806L18.6435 11.4072C18.589 11.3209 18.4932 11.2749 18.3959 11.2749H17.1816C17.0711 11.2749 16.967 11.3376 16.9148 11.4368C16.8619 11.5372 16.8732 11.6525 16.93 11.7404L16.93 11.7404L16.9307 11.7415L20.0354 16.3553L20.0354 16.3553L20.0359 16.356C20.1332 16.497 20.1406 16.6751 20.0589 16.8283L20.0586 16.8289C19.9774 16.9846 19.8263 17.0755 19.6496 17.0755H14.9022C14.7342 17.0755 14.6032 17.2121 14.6032 17.3745V18.3805C14.6032 18.5486 14.7398 18.6795 14.9022 18.6795H31.0975C31.2655 18.6795 31.3965 18.5429 31.3965 18.3805V17.3745C31.3965 17.216 31.275 17.0905 31.125 17.0767Z"
          fill="#F6F5F3"
          stroke="#F6F5F3"
          strokeWidth="0.15"
          strokeLinejoin="round"
        />
        <path
          d="M16.9307 28.3208L16.9306 28.3211C16.868 28.4149 16.8628 28.5307 16.9148 28.6295C16.9674 28.7295 17.0681 28.7874 17.1777 28.7874H18.392C18.4893 28.7874 18.585 28.7414 18.6396 28.6551L22.2741 23.2524L22.2743 23.2521C22.3859 23.0847 22.5706 22.9868 22.7739 22.9868H23.2258C23.4291 22.9868 23.6138 23.0847 23.7254 23.2521L23.7256 23.2523L27.3568 28.656L27.3573 28.6567C27.4142 28.7395 27.504 28.7874 27.6038 28.7874H28.8181C28.9287 28.7874 29.0327 28.7247 29.0849 28.6255C29.1378 28.5251 29.1266 28.4098 29.0697 28.3219L29.0698 28.3219L29.069 28.3208L25.9644 23.707L25.9638 23.7063C25.8665 23.5653 25.8591 23.3872 25.9408 23.234L25.9411 23.2334C26.0224 23.0777 26.1734 22.9868 26.3501 22.9868H31.0975C31.2655 22.9868 31.3965 22.8502 31.3965 22.6878V21.6818C31.3965 21.5137 31.2599 21.3828 31.0975 21.3828C31.0891 21.3828 31.081 21.3841 31.0735 21.3867H14.9022C14.7342 21.3867 14.6032 21.5233 14.6032 21.6857V22.6918C14.6032 22.8598 14.7398 22.9908 14.9022 22.9908H19.6496C19.8229 22.9908 19.9779 23.0822 20.0589 23.234C20.1401 23.3862 20.1301 23.5648 20.0353 23.7072C20.0353 23.7072 20.0352 23.7073 20.0352 23.7073L16.9307 28.3208Z"
          fill="#F6F5F3"
          stroke="#F6F5F3"
          strokeWidth="0.15"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1005_5937"
          x="4.38086"
          y="0.481323"
          width="87.2388"
          height="87.2389"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.709804 0 0 0 0 0.67451 0 0 0 0 0.631373 0 0 0 0.28 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1005_5937" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1005_5937"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_1005_5937"
          x="0"
          y="0.09375"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.709804 0 0 0 0 0.67451 0 0 0 0 0.631373 0 0 0 0.28 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1005_5937" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1005_5937"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1005_5937">
          <rect width="22" height="22" fill="white" transform="translate(12 9.02917)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BitcoinCardIcon(): JSX.Element {
  return (
    <svg width="92" height="89" viewBox="0 0 92 89" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_1005_5478)">
        <rect
          x="17.3506"
          y="-0.0983887"
          width="72"
          height="72"
          rx="8"
          transform="rotate(7.98575 17.3506 -0.0983887)"
          fill="#FF7733"
          fillOpacity="0.4"
          style={{ fill: '#FF7733', fillOpacity: 0.4 }}
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_1005_5478)">
        <rect
          x="4"
          y="0.546875"
          width="72"
          height="72"
          rx="8"
          fill="#FF7733"
          style={{ fill: '#FF7733' }}
        />
      </g>
      <g clipPath="url(#clip0_1005_5478)">
        <path
          d="M16.5808 15.2339H26.2178C26.8972 15.2339 27.5487 15.5037 28.029 15.9841C28.5094 16.4645 28.7792 17.116 28.7792 17.7953V17.929C28.7792 18.6084 28.5094 19.2599 28.029 19.7402C27.5487 20.2206 26.8972 20.4904 26.2178 20.4904H16.5808V15.2339Z"
          stroke="#141312"
          style={{ stroke: '#141312' }}
          strokeWidth="1.69531"
          strokeMiterlimit="10"
        />
        <path
          d="M16.5798 20.4905H26.792C27.1372 20.4905 27.4789 20.5585 27.7978 20.6905C28.1167 20.8226 28.4064 21.0162 28.6505 21.2603C28.8945 21.5043 29.0881 21.7941 29.2202 22.113C29.3523 22.4318 29.4203 22.7736 29.4203 23.1188V23.1188C29.4203 23.8158 29.1434 24.4843 28.6505 24.9772C28.1576 25.4701 27.4891 25.747 26.792 25.747H16.5798V20.4905Z"
          stroke="#141312"
          style={{ stroke: '#141312' }}
          strokeWidth="1.69531"
          strokeMiterlimit="10"
        />
        <path
          d="M20.1416 11.3553V14.8065"
          stroke="#141312"
          style={{ stroke: '#141312' }}
          strokeWidth="1.69531"
          strokeMiterlimit="10"
        />
        <path
          d="M24.2937 11.3553V14.8065"
          stroke="#141312"
          style={{ stroke: '#141312' }}
          strokeWidth="1.69531"
          strokeMiterlimit="10"
        />
        <path
          d="M20.1416 26.1293V29.609"
          stroke="#141312"
          style={{ stroke: '#141312' }}
          strokeWidth="1.69531"
          strokeMiterlimit="10"
        />
        <path
          d="M24.2947 26.1295V29.6093"
          stroke="#141312"
          style={{ stroke: '#141312' }}
          strokeWidth="1.69531"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1005_5478"
          x="4.38062"
          y="0.934448"
          width="87.239"
          height="87.2389"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0.33 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1005_5478" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1005_5478"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_1005_5478"
          x="0"
          y="0.546875"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0.33 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1005_5478" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1005_5478"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1005_5478">
          <rect
            width="22"
            height="22"
            fill="white"
            style={{ fill: 'white' }}
            transform="translate(12 9.4823)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CircleDot(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_834_787)">
        <path
          d="M6.63783 2.31563C6.62128 2.25202 6.61743 2.18577 6.62651 2.12067C6.63559 2.05557 6.65741 1.9929 6.69073 1.93624C6.72405 1.87959 6.76821 1.83006 6.8207 1.79048C6.87318 1.75091 6.93295 1.72208 6.99658 1.70563C8.06248 1.43073 9.18069 1.43073 10.2466 1.70563C10.3646 1.73585 10.4676 1.80816 10.5361 1.90895C10.6046 2.00975 10.6339 2.13209 10.6186 2.25299C10.6032 2.37389 10.5443 2.48502 10.4527 2.56549C10.3612 2.64596 10.2435 2.69024 10.1216 2.69C10.0794 2.68978 10.0374 2.68432 9.99658 2.67375C9.09467 2.44113 8.14849 2.44113 7.24658 2.67375C7.11837 2.70683 6.98228 2.6877 6.86816 2.62056C6.75404 2.55342 6.67121 2.44376 6.63783 2.31563ZM3.98346 3.44625C3.21261 4.23121 2.6535 5.19889 2.35846 6.25875C2.32307 6.38655 2.3399 6.52318 2.40524 6.63857C2.47059 6.75397 2.57909 6.83868 2.7069 6.87406C2.8347 6.90945 2.97132 6.89263 3.08672 6.82728C3.20211 6.76194 3.28682 6.65343 3.32221 6.52563C3.57163 5.62848 4.04474 4.80935 4.69721 4.145C4.78255 4.049 4.82767 3.92384 4.82322 3.79547C4.81877 3.6671 4.76509 3.54537 4.6733 3.45551C4.58152 3.36565 4.45867 3.31457 4.33023 3.31284C4.2018 3.31112 4.07762 3.35889 3.98346 3.44625ZM3.32221 9.47188C3.30464 9.4086 3.27479 9.34939 3.23434 9.29765C3.1939 9.24591 3.14366 9.20264 3.08649 9.17031C3.02933 9.13799 2.96636 9.11724 2.90117 9.10925C2.83598 9.10126 2.76986 9.10619 2.70658 9.12375C2.6433 9.14132 2.5841 9.17117 2.53236 9.21162C2.48062 9.25206 2.43735 9.3023 2.40502 9.35947C2.37269 9.41663 2.35194 9.47961 2.34395 9.54479C2.33597 9.60998 2.34089 9.6761 2.35846 9.73938C2.65368 10.7992 3.21276 11.7668 3.98346 12.5519C4.07645 12.6464 4.2032 12.7002 4.33582 12.7013C4.46845 12.7024 4.59608 12.6508 4.69065 12.5578C4.78521 12.4648 4.83896 12.3381 4.84008 12.2055C4.84119 12.0728 4.78957 11.9452 4.69658 11.8506C4.04492 11.1865 3.57209 10.3681 3.32221 9.47188ZM9.99658 13.3263C9.09471 13.5591 8.14846 13.5591 7.24658 13.3263C7.18265 13.3087 7.11585 13.304 7.0501 13.3125C6.98434 13.321 6.92093 13.3425 6.86355 13.3758C6.80618 13.409 6.75599 13.4533 6.7159 13.5061C6.67582 13.5589 6.64664 13.6192 6.63006 13.6834C6.61348 13.7476 6.60984 13.8144 6.61934 13.8801C6.62884 13.9457 6.6513 14.0088 6.68541 14.0656C6.71952 14.1225 6.7646 14.172 6.81802 14.2113C6.87144 14.2505 6.93214 14.2788 6.99658 14.2944C8.06248 14.5693 9.18069 14.5693 10.2466 14.2944C10.3732 14.2596 10.481 14.1765 10.5468 14.0629C10.6126 13.9493 10.6311 13.8143 10.5983 13.6872C10.5655 13.5601 10.484 13.451 10.3714 13.3835C10.2588 13.3159 10.1242 13.2954 9.99658 13.3263ZM14.5372 9.125C14.4739 9.10744 14.4077 9.10253 14.3425 9.11055C14.2773 9.11857 14.2143 9.13938 14.1571 9.17177C14.0999 9.20416 14.0497 9.2475 14.0093 9.29932C13.9689 9.35113 13.9391 9.41041 13.9216 9.47375C13.6723 10.3708 13.1992 11.1897 12.5466 11.8538C12.5006 11.9006 12.4643 11.9561 12.4397 12.017C12.4151 12.0779 12.4028 12.143 12.4034 12.2087C12.404 12.2744 12.4175 12.3393 12.4432 12.3997C12.4689 12.4602 12.5063 12.5149 12.5531 12.5609C12.6 12.6069 12.6555 12.6433 12.7164 12.6678C12.7773 12.6924 12.8424 12.7047 12.9081 12.7041C12.9738 12.7035 13.0387 12.69 13.0991 12.6643C13.1595 12.6386 13.2143 12.6012 13.2603 12.5544C14.0313 11.7695 14.5904 10.8018 14.8853 9.74188C14.9031 9.67851 14.9082 9.61227 14.9003 9.54694C14.8924 9.48161 14.8717 9.41847 14.8393 9.36116C14.807 9.30385 14.7637 9.25349 14.7118 9.21297C14.66 9.17244 14.6006 9.14255 14.5372 9.125ZM13.921 6.52875C13.9385 6.59203 13.9684 6.65123 14.0088 6.70298C14.0493 6.75472 14.0995 6.79799 14.1567 6.83032C14.2138 6.86264 14.2768 6.88339 14.342 6.89138C14.4072 6.89937 14.4733 6.89444 14.5366 6.87688C14.5999 6.85931 14.6591 6.82946 14.7108 6.78901C14.7626 6.74857 14.8058 6.69833 14.8381 6.64116C14.8705 6.584 14.8912 6.52102 14.8992 6.45584C14.9072 6.39065 14.9023 6.32453 14.8847 6.26125C14.5898 5.20134 14.0307 4.23362 13.2597 3.44875C13.2137 3.40193 13.1588 3.36463 13.0984 3.33899C13.0379 3.31335 12.973 3.29987 12.9073 3.29932C12.8417 3.29877 12.7765 3.31116 12.7157 3.33578C12.6548 3.3604 12.5993 3.39677 12.5525 3.44281C12.5057 3.48886 12.4684 3.54368 12.4428 3.60414C12.4171 3.66459 12.4036 3.72951 12.4031 3.79518C12.4025 3.86085 12.4149 3.92598 12.4395 3.98686C12.4642 4.04774 12.5005 4.10318 12.5466 4.15C13.1985 4.81372 13.6713 5.63194 13.921 6.52813V6.52875Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_834_787">
          <rect width="16" height="16" fill="white" transform="translate(0.621582)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function HalfCircle(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.62158 1.5C7.33601 1.5 6.0793 1.88122 5.01038 2.59545C3.94146 3.30968 3.10834 4.32484 2.61637 5.51256C2.1244 6.70028 1.99568 8.00721 2.24648 9.26809C2.49728 10.529 3.11635 11.6872 4.02539 12.5962C4.93443 13.5052 6.09262 14.1243 7.3535 14.3751C8.61437 14.6259 9.92131 14.4972 11.109 14.0052C12.2967 13.5132 13.3119 12.6801 14.0261 11.6112C14.7404 10.5423 15.1216 9.28558 15.1216 8C15.1198 6.27665 14.4344 4.62441 13.2158 3.40582C11.9972 2.18722 10.3449 1.50182 8.62158 1.5ZM9.12158 2.52312C9.46008 2.55401 9.7949 2.61679 10.1216 2.71062V13.2919C9.7949 13.3857 9.46008 13.4485 9.12158 13.4794V2.52312ZM11.1216 3.10188C11.4779 3.28433 11.8133 3.50522 12.1216 3.76062V12.2394C11.8133 12.4948 11.4779 12.7157 11.1216 12.8981V3.10188ZM3.12158 8C3.12323 6.62838 3.6367 5.30674 4.56148 4.29376C5.48626 3.28078 6.75578 2.64937 8.12158 2.52312V13.4769C6.75578 13.3506 5.48626 12.7192 4.56148 11.7062C3.6367 10.6933 3.12323 9.37162 3.12158 8ZM13.1216 11.1587V4.84125C13.7723 5.76602 14.1216 6.86921 14.1216 8C14.1216 9.13079 13.7723 10.234 13.1216 11.1587Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Flame(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_836_857)">
        <path
          d="M12.1147 9.58376C11.9851 10.3079 11.6366 10.975 11.1164 11.4952C10.5961 12.0154 9.92893 12.3636 9.20471 12.4931C9.17721 12.4975 9.14943 12.4998 9.12158 12.5C8.99616 12.5 8.87533 12.4528 8.78306 12.3679C8.69079 12.2829 8.63381 12.1664 8.62343 12.0414C8.61305 11.9164 8.65001 11.7921 8.72701 11.6931C8.804 11.5941 8.91539 11.5276 9.03908 11.5069C10.0747 11.3325 10.9535 10.4538 11.1291 9.41626C11.1513 9.28547 11.2246 9.16887 11.3327 9.09209C11.4409 9.01532 11.5752 8.98467 11.706 9.00688C11.8367 9.02909 11.9533 9.10235 12.0301 9.21053C12.1069 9.31872 12.1375 9.45297 12.1153 9.58376H12.1147ZM14.1216 9.00001C14.1216 10.4587 13.5421 11.8576 12.5107 12.8891C11.4792 13.9205 10.0803 14.5 8.62158 14.5C7.16289 14.5 5.76394 13.9205 4.73249 12.8891C3.70104 11.8576 3.12158 10.4587 3.12158 9.00001C3.12158 7.25501 3.80908 5.47063 5.16283 3.69688C5.20568 3.64072 5.25995 3.59427 5.32206 3.5606C5.38416 3.52693 5.4527 3.50681 5.52315 3.50155C5.5936 3.4963 5.66436 3.50603 5.73077 3.53011C5.79719 3.55419 5.85775 3.59207 5.90846 3.64126L7.41596 5.10438L8.79096 1.32876C8.81843 1.25345 8.8636 1.18586 8.92267 1.13167C8.98173 1.07748 9.05296 1.03829 9.13035 1.01739C9.20774 0.996497 9.28901 0.994516 9.36733 1.01161C9.44564 1.02871 9.51869 1.06439 9.58033 1.11563C10.9472 2.25001 14.1216 5.28438 14.1216 9.00001ZM13.1216 9.00001C13.1216 6.11938 10.8847 3.63001 9.48346 2.35438L8.09158 6.17126C8.06301 6.24965 8.01528 6.31965 7.95274 6.37487C7.89019 6.4301 7.81482 6.46879 7.7335 6.48743C7.65217 6.50607 7.56747 6.50406 7.48712 6.48159C7.40676 6.45911 7.33331 6.41688 7.27346 6.35876L5.62533 4.76001C4.62721 6.20063 4.12158 7.62501 4.12158 9.00001C4.12158 10.1935 4.59569 11.3381 5.4396 12.182C6.28351 13.0259 7.42811 13.5 8.62158 13.5C9.81506 13.5 10.9596 13.0259 11.8036 12.182C12.6475 11.3381 13.1216 10.1935 13.1216 9.00001Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_836_857">
          <rect width="16" height="16" fill="white" transform="translate(0.621582)" />
        </clipPath>
      </defs>
    </svg>
  );
}
